<template>
  <div style="width:100vw;height:100vh;font-family:PingFang SC;user-select:none;">
    <div class="head">
      <div class="head-title" :class="{ 'head-title-listening': voiceKeepListening || voiceListening || voiceStarting }"
        :title="voiceKeepListening || voiceListening || voiceStarting ? '点击停止语音监听' : '点击开始语音控制'"
        @click="toggleVoiceRecognition">
        <img src="../../static/img/logo.png" class="head-logo" />
        <span class="head-title-text">景区旅游大数据中心</span>
        <span class="head-title-voice-tag"
          :class="{ 'head-title-voice-tag-active': voiceKeepListening || voiceListening || voiceStarting }">
          {{ voiceKeepListening || voiceListening || voiceStarting ? '停止' : '语音' }}
        </span>
        <transition name="voice-status-fade">
          <div v-if="voiceStatusVisible" class="voice-status-box" :class="'voice-status-' + voiceStatusTone">
            <span class="voice-status-dot"></span>
            <span class="voice-status-text">{{ voiceStatusText }}</span>
          </div>
        </transition>
      </div>
      <div class="head-type">
        <div class="type-item" v-for="item in type_item" :key="item.value"
          :class="{ 'type-item2': item.value == typeIndex }" @click="typeChange(item.value)">
          {{ item.label }}
          <div class="type-on" v-if="item.value == typeIndex"></div>
        </div>
      </div>
      <div>
        <div class="date-weather">
          <div class="changeDateOne" @click="changeTheDate(-1)">前一天</div>
          <div class="changeDateOne" @click="changeTheDate(0)">今&nbsp;&nbsp;天</div>
          <div class="changeDateOne" @click="changeTheDate(1)">后一天</div>
          <img @click="getWeatherData(1)" src="../../static/img/refresh-ccw.png" style="
              display: inline-block;
              width: 14px;
              height: 14px;
              vertical-align: middle;
              transform: translate(0, -2px);
              cursor: pointer;
            " v-if="isToday" />
          {{ isToday ? nowDay : req_date.replace('-', '/') }} {{ isToday ? week : changeWeek }} {{ isToday ? nowTime :
            '' }}
          <!-- <span v-if="isToday"> 暂时隐藏天气
            <span style="margin: 0 6px; color: rgba(255, 255, 255, 0.5)">|</span>
            {{weather.temperature}}ºC
            <img
              src="../../static/img/water.png"
              style="
                display: inline-block;
                width: 14px;
                height: 14px;
                vertical-align: middle;
                transform: translate(0, -2px);
              "
            />
            {{weather.humidity}}%
            <img
              src="../../static/img/Vector.png"
              style="
                display: inline-block;
                width: 12px;
                height: 10px;
                vertical-align: middle;
                transform: translate(0, -2px);
              "
            />
            {{weather.winddirection}}{{weather.windpower}}
          </span> -->

        </div>
      </div>
    </div>

    <div class="main" id="bodys">
      <ScenicWarning ref="embeddedWarning" v-if="typeIndex == 4" :embedded="true" />
      <SentimentSurveillance ref="SentimentSurveillance" v-if="typeIndex == 9" :embedded="true" />
      <videoSurveillance ref="videoSurveillance" v-if="typeIndex == 10" :embedded="true" />
      <System ref="system" v-if="typeIndex == 11" :embedded="true" />

      <div v-if="warningPushBoardVisible && typeIndex != 5 && typeIndex != 8" class="warning-push-board">
        <div class="warning-push-icon">!</div>
        <div class="warning-push-text">婺源篁岭景区客流量持续走高，请安排人员加强重点区域疏导</div>
        <button class="warning-push-button" @click="closeWarningPushBoard">告警推送</button>
      </div>
      <div id="migrateMap" class="migrateMap" :style="{ 'height': bodyHeight + 'px' }"
        v-show="typeIndex == 0 || typeIndex == 1 || typeIndex == 2 || typeIndex == 5 || typeIndex == 6 || typeIndex == 7 || typeIndex == 8">
      </div>
      <div v-if="(typeIndex == 0 || typeIndex == 1 || typeIndex == 2) && currentWarningItem"
        class="scenic-warning-board">
        <div class="scenic-warning-icon">!</div>
        <div class="scenic-warning-content">
          <transition name="warning-slide" mode="out-in">
            <div :key="warningCurrentIndex + '-' + currentWarningItem.title" class="scenic-warning-item">
              <span class="scenic-warning-title">{{ currentWarningItem.title }}</span>
              <span class="scenic-warning-text">{{ currentWarningItem.text }}</span>
            </div>
          </transition>
        </div>
      </div>
      <!-- <div class="centenrBox centenr-echart" v-show="typeIndex == 2">
        
        <div class="all_or_shop">
          <div class="all_or_shop_btn" :class="{ 'all_or_shop_on': allShopIndex === 1 }" style="margin-right: 48px;"
            @click="changeAllShop(1)">总营收</div>
          <div class="all_or_shop_btn" :class="{ 'all_or_shop_on': allShopIndex === 2 }" @click="changeAllShop(2)">商户明细
          </div>
        </div>
        
        <div v-show="allShopIndex === 2" class="shop-charts-btn">
          <div id="shopRank" v-show="merchant_order_total_list.length <= 40" class="shop-charts-01"></div>
          <div id="shopRank_1" v-show="merchant_order_total_list.length > 40" class="shop-charts-02"></div>
          <div v-show="merchant_order_total_list.length > 40" id="shopRank_2" class="shop-charts-02"
            style="margin-left: 48px;"></div>
        </div>
      </div> -->
      <div v-show="typeIndex == 0" class="main_type">
        <div class="center-top-num ">
          <div class="left-top-title center-big-title">
            <span>今日全县客流总量</span>
          </div>
          <div class="today-sum-one">
            <div class="year-sum-big" style="line-height:96px">
              <div class="center-icon">,</div>
              <div v-for="(item, index) in dateSum" :key="index" class="sum-one-big">
                <!-- <span>{{item}}</span> -->
                <CountFlop :val="item" />

              </div>
            </div>
          </div>
        </div>
        <div class="main-left">
          <div class="heat-address">
            客源地
            <img style="margin-left:4px;width:1px;height:12px;" src="../../static/img/Rectangle 234.png">
            <img style="width:23px;height:23px;" src="../../static/img/chevron_down.png">
          </div>
          <div class="left-top  data-box" style="height:432px">
            <div class="left-top-main">
              <div class="left-top-title flex ">
                <span style="margin-right:14px;font-weight:600;font-size:20px">全县全域游客总量</span>
                <span style="font-weight:400;font-size:14px">{{ isToday ? nowDay.slice(0, 4) : req_date.slice(0, 4)
                }}年</span>
                <img v-if="!isYearSumShow" style="width: 35px;height: 22px;margin-left: 30px;"
                  src="../../static/img/bg-display.png" alt="" @click="isDataShow(false)">
                <img v-if="isYearSumShow" style="width: 30px;height: 20px;margin-left: 30px;"
                  src="../../static/img/bg-hide.png" alt="" @click="isDataShow(true)">
              </div>
              <div style="margin-right:14px;margin-top:14px;font-weight:400;font-size:16px">全年游客总量</div>
              <div class="year-sum-box">

                <div class="year-sum">
                  <div v-for="(item, index) in yearSum" :key="index" class="sum-one">
                    <span v-if="isYearSumShow">{{ item }}</span>
                    <span v-if="!isYearSumShow">*</span>
                  </div>

                </div>
              </div>

              <div style="margin-top:10px;display:inline-block;text-align:center">
                <img src="../../static/img/rectangle.png" style="width:283px;height:2px">
              </div>
              <div class="today-sum">
                <div class="today-one">
                  <!-- <div class="today-one-title">本月县域旅游总量</div>
                  <div style="position:relative;width:100%;text-align:left;">
                    <div class="today-one-sum">
                      <div class="today-one-sum-box">
                        <div v-for="(item, index) in dateInSum" :key="index" class="today-one-num">
                          {{ item }}
                        </div>
                      </div>

                      <img src="../../static/img/rectangle-vertical.png"
                        style="position: absolute;width:1px;height:32px;top:50%;transform: translate(0,-50%);right:-0.5px">
                    </div>
                  </div> -->
                  <div class="last-num">
                    <div style="margin:12px 0 13px;">
                      <span class="title-small">全县游客年同比</span>
                      <!-- <span class="number-small">{{ realTourists_data.year?realTourists_data.year.county_total_growth:0 }}%</span> -->
                      <span class="number-small">4.6%</span>
                    </div>
                    <div>
                      <span class="title-small">景区游客年同比</span>
                      <span class="number-small">6.6%</span>
                      <!-- <span v-if="!isYearSumShow" class="number-small">****</span> -->

                    </div>
                  </div>
                </div>
                <div class="today-one">
                  <!-- <div class="today-one-title">今日出园游客总量</div>
                  <div style="position:relative;width:100%;text-align:right;">
                    <div class="today-one-sum">
                      <div class="today-one-sum-box">
                        <div v-for="(item, index) in dateOutSum" :key="index" class="today-one-num">
                          {{ item }}
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <div class="last-num" style="padding-left:15px">
                    <div style="margin:12px 0 13px;">
                      <span class="title-small">月同比</span>
                      <span class="number-small">4.9%</span>
                      <!-- <span v-if="!isYearSumShow" class="number-small">****</span> -->
                    </div>
                    <div>
                      <span class="title-small">月同比</span>
                      <span class="number-small">7.8%</span>
                      <!-- <span v-if="!isYearSumShow" class="number-small">****</span> -->
                    </div>
                  </div>
                </div>
              </div>
              <div style="margin-top:10px;display:inline-block;text-align:center">
                <img src="../../static/img/rectangle.png" style="width:283px;height:2px">
              </div>
              <div style="margin-right:14px;margin-top:14px;font-weight:400;font-size:16px">全年车次总量</div>
              <div class="year-sum-box">

                <div class="year-sum">
                  <div v-for="(item, index) in carSum" :key="index" class="sum-one">
                    <span v-if="isYearSumShow">{{ item }}</span>
                    <span v-if="!isYearSumShow">*</span>
                  </div>
                </div>
              </div>
              <div style="margin-top:10px;display:inline-block;text-align:center">
                <img src="../../static/img/rectangle.png" style="width:283px;height:2px">
              </div>
              <div class="today-sum">
                <div class="today-one">
                  <div class="last-num">
                    <div>
                      <span class="title-small" style="margin:12px 0 13px;">入境车次年同比</span>
                      <span class="number-small">3.6%</span>
                    </div>
                  </div>
                </div>
                <div class="today-one">
                  <div class="last-num" style="padding-left:15px">
                    <div>
                      <span class="title-small" style="margin:12px 0 13px;">月同比</span>
                      <span class="number-small">3.7%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="left-bottom data-box" style="height: 240px;">
            <div class="right-title" style="margin-right:14px;font-weight:600;font-size:24px">消费系数分析</div>
            <div class="right-title" style="padding:0 10px 10px">
              <div class="title-price">
                <span style="width: 100px;text-align: right;display: inline-block;">文旅消费总量</span>
                <span class="num-price">{{ realTourists_data.year ? (realTourists_data.year.county_total *
                  85.3).toFixed(2) : 0 }}</span>
              </div>
              <div class="title-price">
                <span style="width: 100px;text-align: right;display: inline-block;">年同比</span>
                <span class="num-price">+20.23%</span>
              </div>
              <div class="title-price">
                <span style="width: 100px;text-align: right;display: inline-block;">人均消费</span>
                <span class="num-price">85.30</span>
              </div>
              <div class="title-price">
                <span style="width: 100px;text-align: right;display: inline-block;">年同比</span>
                <span class="num-price">+20.53%</span>
              </div>
            </div>
            <div></div>
          </div>
          <div class="right-center data-box">
            <div class="left-bottom-title">文旅消费分析</div>
            <div class="gender" style="height:200px;">
              <div class="ota_pie_box">
                <div id="ota_pie" class="ota_pie"></div>
                <div class="ota_pie_list">
                  <div><span class="pie-dot" style="background-color: #63a8ea;"></span>餐饮：20.18%</div>
                  <div><span class="pie-dot" style="background-color: #ea8186;"></span>住宿：17.52%</div>
                  <div><span class="pie-dot" style="background-color: #e9c16d;"></span>游玩：26.51%</div>
                  <div><span class="pie-dot" style="background-color: #8c63ea;"></span>交通：31.16%</div>
                  <div><span class="pie-dot" style="background-color: #049f09;"></span>购物：3.59%</div>
                  <div><span class="pie-dot" style="background-color: #500509;"></span>其他：1.03%</div>
                </div>
              </div>
              <!-- <div id="travelPerson" class="travel-person"></div> -->
            </div>
            <!-- <div id="peakLine" class="touristLine"></div> -->
          </div>

        </div>
        <div class="main-center">
          <div class="charts">
            <div class="inOrOut data-box" style="width: 600px">
              <div class="right-title">
                客流过去30天走势
                <div class="right-datetiem">
                  周
                  <img style="margin-left:4px;width:1px;height:9px;" src="../../static/img/Rectangle 234.png">
                  <img style="width:18px;height:18px;" src="../../static/img/chevron_down.png">
                </div>
              </div>
              <div id="touristLine" class="touristLine" style="width:560px"></div>
            </div>
            <div class="inOrOut data-box">
              <div class="right-title" style="padding:11px">游客进出园时间分析</div>
              <div id="inOrOut" class="inOrOut-chart"></div>
            </div>
          </div>
        </div>
        <div class="main-right">
          <div class="right-top data-box" style="height: 300px;">
            <div class="left-bottom-title">
              层级下钻
            </div>
          </div>
          <div class="right-top data-box" style="height: 240px;margin-top: 15px;">
            <div class="left-bottom-title">游客停留时长</div>
            <div id="time_1" class="gender-column" style="width: 320px;height:200px;"></div>
          </div>
          <div class="left-center data-box" style="height: 400px;">
            <div class="right-title" style="font-weight: 600;padding:10px 10px 5px;">游客画像分析</div>
            <div class="right-title" style="padding:10px">
              <div class="right-title-1">客源地统计</div>
              <div class="right-datetiem" style="top:5px">
                日
                <img style="margin-left:4px;width:1px;height:9px;" src="../../static/img/Rectangle 234.png">
                <img style="width:18px;height:18px;" src="../../static/img/chevron_down.png">
              </div>
              <div class="addressList">
                <div v-for="(item, index) in origin_list_dict.o_address_list" :key="index" class="addressListOne">
                  {{ item.slice(0, 2) }}</div>
                <div class="addressBar" id="addressBar_1"></div>
              </div>
            </div>
            <div id="address_1" class="address"></div>
            <div class="right-title-1" style="padding:20px 10px 10px">游客性别及时间安排</div>
            <div class="gender">
              <div class="a-gender">
                <img src="../../static/img/man.png">
                <div class="gender-content" style="margin-top:8px">男</div>
                <div class="gender-content" style="margin-top:5px">{{ this.gender.male ? this.gender.male.ratio : 0 }}</div>
              </div>
              <div class="a-gender">
                <img src="../../static/img/woman.png">
                <div class="gender-content" style="margin-top:8px">女</div>
                <div class="gender-content" style="margin-top:5px">{{ this.gender.female ? this.gender.female.ratio : 0 }}
                </div>
              </div>
              <div id="gender_1" class="gender-column"></div>
            </div>
          </div>

          <!-- <div class="right-bottom data-box">
            <div class="right-title">
              三天待入园人数
            </div>
            <div>
              <div id="waitInPart" class="travel-person" style="height: 230px;width: 180px;display:inline-block"></div>
              <div class="three-day">
                <div style="margin-bottom:10px;font-size:15px">
                  待入园渠道分析
                </div>
                <div v-for="(item, index) in three_show" :key="index" style="margin-bottom:6px">
                  {{ item.text }}
                </div>

                <div style="width: 128px;height: 128px;margin-left:-10px" id="three_pie"></div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div v-show="typeIndex == 1" class="main_type">
        <div class="main-left">
          <div class="right-top data-box" style="height: 320px;margin-top:18px;">
            <div class="right-title" style="padding-bottom: 0;font-size: 18px;">今日全县及各景区客流总量</div>
            <div class="right-title" style="padding-top: 0;">
              <div class="title-price" style="font-size: 15px;">
                全县游客总量
                <span class="num-price">{{ county_total_value }}</span>
                <div class="title-price-tong">同比+4.54%</div>
              </div>
              <div id="touristType_1" class="touristType" style="height: 250px;width: 300px;"></div>
            </div>
          </div>
          <div class="right-center data-box">
            <div class="right-title">
              客流峰值分析
            </div>
            <div id="peakLine" class="touristLine"></div>
          </div>
          <div class="left-bottom data-box" style="height: 320px;">
            <div class="right-title" style="padding-bottom: 0;font-size: 18px;">游客接待排行</div>
            <div class="right-title" style="padding-top: 0;">
              <div class="title-price" style="font-size: 15px;">
                全县游客总量
                <span class="num-price">{{ county_total_value }}</span>
              </div>
              <div id="scenic_ranking_list_1" class="travel-person" style="width: 300px;height:240px;"></div>
            </div>
          </div>
          <!--
          <div class="cityCome data-box" style="margin-top:36px">
            <div class="right-title" style="text-align:center">
              <div class="city-btn" @click="drawOldCome(1)" :class="{'onOldCome': oldComeIndex == 1}">老年</div>
              <div class="city-btn" @click="drawOldCome(2)" :class="{'onOldCome': oldComeIndex == 2}">中年</div>
              <div class="city-btn" @click="drawOldCome(3)" :class="{'onOldCome': oldComeIndex == 3}">青少</div>
              <div class="city-btn" @click="drawOldCome(4)" :class="{'onOldCome': oldComeIndex == 4}">亲子</div>
              <div class="city-btn" @click="drawOldCome(5)" :class="{'onOldCome': oldComeIndex == 5}">均衡</div>
            </div>
            <div style="padding:0 22px;font-size:16px">{{oldComeName}}客源市场(占比)TOP10</div>
            <div id="oldCome" class="cityCome-chart" style="height: 234px;"></div>
          </div> -->
        </div>
        <div class="main-right" style="width:360px">
          <div class="cityCome data-box" style="height: 200px;">
            <div class="right-title" style="padding:11px">客流过去30天走势</div>
            <div id="touristLine_1" class="inTime-chart"></div>
          </div>
          <div class="cityCome data-box" style="height: 200px;margin-top:18px">
            <div class="right-title" style="padding:11px">游客构成分析</div>
            <div id="inTime" class="inTime-chart"></div>
          </div>
          <div class="cityCome data-box" style="margin-top:18px;height: 240px;">
            <div class="right-title">
              客源地统计
              <div class="right-datetiem">
                日
                <img style="margin-left:4px;width:1px;height:9px;" src="../../static/img/Rectangle 234.png">
                <img style="width:18px;height:18px;" src="../../static/img/chevron_down.png">
              </div>
              <div class="addressList_2">
                <div v-for="(item, index) in origin_list_dict.o_address_list" :key="index" class="addressListOne_2">
                  {{ item.slice(0, 2) }}</div>
                <div class="addressBar_2" id="addressBar_2"></div>
              </div>
            </div>
            <div id="address_2" class="address_2"></div>
          </div>
          <div class="cityCome data-box" style="margin-top:18px;height: 240px;">
            <div class="right-title" style="padding-bottom:0">
              城市客源年龄结构分析
              <input type="text" class="cityInput" v-model="city_name">
              <div class="city-btn" @click="getCityCome()">查询</div>
            </div>
            <div style="padding:0 22px;font-size:16px;">{{ now_city_name }}</div>
            <div id="cityCome" class="cityCome-chart"></div>
          </div>
        </div>

      </div>
      <div v-show="typeIndex == 2" class="main_type map-pass-through">
        <div class="click-box" @click="openDefaultMonitorVideo">
          <div class="scroll-text-box">
            <div class="scroll-text-content">
              <span><span style="color: red;">当前监控：</span>篁岭景区[游客中心]出现拥堵情况，请尽快疏导</span>
              <span><span style="color: red;">当前监控：</span>篁岭景区[晒秋平台]出现拥堵情况，请尽快疏导</span>
            </div>
          </div>
        </div>
        <div class="resource-panel">
          <div class="resource-panel-title">文旅资源概况</div>
          <div class="resource-item" :class="{ active: isResourceItemActive(item) }" v-for="item in this_list"
            :key="item.key || item.name" @click="handleResourceItemClick(item)">
            <span class="resource-label">{{ item.name }}</span>
            <span class="resource-count">({{ item.value }})</span>
          </div>
        </div>
        <div class="main-left" style="width: 360px;">
          <div class="data-box" style="height: 233px;">
            <div class="right-title">重点景区实时客流量（入园人数）</div>
            <div id="in_ranking_list" class="travel-person" style="width: 320px;height:180px;vertical-align: top;">
            </div>
          </div>
          <div class="inOrOut data-box" style="width: 360px;margin-top: 18px;height: 278px;">
            <div class="right-title">景区实时客流排名榜单（在园人数）</div>
            <div id="on_ranking_list" class="travel-person" style="width: 320px;height:180px;vertical-align: top;">
            </div>
          </div>
          <div class="inOrOut data-box" style="width: 360px;margin-top: 18px;height: 280px;">
            <div class="right-title">
              景区实时客流走势
            </div>
            <div id="peakLine_2" class="touristLine" style="width:320px"></div>
          </div>
        </div>
        <div class="main-right" style="width: 360px;">
          <div class="data-box" style="height: 233px;">
            <div class="right-title">重点景区未来一小时客流预测</div>
            <div id="hourScenic" class="touristLine" style="height: 180px;width: 320px;"></div>
          </div>
          <div class="data-box" style="width: 360px;margin-top: 18px;height: 278px;">
            <div class="right-title">一小时后道路拥堵情况预测</div>
            <!-- 表格 -->
            <div class="table-container">
              <div class="table-header">
                <div class="th">市场路段</div>
                <div class="th">进口车流量</div>
                <div class="th">拥堵率</div>
                <div class="th">出口车流量</div>
                <div class="th">拥堵率</div>
              </div>

              <div class="table-body">
                <div v-for="(item, index) in tableData" :key="index" class="table-row"
                  :class="{ 'even': index % 2 === 0 }">
                  <div class="td road-name">{{ item.road }}</div>
                  <div class="td">{{ item.inFlow }}</div>
                  <div class="td">
                    <span class="rate-text" :class="getRateClass(item.inRate)">
                      {{ item.inRate }}%
                    </span>
                  </div>
                  <div class="td">{{ item.outFlow }}</div>
                  <div class="td">
                    <span class="rate-text" :class="getRateClass(item.outRate)">
                      {{ item.outRate }}%
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right-top data-box" style="height: 280px;margin-top: 18px;">
            <div class="right-title">明日易拥堵场所预测分析</div>
            <!-- 表格 -->
            <div class="table-container">
              <div class="table-header">
                <div class="th">易拥堵场所</div>
                <div class="th">客流量</div>
                <div class="th">饱和度</div>
              </div>
              <div class="table-body">
                <div v-for="(item, index) in tableData_1" :key="index" class="table-row"
                  :class="{ 'even': index % 2 === 0 }">
                  <div class="td road-name">{{ item.road }}</div>
                  <div class="td">{{ item.inFlow }}</div>
                  <div class="td">
                    <span class="rate-text" :class="getRateClass(item.inRate)">
                      {{ item.inRate }}%
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="inOrOut data-box" style="width: 360px;margin-top: 18px;height: 248px;">

          </div> -->

        </div>
      </div>
      <div v-show="typeIndex == 5" class="business-resource-page map-pass-through">
        <div class="business-alert">
          <span class="business-alert-icon">!</span>
          <span><em>弦高景区</em>客流量接近饱和上限，请安排人员进行疏导</span>
        </div>
        <div class="business-left-panel">
          <div class="business-saturation-card data-box" v-for="item in businessSaturationList" :key="item.title">
            <div class="business-card-head">
              <div class="business-card-title">{{ item.title }}</div>
              <button class="business-period-filter">
                {{ item.period }}
                <span></span>
              </button>
            </div>
            <div class="business-bar-chart">
              <div class="business-chart-row" v-for="bar in item.ranking" :key="item.title + '-' + bar.name">
                <span class="business-chart-label">{{ bar.name }}</span>
                <div class="business-chart-track">
                  <i :class="{ 'is-danger': bar.value >= 85, 'is-warning': bar.value >= 70 && bar.value < 85 }"
                    :style="{ width: bar.value + '%' }"></i>
                </div>
                <strong :class="{ 'is-danger': bar.value >= 85, 'is-warning': bar.value >= 70 && bar.value < 85 }">
                  {{ bar.value }}%
                </strong>
              </div>
              <div class="business-chart-axis">
                <span v-for="axis in item.axis" :key="item.title + '-' + axis">{{ axis }}</span>
              </div>
            </div>
            <div class="business-advice-box">
              <div class="business-advice-title">优化建议</div>
              <p v-for="text in item.advice" :key="item.title + '-' + text">{{ text }}</p>
            </div>
          </div>
        </div>
        <div v-if="businessResourceList.length" class="business-resource-menu">
          <div class="business-resource-menu-title">业态资源概况</div>
          <div
            class="business-resource-item"
            :class="{ active: isBusinessResourceSelected(item) }"
            v-for="item in businessResourceList"
            :key="item.key || item.name"
            @click="handleResourceItemClick(item)"
          >
            <img v-if="item.icon" class="business-resource-icon-img" :src="item.icon" :alt="item.name">
            <span v-else class="business-resource-icon"></span>
            <span class="business-resource-name">{{ item.name }}</span>
            <span class="business-resource-count">({{ item.value }})</span>
          </div>
        </div>
        <div class="business-right-panel">
          <div class="business-tool-card data-box">
            <div class="business-card-title">地图绘制工具</div>
            <div class="business-tool-body">
              <div class="business-drawing-status" :class="{ active: isBusinessFenceDrawing }">
                <div>{{ businessDrawingStatusText }}</div>
                <span>已选点位：{{ businessFencePoints.length }}</span>
                <span>{{ businessFencePoints.length >= 3 ? '可继续添加点位扩展区域' : '至少 3 个点形成区域面，不限点数' }}</span>
              </div>
              <div class="business-tool-actions">
                <button v-for="item in drawingToolActions" :key="item.action"
                  :class="{ active: businessDrawingToolActive(item.action) }"
                  :disabled="businessDrawingToolDisabled(item.action)" @click="handleDrawingToolAction(item.action)">
                  {{ item.label }}
                </button>
              </div>
            </div>
          </div>
          <div class="business-stat-card data-box">
            <div class="business-card-title">绘制区域数据统计</div>
            <div class="business-stat-table">
              <div class="business-stat-head">
                <span>业态</span>
                <span>数量</span>
                <span>负荷</span>
                <span>接待能力</span>
              </div>
              <div class="business-stat-row" v-for="item in businessAreaStats" :key="item.type">
                <span>{{ item.type }}</span>
                <span>{{ item.count }}</span>
                <span :class="'business-load-' + item.loadType">{{ item.load }}</span>
                <span :class="'business-load-' + item.loadType">{{ item.capacity }}</span>
              </div>
            </div>
            <div class="business-passenger-box">
              <div class="business-passenger-title">客流量</div>
              <div class="business-passenger-meta">
                <span>在园人数：{{ businessPassengerSummary.online }}</span>
                <span>饱和度：{{ businessPassengerSummary.saturation }}%</span>
              </div>
              <div class="business-rank-row" v-for="(item, index) in businessFlowRanking"
                :key="item.name + '-' + index">
                <span>{{ index + 1 }}</span>
                <strong>{{ item.name }} - {{ item.percent }}%</strong>
                <i :style="{ width: item.percent + '%' }"></i>
              </div>
            </div>
            <div class="business-suggestion">
              <div class="business-advice-title">优化建议</div>
              <p v-for="text in businessDiversionAdvice" :key="text">{{ text }}</p>
            </div>
          </div>
          <div class="business-fence-card data-box">
            <div class="business-card-title">电子围栏</div>
            <div class="business-fence-list">
              <button v-for="item in businessFenceList" :key="item.name" :class="{ active: item.active }">
                {{ item.name }}
                <span v-if="item.deletable" class="business-delete-icon"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-show="typeIndex == 3" class="sentiment-box">
        <div class="sentiment-left" style="width: 400px;">
          <div class="inOrOut data-box sentiment-stream-card" style="width: 400px;height: 300px;padding: 15px;">
            <div class="right-title">监控流 0000000003</div>
            <div class="sentiment-stream-body">
              <video ref="sentimentVideoOne" class="sentiment-stream-video" controls autoplay muted playsinline></video>
            </div>
          </div>
          <div class="inOrOut data-box sentiment-stream-card"
            style="width: 400px;margin-top: 80px;height: 300px;padding: 15px;">
            <div class="right-title">监控流 0000000005</div>
            <div class="sentiment-stream-body">
              <video ref="sentimentVideoTwo" class="sentiment-stream-video" controls autoplay muted playsinline></video>
            </div>
          </div>
        </div>
        <div class="sentiment-body">
          <div class="body-left  data-box">
            <div class="body-title">
              舆情动态
            </div>
            <div class="list-box">
              <div v-for="(item, index) in tendenciesList" :key="index">
                <div class="list-item" @click="handleDetail(item)">
                  <div class="item-header">
                    <div class="avatar">
                      <img v-if="item.userHead" :src="item.userHead"></img>
                      <div v-else style="background-color: #fff;"></div>
                    </div>
                    <div class="header-content">
                      <div class="header-content-left">
                        <div class="title">{{ item.nickName || item.userName || item.websiteName }}</div>
                        <div class="content">
                          <span>{{ item.createAt }}</span>
                          <span style="margin-left: 5px;">{{ `- 来源:${item.websiteName || '未知'}` }}</span>
                          <span style="margin-left: 5px;">{{ `- IP:${item.ipLocation || '未知'}` }}</span>
                        </div>
                      </div>
                      <div class="header-content-right" @click.stop="toUrl(item.url)">原帖<i
                          class="el-icon-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                  <div class="item-tap" style="padding: 0 13px;">
                    <div style="width: 34px;">标签: </div>
                    <div class="tap-list">
                      <div class="tap" v-for="(tap, index) in taps(item.region)" :key="tap">#{{ tap }}</div>
                    </div>
                  </div>
                  <div class="item-body">
                    <div class="body-text" v-html="highlightText(strictClean(item.content), item.matchKeywords)">
                    </div>
                    <div class="body-images">
                      <div class="images-list" ref="imagesList">
                        <div class="prev" @click.stop="prevImage(index)"
                          v-if="actIndex > 0 && imageList(item.imageUrl).length > 3"><i class="el-icon-arrow-left"></i>
                        </div>
                        <div class="next" @click.stop="nextImage(index)"
                          v-if="actIndex < (imageList(item.imageUrl).length - 3) && imageList(item.imageUrl).length > 3">
                          <i class="el-icon-arrow-right"></i>
                        </div>
                        <div v-if="imageList(item.imageUrl).length > 3" class="img-total">{{ `(${actIndex +
                          1}-${actIndex +
                          3})
                          / ${imageList(item.imageUrl).length}` }}</div>
                        <img referrerPolicy="no-referrer" v-for="(url, index) in imageList(item.imageUrl)" :src="url"
                          :key="index">
                      </div>
                    </div>
                  </div>
                  <div class="item-footer">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-left: 10px;" class="body-right data-box" v-if="isDetail">
            <div class="body-title">
              舆情详情
              <span style="float: right;margin-right: 10px;cursor: pointer;" @click="isDetail = !isDetail">X</span>
            </div>
            <div class="box-right list-item" v-if="tendenciesItem.antduId">
              <div class="right-header">
                <div class="item-header">
                  <div class="avatar">
                    <img v-if="tendenciesItem.userHead" :src="tendenciesItem.userHead"></img>
                    <img v-else style="background-color: #fff;"></img>
                  </div>
                  <div class="header-content">
                    <div class="header-content-left">
                      <div class="title">{{ tendenciesItem.nickName || tendenciesItem.userName ||
                        tendenciesItem.websiteName }}</div>
                      <div class="content">
                        <span>{{ tendenciesItem.createAt }}</span>
                        <span style="margin-left: 5px;">{{ tendenciesItem.websiteName ? `-
                          ${tendenciesItem.websiteName}` :
                          ''
                        }}</span>
                        <span style="margin-left: 5px;">{{ `- IP:${tendenciesItem.ipLocation || '未知'}` }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-body item-body">
                <div class="item-tap">
                  <div style="width: 30px;">标签: </div>
                  <div class="tap-list">
                    <div class="tap" v-for="(tap, index) in taps(tendenciesItem.region)" :key="tap">#{{ tap }}</div>
                  </div>
                </div>
                <div class="right-body-text"
                  v-html="highlightText(imgText(tendenciesItem.content), tendenciesItem.matchKeywords)"></div>
                <div class="right-body-images" v-if="isImg(tendenciesItem.content)">
                  <img referrerPolicy="no-referrer" v-for="(url, index) in imageList(tendenciesItem.imageUrl)"
                    :src="url" :key="index">
                </div>
              </div>
              <div class="item-footer">
              </div>
            </div>
          </div>
          <div style="margin-left: 10px;" class="body-right data-box" v-if="!isDetail">
            <div class="body-title">
              舆情列表
            </div>
            <div class="timeline">
              <div v-for="(value, key, i) in timelineList" :key="key">
                <div class="timeline-date">
                  <div class="date-span">
                    <div class="date-item1"></div>
                  </div>
                  <div class="date">{{ key }}</div>
                </div>
                <div v-for="(item, index) in value" :key="index" class="timeline-item">
                  <div class="timeline-content" style="width:100%">
                    <div class="timeline-span">
                      <div class="span-item1"></div>
                    </div>
                    <div class="timeline-time">{{ item.time }}</div>
                    <div class="timeline-text" @click="toUrl(item.url)">
                      <span style="color: #d6a450;" v-if="item.emotionStr === '负面'">(疑似负面)</span>
                      <span style="color: red;" v-if="item.emotionStr === '差评'">(负面)</span>
                      <span v-html="highlightText(item.title, item.matchKeywords)" style="margin-right: 10px;"></span>
                      <span style="font-size: 14px;color: #b2b2b2;"
                        v-html="highlightText(strictClean(item.content), item.matchKeywords)"></span>
                    </div>
                    <div class="timeline-website">
                      {{ item.websiteName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sentiment-right" style="width: 400px;">
          <div ref="emotion" class="right-top data-box" style="width: 400px;padding: 15px;height: 300px;">

          </div>
          <div ref="hotWeb" class="right-top data-box"
            style="width: 400px;padding: 15px;height: 300px;margin-top: 80px;">

          </div>
        </div>
      </div>
      <div v-show="typeIndex == 6" class="main_type">
        <div class="main-left">
          <div class="cityCome data-box" style="height: 268px;margin-top:18px">
            <div class="right-title" style="padding:11px">游客构成分析</div>
            <div id="inTime_5" class="inTime-chart" style="height: 240px;padding-top: 18px;"></div>
          </div>
          <div class="cityCome data-box" style="margin-top:18px;height: 268px;">
            <div class="right-title">
              客源地统计
              <div class="right-datetiem">
                日
                <img style="margin-left:4px;width:1px;height:9px;" src="../../static/img/Rectangle 234.png">
                <img style="width:18px;height:18px;" src="../../static/img/chevron_down.png">
              </div>
              <div class="addressList_2">
                <div v-for="(item, index) in origin_list_dict.o_address_list" :key="index" class="addressListOne_2">
                  {{ item.slice(0, 2) }}</div>
                <div class="addressBar_2" id="addressBar_5"></div>
              </div>
            </div>
            <div id="address_5" class="address_2"></div>
          </div>
          <div class="cityCome data-box" style="margin-top:18px;height: 300px;">
            <div class="right-title" style="padding-bottom:0">
              城市客源年龄结构分析
              <input type="text" class="cityInput" v-model="city_name">
              <div class="city-btn" @click="getCityCome()">查询</div>
            </div>
            <div style="padding:0 22px;font-size:16px;">{{ now_city_name }}</div>
            <div id="cityCome_5" class="cityCome-chart" style="height: 240px"></div>
          </div>
        </div>
        <div class="main-right">
          <div class="right-center data-box" style="height:320px;">
            <div class="left-bottom-title">业态适配建议</div>
            <div class="gender">
              <div class="ota_pie_box">
                <div id="ota_pie_5" class="ota_pie"></div>
                <div class="ota_pie_list">
                  <div><span class="pie-dot" style="background-color: #63a8ea;"></span>餐饮：20.18%</div>
                  <div><span class="pie-dot" style="background-color: #ea8186;"></span>住宿：17.52%</div>
                  <div><span class="pie-dot" style="background-color: #e9c16d;"></span>游玩：26.51%</div>
                  <div><span class="pie-dot" style="background-color: #8c63ea;"></span>交通：31.16%</div>
                  <div><span class="pie-dot" style="background-color: #049f09;"></span>购物：3.59%</div>
                  <div><span class="pie-dot" style="background-color: #500509;"></span>其他：1.03%</div>
                </div>
              </div>
              <div class="text-box">
                建议建议建议建议建议建议建议建议建议建议建议建议建议建议建议建议建议建议建议建议建议建议建议建议建议建议建议
              </div>
            </div>
          </div>
          <div class="cityCome data-box" style="margin-top:18px;height: 260px;">
            <div class="left-bottom-title">动线优化方案</div>
            <div class="text-item-6">
              <div>关于游客在婺源县的动线优化方案</div>
              <div>6月2日</div>
            </div>
            <div class="text-item-6">
              <div>关于游客在婺源县的动线优化方案</div>
              <div>6月2日</div>
            </div>
            <div class="text-item-6">
              <div>关于游客在婺源县的动线优化方案</div>
              <div>6月2日</div>
            </div>
            <div class="text-item-6">
              <div>关于游客在婺源县的动线优化方案</div>
              <div>6月2日</div>
            </div>
            <div class="text-item-6">
              <div>关于游客在婺源县的动线优化方案</div>
              <div>6月2日</div>
            </div>
            <div class="text-item-6">
              <div>关于游客在婺源县的动线优化方案</div>
              <div>6月2日</div>
            </div>
            <div class="button-6">新增优化方案</div>
          </div>
          <div class="cityCome data-box" style="margin-top:18px;height: 260px;">
            <div class="left-bottom-title">精准营销策略</div>
            <div class="text-item-6">
              <div>关于游客在婺源县文旅营销策略</div>
              <div>6月2日</div>
            </div>
            <div class="text-item-6">
              <div>关于游客在婺源县文旅营销策略</div>
              <div>6月2日</div>
            </div>
            <div class="text-item-6">
              <div>关于游客在婺源县文旅营销策略</div>
              <div>6月2日</div>
            </div>
            <div class="text-item-6">
              <div>关于游客在婺源县文旅营销策略</div>
              <div>6月2日</div>
            </div>
            <div class="text-item-6">
              <div>关于游客在婺源县文旅营销策略</div>
              <div>6月2日</div>
            </div>
            <div class="text-item-6">
              <div>关于游客在婺源县文旅营销策略</div>
              <div>6月2日</div>
            </div>
            <div class="button-6">新增营销策略</div>
          </div>
        </div>
      </div>
      <!-- 价格监管 -->
      <div v-show="typeIndex == 8" class="main_type map-pass-through price-supervision-page">
        <div v-if="priceMapWarnings.length" class="price-map-alert-board">
          <div class="alert-scroll-container">
            <!-- 滚动内容层：自动动画 -->
            <div class="alert-scroll-wrapper">
              <div v-for="(item, index) in priceMapWarnings" :key="'price-map-alert-' + index"
                class="price-map-alert-item">
                <span class="price-map-alert-icon">⚠{{ item.scenic }}</span>
                <span class="price-map-alert-text">{{ item.text }}</span>
              </div>
              <!-- 复制一份用于无缝循环滚动（关键） -->
              <div v-for="(item, index) in priceMapWarnings" :key="'price-map-alert-copy-' + index"
                class="price-map-alert-item">
                <span class="price-map-alert-icon">⚠{{ item.scenic }}</span>
                <span class="price-map-alert-text">{{ item.text }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="main-left price-supervision-left">
          <div class="data-box price-panel">
            <div class="price-panel-header">
              <div class="right-title" style="font-size: 18px;">住宿价格监管</div>
              <div class="price-search-box">
                <input v-model="priceRoomSearch" type="text" placeholder="酒店/房型搜索" class="price-search-input" />
              </div>
            </div>
            <div class="price-table-container">
              <div class="price-table-header accommodation-header">
                <div class="price-th hotel-col">酒店名称</div>
                <div class="price-th">房型</div>
                <div class="price-th">实时价格</div>
                <div class="price-th">历史均价</div>
                <div class="price-th">溢价率</div>
              </div>
              <div class="price-table-body accommodation-list-body">
                <div v-for="(item, index) in filteredAccommodationPriceList" :key="'room-price-' + item.hotelId"
                  class="price-table-row accommodation-hotel-row"
                  :class="{ even: index % 2 === 0, active: isAccommodationHotelActive(item) }"
                  @click="selectAccommodationHotel(item)">
                  <div class="price-td hotel-name" :title="item.hotelName">{{ item.hotelName }}</div>
                  <div class="price-td room-type">{{ item.roomType }}</div>
                  <div class="price-td">¥{{ item.realTimePrice }}</div>
                  <div class="price-td">¥{{ item.historyAvgPrice }}</div>
                  <div class="price-td">
                    <span class="premium-rate" :class="getPremiumRateClass(item.premiumRate)">
                      {{ formatPremiumRate(item.premiumRate) }}
                    </span>
                  </div>
                </div>
                <div v-if="!filteredAccommodationPriceList.length" class="price-table-empty">未找到匹配的酒店</div>
              </div>
            </div>
            <div class="right-title" style="font-size: 18px;">
              投诉联动
              <span v-if="activeAccommodationHotel" class="price-selected-hotel-tag">{{
                activeAccommodationHotel.hotelName }}</span>
            </div>
            <div class="complaint-linkage-box">
              <div class="complaint-summary">该酒店投诉总数量：{{ activeHotelComplaintCount.toLocaleString() }}</div>
              <div class="complaint-summary">该酒店投诉摘要：</div>
              <div v-if="activeHotelComplaints.length > 0">
                <div v-for="(item, index) in activeHotelComplaints"
                  :key="'complaint-' + (activeAccommodationHotel && activeAccommodationHotel.hotelId) + '-' + index"
                  class="complaint-item">
                  <span class="complaint-dot"></span>{{ item }}
                </div>
              </div>
              <div v-else class="price-table-empty">该酒店暂无投诉</div>
            </div>
            <div class="right-title" style="font-size: 18px;">价格预警</div>
            <div class="price-warning-list">
              <div v-for="item in activeHotelPriceWarnings" :key="'price-warning-' + item.id"
                class="price-warning-item">
                <span class="price-warning-text">{{ (activeAccommodationHotel && activeAccommodationHotel.hotelName) ||
                  '' }}，{{ item.message }}</span>
                <span class="price-warning-link" @click.stop="openPriceWarningDetail(item)">点击查看</span>
              </div>
              <div v-if="activeAccommodationHotel && !activeHotelPriceWarnings.length" class="price-table-empty">
                该酒店暂无价格预警</div>
            </div>
          </div>
          <div class="data-box price-panel price-trend-panel">
            <div class="price-panel-header">
              <div class="right-title" style="font-size: 18px;">趋势分析</div>
            </div>
            <div class="price-trend-filters flex flex_w">
              <div class="price-filter-item"
                :class="{ 'price-filter-item-active': priceTrendActiveFilter === 'fence' }">
                <select v-model="priceFenceRegionId" class="price-filter-select" @change="onPriceTrendFenceChange">
                  <option v-for="region in priceFenceRegions" :key="region.id" :value="region.id">
                    {{ region.name }}
                  </option>
                </select>
              </div>
              <div class="price-filter-item"
                :class="{ 'price-filter-item-active': priceTrendActiveFilter === 'merchant' }">
                <select v-model="priceTrendMerchantId" class="price-filter-select" @change="onPriceTrendMerchantChange">
                  <option value="">请选择商户</option>
                  <option v-for="hotel in priceTrendMerchantOptions" :key="hotel.hotelId" :value="hotel.hotelId">
                    {{ hotel.hotelName }}
                  </option>
                </select>
              </div>
              <div class="price-filter-item" :class="{ 'price-filter-item-active': priceTrendActiveFilter === 'time' }">
                <select v-model="priceTrendDayCount" class="price-filter-select" @change="onPriceTrendTimeChange">
                  <option :value="7">前7天</option>
                  <option :value="14">前14天</option>
                </select>
              </div>
            </div>
            <div class="price-trend-chart-tip">{{ priceTrendChartTip }}</div>
            <div id="priceFluctuationChart" class="price-fluctuation-chart"></div>
          </div>
        </div>
        <div class="main-right price-supervision-right">
          <div class="data-box price-panel price-work-order-panel">
            <div class="right-title">监管预警工单</div>
            <div class="price-table-container price-work-order-table">
              <div class="price-table-header work-order-header">
                <div class="price-th">酒店名称</div>
                <div class="price-th">房型</div>
                <div class="price-th">溢价预警</div>
                <div class="price-th">预警时间</div>
                <div class="price-th">溢价率</div>
              </div>
              <div class="price-table-body work-order-body">
                <div v-for="(item, index) in priceSupervisionWorkOrders" :key="'work-order-' + index"
                  class="price-table-row" :class="{ even: index % 2 === 0 }">
                  <div class="price-td hotel-name">{{ item.hotelName }}</div>
                  <div class="price-td">{{ item.roomType }}</div>
                  <div class="price-td">{{ item.premiumPrice.toFixed(2) }}</div>
                  <div class="price-td">{{ item.warningTime }}</div>
                  <div class="price-td">
                    <span class="premium-rate" :class="getPremiumRateClass(item.premiumRate)">{{
                      formatPremiumRate(item.premiumRate) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="typeIndex == 7" class="main_type">
        <div class="main-left">
          <div class="cityCome data-box" style="height: 240px;">
            <div class="left-bottom-title">游客性别及时间安排</div>
            <div class="gender">
              <div class="a-gender" style="margin-top: 30px;margin-left: 20px;">
                <img src="../../static/img/man.png">
                <div class="gender-content" style="margin-top:8px">男</div>
                <div class="gender-content" style="margin-top:5px">{{ this.gender.male ? this.gender.male.ratio : 0 }}</div>
              </div>
              <div class="a-gender" style="margin-top: 30px;">
                <img src="../../static/img/woman.png">
                <div class="gender-content" style="margin-top:8px">女</div>
                <div class="gender-content" style="margin-top:5px">{{ this.gender.female ? this.gender.female.ratio : 0 }}
                </div>
              </div>
              <div id="gender_7" class="gender-column" style="height: 200px;width: 208px;margin-left: 30px;"></div>
            </div>
          </div>
          <div class="cityCome data-box" style="margin-top:18px;height: 300px;">
            <div class="right-title" style="padding-bottom:0">
              城市客源年龄结构分析
              <input type="text" class="cityInput" v-model="city_name">
              <div class="city-btn" @click="getCityCome()">查询</div>
            </div>
            <div style="padding:0 22px;font-size:16px;">{{ now_city_name }}</div>
            <div id="cityCome_7" class="cityCome-chart" style="height: 240px"></div>
          </div>
          <div class="cityCome data-box" style="height: 240px;margin-top:18px;">
            <div class="left-bottom-title">出行方式</div>
            <div class="gender" style="height:200px;">
              <div id="travel_pie" class="ota_pie" style="height:180px;"></div>
              <div class="ota_pie_list">
                <div><span class="pie-dot" style="background-color: #63a8ea;"></span>高铁：41.4%</div>
                <div><span class="pie-dot" style="background-color: #ea8186;"></span>自驾：35.2%</div>
                <div><span class="pie-dot" style="background-color: #e9c16d;"></span>大巴：21.5%</div>
                <div><span class="pie-dot" style="background-color: #8c63ea;"></span>其他：1.9%</div>
              </div>
            </div>
          </div>
        </div>
        <div class="main-right">
          <div class="right-top data-box" style="height: 300px;">
            <div class="left-bottom-title">景区对比</div>
            <div class="filter-select-box">
              <select class="filter-select" v-model="comparison_1" @change="comparisonChange_1">
                <option value="" disabled selected>请选择景区</option>
                <option value="篁岭">篁岭</option>
                <option value="弦高古城">弦高古城</option>
                <option value="婺女洲">婺女洲</option>
                <option value="婺女洲">月亮湾</option>
                <option value="婺女洲">李坑</option>
                <option value="婺女洲">江湾</option>
                <option value="婺女洲">江岭</option>
                <option value="婺女洲">卧龙谷</option>
              </select>
              <span class="select-arrow">▼</span>
            </div>
            <div class="filter-select-box">
              <select class="filter-select" v-model="comparison_2" @change="comparisonChange_2">
                <option value="" disabled selected>请选择景区</option>
                <option value="篁岭">篁岭</option>
                <option value="弦高古城">弦高古城</option>
                <option value="婺女洲">婺女洲</option>
                <option value="婺女洲">月亮湾</option>
                <option value="婺女洲">李坑</option>
                <option value="婺女洲">江湾</option>
                <option value="婺女洲">江岭</option>
                <option value="婺女洲">卧龙谷</option>
              </select>
              <span class="select-arrow">▼</span>
            </div>
            <div class="text-type-box">
              <div class="text-type-item" :class="{'text-type-item-on':comparison_type_index == item.value}" 
                v-for="(item, index) in comparison_type_list" @click="changeComparisonType(item.value)">
                {{ item.text }}
              </div>
            </div>
            <div>
              <div style="margin-top: 10px" v-show="comparison_1 && comparison_2">
                <div id="comparison_pie_1" class="ota_pie"
                  style="height:180px;width: 140px;border: 1px solid #03bbea;margin-left: 10px;"></div>
                <div id="comparison_pie_2" class="ota_pie"
                  style="height:180px;width: 140px;border: 1px solid #03bbea;margin-left: 10px;"></div>
              </div>
            </div>
          </div>
          <div class="right-top data-box" style="height: 300px;margin-top:18px;">
            <div class="left-bottom-title">
              层级下钻：{{ level_value==1?'省级':(level_value==2?'市级':'县级') }}
              <div class="last-level" v-if="level_value > 1" @click="lastLevel">< 返回上一级</div>
            </div>
            <div id="level_pie" class="ota_pie"
                style="height:240px;width: 300px;"></div>
          </div>
          <div class="right-top data-box" style="height: 200px;margin-top:18px;">
            <div class="left-bottom-title">营销策略调整</div>
            <div class="text-type-box">
              <div class="text-type-item" :class="{'text-type-item-on':text_type_value == item.value}" 
                v-for="(item, index) in text_type_list" @click="changeTextType(item.value)">
                {{ item.text }}
              </div>
            </div>
            <div class="text-box" style="margin-left: 5px" v-show="text_type_value == 1">
              【客源地】江、赣、浙、皖、粤、京、沪，【年龄层】18-40；60以上【性别】女，为婺源核心客群，对徽派、乡村、打卡、非遗类产品保持较高热度，需要强化此类产品
            </div>
            <div class="text-box" style="margin-left: 5px" v-show="text_type_value == 2">
              【客源地】鄂、鲁、闽、豫、湘，【年龄层】18以下；40-60【性别】男，为婺源潜力客群，交通便捷，对徽派文化有较强认同，需要增强区域性落地推广
            </div>
            <div class="text-box" style="margin-left: 5px" v-show="text_type_value == 3">
              【客源地】其他区域，为婺源机会客群，受制于交通和时空距离，1200公里以外市场以团队业务为主，需要增强市场走线和推介会
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 自定义弹窗 -->
    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <span>{{ videoTitle || '视频播放' }}</span>
          <button class="close-btn" @click="closeModal">×</button>
        </div>
        <div class="modal-body">
          <video :key="videoElementKey" ref="videoElement" controls width="100%"></video>
        </div>
      </div>
    </div>
    <!-- 价格预警弹窗 -->
    <div v-if="showPriceWarningModal" class="modal-overlay price-warning-modal-overlay"
      @click.self="closePriceWarningModal">
      <div class="modal-content price-warning-modal-content">
        <div class="modal-header price-warning-modal-header">
          <span>{{ priceWarningModalTitle }}</span>
          <button class="close-btn price-warning-close-btn" @click="closePriceWarningModal">×</button>
        </div>
        <div class="modal-body price-warning-modal-body">
          <div class="price-warning-modal-subtitle">{{ priceWarningModalSubtitle }}</div>
          <div class="price-warning-modal-tip">近5日价格波动（不含当日）</div>
          <div id="priceWarningModalChart" class="price-warning-modal-chart"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CountFlop from '../components/CountFlop/CountFlop.vue'
import ScenicWarning from './ScenicWarning.vue'
import SentimentSurveillance from './sentiment-surveillance.vue'
import videoSurveillance from './video-surveillance.vue'
import System from './system.vue'
import store from '@/store/index'
import {
  getSettingByIdApi, planeFigure, ticketNumberStatistics,
  realTimeTraffic, currentTrafficTrend, originList,
  realTouristsData, historyTouristsData, genderScheduleData,
  weatherData, weatherDataNew, getDataCustomerSourceMarketApi, getDataMainSourceMarketApi,
  getAnalysisMonthApi, getTradingNumApi, getTouristAgencyType,
  getSalesNumApi, xcxGetHotelDataApi, getMerchantOrder,
  getMerchantOrderList, getBigDataOfflineRetailInfo, salesComparisonApi,
  getDataRepurchaseAnalysisApi, getWaitingInApi, xcxGetDeliciousFoodDataApi,
  getCoefficientDataSettingApi, getMapResourceApi
} from '../api/ScenicAPI'
import {
  realTouristsWYData, visitorTrendData, scenicRankingData,
  todayVisitorsData, userPortraitData, visitorSourceData,
  channelAnalysisData, visitorRatioData, scenicHourlyData
} from '../api/wuyuanApi'
import {
  getIotScenicHistoryData, getIotScenicVillageRealData, getIotScenicVillageTrend, iotSettingData,
} from '../api/ScenicIotApi'
import {
  get_subscribe_info_list, get_dynamic_subscribe_info_list, get_dynamic_subscribe_info_detail,
  get_subscribe_time_trend
} from '../api/sentiment'

import echarts from 'echarts'
import { parseTime, debounce, createXfyunSpeechRecognizer, XfyunSpeechRecognizer } from '@/utils/index'
import { VOICE_PENDING_ACTION_KEY, VOICE_RECOGNITION_EOS_MS, VOICE_STATUS_HIDE_MS, findVoiceCommandMatch } from '@/utils/voiceCommandConfig'
import { accommodationPriceList, priceSupervisionWorkOrders, PRICE_FENCE_REGIONS, filterHotelsByFenceRegion, getPriceFenceRegionById } from '@/utils/priceSupervisionData.js'
var arcData = [];
var heatData = []
var SENTIMENT_STREAM_URLS = [
  'http://121.40.47.136:50080/video/0402b05801a098b1/0000000003.flv',
  'http://121.40.47.136:50080/video/0402b05801a098b1/0000000005.flv'
]
var DEFAULT_MONITOR_STREAM_URL = 'http://121.40.47.136:50080/video/0402b05801a098b1/0000000005.flv'
const WUYUAN_CENTER = {
  lat: 29.254015,
  lng: 117.861488
}
const WUYUAN_BOUNDARY_LOCAL_URL = process.env.NODE_ENV === 'production'
  ? '/static/big_data_web/geo/361130.json'
  : '/static/geo/361130.json'
const WUYUAN_BOUNDARY_REMOTE_URL = 'https://geo.datav.aliyun.com/areas_v3/bound/361130.json'
const WUYUAN_BOUNDARY_URLS = [WUYUAN_BOUNDARY_LOCAL_URL, WUYUAN_BOUNDARY_REMOTE_URL]
const WUYUAN_VIEW_HORIZONTAL_PADDING_RATIO = 0.38
const WUYUAN_VIEW_VERTICAL_PADDING_RATIO = 0.18
const WUYUAN_MAP_MIN_ZOOM = 11.2
const WUYUAN_FALLBACK_BOUNDS = {
  minLat: 29.01,
  maxLat: 29.59,
  minLng: 117.36,
  maxLng: 118.22
}
const PRICE_SUPERVISION_TYPE_INDEX = 8
const QIANJING_SERVICE_ORIGIN = 'https://qianjing.dev.ioing.uk:8443'
const LOCATION_ICON_URL = process.env.NODE_ENV === 'production'
  ? '/static/big_data_web/img/location_icon.png'
  : '/static/img/location_icon.png'
const BUSINESS_FENCE_POINT_ICON_URL = 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2214%22%20height%3D%2214%22%20viewBox%3D%220%200%2014%2014%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Ccircle%20cx%3D%227%22%20cy%3D%227%22%20r%3D%226%22%20fill%3D%22%238fffff%22%20stroke%3D%22%23003a4d%22%20stroke-width%3D%222%22/%3E%3C/svg%3E'
const SCENIC_4A_RESOURCE_KEY = 'scenic_4a'
const SCENIC_4A_SPOTS = [
  { id: 'scenic4a-1', name: '大鄣山卧龙谷景区', lng: 117.756709, lat: 29.485153 },
  { id: 'scenic4a-2', name: '灵岩洞景区', lng: 117.611753, lat: 29.47278 },
  { id: 'scenic4a-3', name: '文公山景区', lng: 117.747754, lat: 29.161558 },
  { id: 'scenic4a-4', name: '鸳鸯湖景区', lng: 117.51886, lat: 29.319423 },
  { id: 'scenic4a-5', name: '李坑景区', lng: 117.928314, lat: 29.325495 },
  { id: 'scenic4a-6', name: '思溪延村景区', lng: 117.788217, lat: 29.34055 },
  { id: 'scenic4a-7', name: '汪口景区', lng: 117.99147, lat: 29.350091 },
  { id: 'scenic4a-8', name: '严田景区', lng: 117.635814, lat: 29.366016 },
  { id: 'scenic4a-9', name: '五龙源景区', lng: 118.02027, lat: 29.492432 },
  { id: 'scenic4a-10', name: '熹园景区', lng: 117.852147, lat: 29.253135 },
  { id: 'scenic4a-11', name: '翼天文化旅游城', lng: 117.837654, lat: 29.206087 },
  { id: 'scenic4a-12', name: '源头古村景区', lng: 117.607083, lat: 29.396537 }
]

function fetchJson(url) {
  if (typeof window !== 'undefined' && window.fetch) {
    return window.fetch(url).then(response => {
      if (!response.ok) {
        throw new Error('边界数据请求失败(' + response.status + '): ' + url)
      }
      return response.json()
    })
  }

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) {
        return
      }
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          resolve(JSON.parse(xhr.responseText))
        } catch (error) {
          reject(error)
        }
      } else {
        reject(new Error('边界数据请求失败(' + xhr.status + '): ' + url))
      }
    }
    xhr.onerror = function () {
      reject(new Error('边界数据请求失败: ' + url))
    }
    xhr.send()
  })
}

function fetchJsonWithFallback(urls) {
  const sourceList = Array.isArray(urls) ? urls.filter(Boolean) : []
  let currentIndex = 0
  let lastError = null

  const tryNext = () => {
    if (currentIndex >= sourceList.length) {
      return Promise.reject(lastError || new Error('边界数据请求失败'))
    }
    const currentUrl = sourceList[currentIndex++]
    return fetchJson(currentUrl).catch(error => {
      lastError = error
      return tryNext()
    })
  }

  return tryNext()
}
export default {
  components: {
    CountFlop,
    ScenicWarning,
    SentimentSurveillance,
    videoSurveillance,
    System,
  },
  data() {
    return {
      geoCoordMap: {}, //  全国省份。  也不能叫全省吧。 就是所有数据要展示的经纬度。
      type_item: [
        { label: '文旅市场', value: 0 },
        { label: '客流分析', value: 1 },
        { label: '业态资源', value: 5 },
        { label: '大数据驾驶舱', value: 2 },
        { label: '价格监管', value: PRICE_SUPERVISION_TYPE_INDEX },
        { label: '客流预警', value: 4 },
        {label: '舆情分析', value: 9},
        {label: '视频监控', value: 10},
        {label: '系统管理', value: 11},
      ],
      // ,"营收分析"
      typeIndex: 0,
      yearSum: [],
      carSum: [],
      dateSum: [],
      dateInSum: [],
      dateOutSum: [],
      crowding: '',//在园游客饱和度
      ticket_of_data: '',//当日售票占比
      mouth_tourists_num: '',//本月游客
      yesterday_tourists_num: '',//昨日游客
      last_mouth_tourists_num: '',//上月游客
      last_years_tourists_num: '',//去年游客
      gender: {},//性别数据
      menP: 0,//男占比
      womenP: 0,//女占比
      schedule: [],//时间
      // temperature:'',//温度
      // winddirection:'',//风向
      // windpower:'',//风力
      nowDay: '',//今天日期
      nowYear: '',//现在年份
      week: '',//星期几
      nowTime: '',//时分秒
      tourists_list: {},//游客入园时间统计
      real_time_traffic_list: {},//游客客流分析
      current_traffic_trend: {
        categories: [],
        series: [],
      },//游客进出园时间分析
      ticket_number_statistics: {},//入园游客类型统计
      weather: {},
      scenic_id: '',
      req_date: null,
      bodyHeight: '',
      originType: ['全部', '散客', '团队'],
      isShowType: false,
      originIndex: 0,
      origin_list_dict: {},
      flightMap: null,
      hotMap: '',
      map: null,
      map_2: {},
      boundaryLayer: null,
      boundaryMaskLayer: null,
      priceFenceLayer: null,
      boundaryGeometries: [],
      boundaryHitPolygons: [],
      boundaryBounds: null,
      viewportBounds: null,
      boundaryLoadingPromise: null,
      isWuyuanViewportResetting: false,
      wuyuanMapGuardHandlers: null,
      scenic4AMarkerLayer: null,
      scenic4ALabelLayer: null,
      activeResourceItemKeys: ['scenic_all'],
      businessFencePoints: [],
      businessFenceMarkers: null,
      businessFencePolyline: null,
      businessFencePolygon: null,
      businessResourceMarkerLayer: null,
      selectedBusinessResourceKeys: [],
      businessFenceMetric: 0,
      businessResourceList: [],
      businessResourceTypeList: [],
      isBusinessFenceDrawing: false,
      businessFenceBoundaryTip: '',
      businessFenceBoundaryTipTimer: null,
      businessSavedFenceCount: 1,
      hotMapList: [],
      changeWeek: '',
      isToday: true,
      setting: {
        first_refresh_time: 2,
        second_refresh_time: 5,
        third_refresh_time: 10,
      },
      // matinee:'',
      // evening:'',
      matinee_evening: [],
      hour: '',
      isYearSumShow: false,
      isGetUser: false,
      isGetRevenue: false,
      isIndex: false,
      city_name: '南昌',
      now_city_name: '南昌',
      cityComeData: '',
      oldComeIndex: 1,
      oldComeName: '老年主体',
      monthList: [],
      tradingNum: {},
      productMoneyList: [],
      pieColor: ['#6BB7FF', '#FF898A', '#FFC06B', '#986BFF', '#00aa00', '#550000',
        '#aaff00', '#ffff7f', '#aaaaff', '#aaffff', '#aaaa00', "#9A60B4",
        "#ea7ccc", "#1890FF", "#91CB74", "#FAC858", "#EE6666"],
      hotelData: {},
      businessNum: {},
      offlineRetailInfo: {},
      ote_type_sale_person_list: [],
      re_sex: {},
      total_tourists_num: 0,
      free_check_gate_record_num: 0,
      three_series: [],
      three_show: [],
      last_day: '',
      tableTurnoverRate: 0,
      deliciousFoodData: {},
      IotAppendDataCache: null,
      allShopIndex: 1,
      merchant_order_total_list: [],
      coefficient_data: 100,
      //舆情分析
      timeTrend: null,
      timeTrendData: {
        x: [], y: []
      },
      emotion: null,
      emotionData: [],
      mediaType: null,
      mediaTypeData: [],
      hotWeb: null,
      hotWebData: { x: [], y: [] },
      list: [],
      platform_type: {
        'XINWEN': '新闻',
        'APP': 'APP',
        'SHUZIBAO': '数字报',
        'WEIXIN': '微信公众号',
        'SHORT_VIDEO': '视频',
        'MICRO_BLOG': '微博客',
        'WENDA': '问答',
        'LUNTAN': '论坛'
      },
      emotionType: {
        '正面': '#67C23A',
        '中立': '#909399',
        '疑似负面': '#E6A23C',
        '负面': '#F56C6C'
      },
      timelineList: null,
      tendenciesList: [],
      tendenciesItem: {},
      isDetailLoading: false,
      actIndex: 0,
      isDetail: false,
      realTourists_data: {},
      county_total_value: 0,
      warningList: [],
      warningCurrentIndex: 0,
      warningTimer: null,
      warningPushBoardVisible: false,
      warningPushBoardTimer: null,
      voiceRecognition: null,
      voiceRecognitionSupported: false,
      voiceKeepListening: false,
      voiceListening: false,
      voiceStarting: false,
      voiceStatusVisible: false,
      voiceStatusText: '',
      voiceStatusTone: 'info',
      voiceStatusTimer: null,
      voiceRestartTimer: null,
      voiceEndReason: '',
      voiceSuppressEndStatus: false,
      voiceCommandHandled: false,
      showModal: false,
      videoTitle: '',
      modalVideoUrl: DEFAULT_MONITOR_STREAM_URL,
      videoElementKey: 0,
      player: null,
      sentimentPlayers: [],
      tableData: [
        { road: '婺源高速口', inFlow: 385, inRate: 94, outFlow: 312, outRate: 94 },
        { road: '婺源北高速口', inFlow: 223, inRate: 36, outFlow: 232, outRate: 33 },
        { road: '江湾高速口', inFlow: 457, inRate: 89, outFlow: 402, outRate: 89 },
        { road: '清华高速口', inFlow: 343, inRate: 92, outFlow: 331, outRate: 82 }
      ],
      tableData_1: [
        { road: '德兴-婺源交界', inFlow: 9232, inRate: 96 },
        { road: '景德镇-婺源交界', inFlow: 2256, inRate: 21 },
        { road: '黄山-婺源交界', inFlow: 8443, inRate: 89 },
        { road: '高铁站出口地下', inFlow: 8377, inRate: 92 }
      ],
      businessSaturationList: [
        {
          title: '住宿饱和度',
          period: '周',
          axis: [40, 60, 80, 100],
          ranking: [
            { name: '酒店', value: 92 },
            { name: '民宿', value: 87 },
            { name: '客栈', value: 76 },
            { name: '露营地', value: 62 },
            { name: '度假村', value: 58 }
          ],
          advice: [
            '酒店、民宿接待接近高位，建议优先引导游客预订客栈、露营地等低负荷住宿资源。',
            '对高饱和住宿区域增加夜间接驳和行李寄存服务，降低核心片区入住压力。'
          ]
        },
        {
          title: '餐饮饱和度',
          period: '周',
          axis: [40, 60, 80, 100],
          ranking: [
            { name: '正餐', value: 89 },
            { name: '小吃', value: 82 },
            { name: '咖啡茶饮', value: 73 },
            { name: '团餐', value: 68 },
            { name: '夜宵', value: 55 }
          ],
          advice: [
            '正餐、小吃饱和度偏高，建议在午晚餐峰值前推送错峰用餐和周边餐饮推荐。',
            '咖啡茶饮与团餐仍有承接空间，可作为排队游客短停分流点。'
          ]
        },
        {
          title: '互娱饱和度',
          period: '周',
          axis: [40, 60, 80, 100],
          ranking: [
            { name: '演艺', value: 91 },
            { name: '夜游', value: 84 },
            { name: '研学体验', value: 72 },
            { name: '亲子互动', value: 66 },
            { name: '文创体验', value: 52 }
          ],
          advice: [
            '演艺、夜游资源趋于紧张，建议增加预约分时段和候场区客流提示。',
            '研学、亲子、文创体验仍可承接分流，适合向家庭及团队游客定向推荐。'
          ]
        }
      ],
      businessAreaStats: [
        { type: '酒店', count: 234, load: '92%', capacity: '紧张', loadType: 'danger' },
        { type: '餐饮', count: 654, load: '65%', capacity: '良好', loadType: 'warning' },
        { type: '互娱', count: 124, load: '36%', capacity: '良好', loadType: 'normal' }
      ],
      businessPassengerSummary: {
        online: '123,456',
        saturation: '87.56'
      },
      businessDiversionAdvice: [
        '根据区域客流量和饱和度变化，优先引导游客向低负荷资源点分流。',
        '结合电子围栏内业态承载情况，动态推送错峰游览和周边配套服务。'
      ],
      businessFlowRanking: [
        { name: 'AAAA景区', percent: 95 },
        { name: 'BBBB景区', percent: 90 },
        { name: 'CCCC景区', percent: 87 },
        { name: 'BBBB景区', percent: 87 },
        { name: 'CCCC景区', percent: 87 }
      ],
      businessFenceList: [
        { name: '全域', active: false, deletable: false },
        { name: '围栏名称A', active: true, deletable: true },
        { name: '围栏名称B', active: false, deletable: true },
        { name: '围栏名称C', active: false, deletable: true },
        { name: '围栏名称D', active: false, deletable: true },
        { name: '围栏名称E', active: false, deletable: true }
      ],
      drawingToolActions: [
        { label: '重新绘制', action: 'redraw' },
        { label: '确定选择区域', action: 'confirm' },
        { label: '保存电子围栏', action: 'save' },
        { label: '取消绘制', action: 'cancel' }
      ],
      businessResourceSeedList: [
        { key: 'scenic_all', name: '景区', base: 36, markerColor: '#8fffff' },
        { key: 'venue', name: '园馆', base: 122, markerColor: '#71a7ff' },
        { key: 'village_spot', name: '乡村旅游点', base: 122, markerColor: '#a47dff' },
        { key: 'monitor', name: '检测', base: 126, markerColor: '#4de2a6' },
        { key: 'hotel', name: '酒店', base: 1233, markerColor: '#ffd744' },
        { key: 'restaurant', name: '餐厅', base: 9882, markerColor: '#ff8a3d' },
        { key: 'parking', name: '停车场', base: 232, markerColor: '#d9f2ff' },
        { key: 'other', name: '其它资源', base: 2212, markerColor: '#ff65a8' }
      ],
      priceRoomSearch: '',
      selectedPriceHotelId: '',
      priceFenceRegions: PRICE_FENCE_REGIONS,
      priceFenceRegionId: 'huangling',
      priceTrendMerchantId: '',
      priceTrendDayCount: 7,
      // 趋势筛选三选一：merchant | fence | time
      priceTrendActiveFilter: 'fence',
      accommodationPriceList: accommodationPriceList,
      priceMapWarnings: [
        { scenic: '篁岭景区', text: '客流量接近饱和上限，请安排人员进行疏导' },
        { scenic: '弦高古城', text: '部分门店的产品售价高于平均值' },
        { scenic: '舆情警告:', text: '游客对“景区服务”产生的负面舆情有增幅' },
      ],
      priceSupervisionWorkOrders: priceSupervisionWorkOrders,
      priceFluctuationChart: null,
      showPriceWarningModal: false,
      priceWarningModalTitle: '',
      priceWarningModalSubtitle: '',
      priceWarningModalTrend: null,
      priceWarningModalChart: null,
      this_list: [
        { key: 'scenic_5a', name: '景区（5A）', value: 2 },
        { key: SCENIC_4A_RESOURCE_KEY, name: '景区（4A）', value: 12 },
        { key: 'provincial_resort', name: '度假区（省级）', value: 2 },
        { key: 'village_spot', name: '乡村旅游点', value: 54 },
        { key: 'hotel', name: '酒店', value: 345 },
        { key: 'homestay', name: '民宿', value:  1145 },
        { key: 'highway_checkpoint', name: '高速卡口', value:  7 },
        { key: 'parking', name: '公共停车场', value:  121 },
        { key: 'restaurant', name: '餐饮门店', value:  3423 },
        { key: 'shopping', name: '购物门店', value:  2030 }
      ],
      text_type_list: [
        { value: 1, text: '核心客群' },
        { value: 2, text: '潜力客群' },
        { value: 3, text: '机会客群' }
      ],
      text_type_value: 1,
      comparison_1: '',
      comparison_2: '',
      comparison_type_list: [
        { value: 1, text: '客源地' },
        { value: 2, text: '年龄' },
        { value: 3, text: '性别结构' },
      ],
      comparison_type_index: 1,
      level_value: 1
    };
  },
  computed: {
    filteredAccommodationPriceList() {
      var keyword = (this.priceRoomSearch || '').trim().toLowerCase()
      if (!keyword) {
        return this.accommodationPriceList
      }
      return this.accommodationPriceList.filter(function (item) {
        return (
          item.hotelName.indexOf(keyword) !== -1 ||
          item.roomType.indexOf(keyword) !== -1 ||
          (item.area && item.area.indexOf(keyword) !== -1)
        )
      })
    },
    activeAccommodationHotel() {
      var list = this.filteredAccommodationPriceList
      if (!list.length) {
        return null
      }
      if (this.selectedPriceHotelId) {
        var selected = list.find(function (item) {
          return item.hotelId === this.selectedPriceHotelId
        }.bind(this))
        if (selected) {
          return selected
        }
      }
      return list[0]
    },
    activeHotelComplaintCount() {
      return this.activeAccommodationHotel ? this.activeAccommodationHotel.complaintCount30Days : 0
    },
    activeHotelComplaints() {
      return this.activeAccommodationHotel ? (this.activeAccommodationHotel.complaints || []) : []
    },
    activeHotelPriceWarnings() {
      return this.activeAccommodationHotel ? (this.activeAccommodationHotel.warnings || []) : []
    },
    priceTrendMerchantOptions() {
      return this.accommodationPriceList
    },
    priceTrendChartDayCount() {
      if (this.priceTrendActiveFilter === 'time') {
        return Number(this.priceTrendDayCount) || 7
      }
      return 7
    },
    priceTrendChartTip() {
      var dayCount = this.priceTrendChartDayCount
      var suffix = '近' + dayCount + '天价格 vs 上月同期'
      if (this.priceTrendActiveFilter === 'merchant') {
        var merchant = this.accommodationPriceList.find(function (item) {
          return item.hotelId === this.priceTrendMerchantId
        }.bind(this))
        return (merchant ? merchant.hotelName : '请选择商户') + ' · ' + suffix
      }
      if (this.priceTrendActiveFilter === 'time') {
        return '时间范围：前' + dayCount + '天 · ' + suffix
      }
      var region = getPriceFenceRegionById(this.priceFenceRegionId)
      return region.name + ' · 区域均价 · ' + suffix
    },
    currentWarningItem() {
      if (!this.warningList.length) {
        return null
      }
      return this.warningList[this.warningCurrentIndex] || this.warningList[0]
    },
    businessDrawingStatusText() {
      if (this.businessFenceBoundaryTip) {
        return this.businessFenceBoundaryTip
      }
      if (this.isBusinessFenceDrawing) {
        if (this.businessFencePoints.length >= 3) {
          return '已形成区域，可继续添加点位或确定选择'
        }
        return '绘制中，请在婺源县范围内依次点击围栏点位'
      }
      if (this.businessFencePoints.length >= 3) {
        return '电子围栏区域已生成'
      }
      return '点击重新绘制开始创建电子围栏'
    },
    taps() {
      return function (tapsStr) {
        if (tapsStr) {
          return tapsStr.split(' ').slice(0, 4)
        } else {
          return []
        }
      }
    },
    imageList() {
      return function (imagesStr) {
        if (imagesStr) {
          return imagesStr.split(',')
        } else {
          return []
        }
      }
    },
    isImg() {
      return function (text) {
        if (!text) return true
        return text.indexOf('<img') < 0
      }
    }
  },
  created() {
    // if (sessionStorage.getItem('scenicId') === 'dsflksdjkfjlsdjlk1112312312111') {
    //   this.type_item.splice(3, 0, { label: '舆情分析', value: 3 })
    // }
    if (sessionStorage.getItem('scenicId') === 'dsflksdjkfjlsdjlk1112312312111') {
      this.type_item.splice(6, 0, { label: '决策分析', value: 6 })
    }
    if (sessionStorage.getItem('scenicId') === 'dsflksdjkfjlsdjlk1112312312111') {
      this.type_item.splice(7, 0, { label: '客群画像分析', value: 7 })
    }
  },
  mounted() {
    if (!this.$route.query.id) {
      let id = sessionStorage.getItem('scenicId');
      this.$router.push({ path: '/', query: { id: id, token: store.state.token } })
      this.$router.go(0)
    }
    this.getToday();
    this.scenic_id = this.$route.query.id
    if (this.scenic_id == 'e7bfd798d9ca461c9f37a4191d55edea') {
      this.type_item = this.type_item.filter(item => item.value !== 2)
    }

    if (this.$route.query.date) {
      this.req_date = this.$route.query.date
      if (this.req_date && this.req_date != '') {
        var reDate = new Date(this.req_date)
        this.changeWeek = this.getWeek(reDate.getDay())
      }

    }
    if (this.$route.query.token) {
      this.$store.commit('setToken', this.$route.query.token);
    }
    if (this.$route.query.typeIndex !== undefined && this.$route.query.typeIndex !== null) {
      this.typeIndex = Number(this.$route.query.typeIndex)
    }
    this.getCoefficientDataSetting()
    // this.getSettingById();
    if (this.req_date && this.req_date != '' && this.req_date != this.nowDay2) {
      this.isToday = false;
    } else {
      let _this = this;
      //设置零点十分刷新
      let current = new Date();
      let next = new Date();
      next.setDate(current.getDate() + 1);
      next.setHours(0);
      next.setMinutes(10);
      next.setSeconds(0);
      setTimeout(doIT, next - current);
      function doIT() {
        // _this.getGenderSchedule();
        _this.getHistoryData();
        _this.getRealTimeTraffic();
        _this.getPlaneFigure(1)
        setTimeout(doIT, 24 * 60 * 60 * 1000);
      }
    }
    if (this.typeIndex === 2 && this.isToday) {
      var today = new Date()
      var targetday_milliseconds = today.getTime() - 1000 * 60 * 60 * 24
      today.setTime(targetday_milliseconds) //注意，这行是关键代码
      var tYear = today.getFullYear()
      var tMonth = today.getMonth()
      var tDate = today.getDate()
      this.nowYear = tYear;
      tMonth = this.doHandleMonth(tMonth + 1)
      tDate = this.doHandleMonth(tDate)
      this.last_day = tYear + "-" + tMonth + "-" + tDate
    }

    this.bodyHeight = document.getElementById("bodys").offsetHeight + 54;
    this.initVoiceRecognitionSupport()
    this.startWarningPushBoardTimer()
    this.$nextTick(() => {
      this.consumePendingVoiceAction(0)
      this.initSentimentPlayersIfNeeded()
    })
  },
  beforeDestroy() {
    this.stopWarningScroll()
    this.clearWarningPushBoardTimer()
    this.destroyVoiceRecognition()
    this.destroyPlayer()
    this.destroySentimentPlayers()
    this.destroyMainMap()
    this.destroyPriceWarningModalChart()
  },
  watch: {
    showModal(val) {
      if (val) {
        this.$nextTick(() => this.initPlayer())
      } else {
        this.destroyPlayer()
      }
    },
    typeIndex(val) {
      if (val === 3) {
        this.$nextTick(() => this.initSentimentPlayersIfNeeded())
        return
      }
      this.destroySentimentPlayers()
      if (val === PRICE_SUPERVISION_TYPE_INDEX) {
        this.$nextTick(() => {
          this.renderPriceFenceLayer()
          this.refreshPriceFluctuationChart()
        })
      } else {
        this.removePriceFenceLayer()
      }
    }
  },
  methods: {
    go_hl() {
      // 跳转篁岭
      this.$router.push({ path: '/scenic_date_data', query: { id: 'dsflksdjkfjlsdjlk1112312312111' } })
    },
    getRateClass(rate) {
      if (rate >= 80) return 'danger'    // 红色 - 严重拥堵
      if (rate >= 50) return 'warning'   // 黄色 - 拥堵
      return 'normal'                    // 绿色 - 畅通
    },
    getPremiumRateClass(rate) {
      if (rate > 0) return 'up'
      if (rate < 0) return 'down'
      return 'flat'
    },
    formatPremiumRate(rate) {
      var value = Number(rate) || 0
      var prefix = value > 0 ? '+' : ''
      return prefix + value.toFixed(2) + '%'
    },
    isAccommodationHotelActive(item) {
      return (this.activeAccommodationHotel && item && item.hotelId === this.activeAccommodationHotel.hotelId)
    },
    selectAccommodationHotel(item) {
      if (!item || !item.hotelId) {
        return
      }
      this.selectedPriceHotelId = item.hotelId
      // ==================== 注释掉这一段，切换酒店就不会影响趋势 ====================
      // this.priceTrendActiveFilter = 'merchant'
      // this.priceTrendMerchantId = item.hotelId
      // if (item.fenceRegionId) {
      //   this.priceFenceRegionId = item.fenceRegionId
      //   this.renderPriceFenceLayer()
      // }
      // this.refreshPriceFluctuationChart()
    },
    getPriceReferenceDate() {
      return new Date(2026, 4, 8)
    },
    buildPriceTrendSeries(hotels, dayCount) {
      const baseDate = new Date(2026, 4, 7);
      const dates = [];
      const recentSeries = [];
      const lastMonthSeries = [];

      if (!hotels.length) return { dates, recentSeries, lastMonthSeries };

      // 生成横轴日期
      for (let i = dayCount - 1; i >= 0; i--) {
        const d = new Date(baseDate);
        d.setDate(baseDate.getDate() - i);
        dates.push(`${d.getMonth() + 1}-${d.getDate()}`);
      }

      const isHuangling = hotels.some(h => h.fenceRegionId === 'huangling');
      const isWunvzhou = hotels.some(h => h.fenceRegionId === 'wunvzhou');

      // 5.1,5.2,5.3,5.4 高价位；5.5,5.6,5.7回落
      const huangling7 = [1200, 1230, 1250, 1240, 1080, 920, 750];
      const wunvzhou7 = [890, 910, 931, 920, 760, 630, 490];

      for (let idx = 0; idx < dayCount; idx++) {
        let nowPrice, lastMonthPrice;
        if (dayCount === 7) {
          if (isHuangling) {
            nowPrice = huangling7[idx];
            lastMonthPrice = Math.round(nowPrice * 0.52);
          } else if (isWunvzhou) {
            nowPrice = wunvzhou7[idx];
            lastMonthPrice = Math.round(nowPrice * 0.56);
          } else {
            nowPrice = 480 + idx * 25;
            lastMonthPrice = 320 + idx * 18;
          }
        } else {
          // 14天：前7天平日低价爬升，第8天起接入五一峰值
          if (isHuangling) {
            if (idx < 7) {
              nowPrice = 320 + idx * 45;
            } else {
              nowPrice = huangling7[idx - 7];
            }
            lastMonthPrice = Math.round(nowPrice * 0.5);
          } else if (isWunvzhou) {
            if (idx < 7) {
              nowPrice = 288 + idx * 34;
            } else {
              nowPrice = wunvzhou7[idx - 7];
            }
            lastMonthPrice = Math.round(nowPrice * 0.54);
          } else {
            nowPrice = 290 + idx * 26;
            lastMonthPrice = 210 + idx * 16;
          }
        }
        recentSeries.push(nowPrice);
        lastMonthSeries.push(lastMonthPrice);
      }
      return { dates, recentSeries, lastMonthSeries };
    },
    openPriceWarningDetail(warningItem) {
      var hotel = this.activeAccommodationHotel
      if (!hotel || !warningItem) {
        return
      }
      this.priceWarningModalTitle = hotel.hotelName + ' · ' + hotel.roomType
      this.priceWarningModalSubtitle = warningItem.message
      this.priceWarningModalTrend = this.buildLast5DaysPriceTrend(hotel)
      this.showPriceWarningModal = true
      this.$nextTick(() => {
        this.initPriceWarningModalChart()
      })
    },
    buildLast5DaysPriceTrend(hotel) {
    const baseDate = new Date(2026, 4, 7);
    const dates = [];
    const historyAvgLine = [];
    let prices = [];
    const avgPrice = Number(hotel.historyAvgPrice) || 0;

    // 5.3 ~ 5.7
    for (let dayOffset = 5; dayOffset >= 1; dayOffset--) {
      const pointDate = new Date(baseDate);
      pointDate.setDate(baseDate.getDate() - dayOffset);
      dates.push(parseTime(pointDate, '{m}-{d}'));
      historyAvgLine.push(avgPrice);
    }

    // 按酒店类型生成真实价格
    if (hotel.fenceRegionId === 'huangling') {
      prices = [1250, 1120, 960, 810, 680];
    } else if (hotel.fenceRegionId === 'wunvzhou') {
      prices = [931, 922, 775, 640, 495];
    } else {
      const base = avgPrice;
      prices = [
        Math.round(base * 1.8),
        Math.round(base * 1.65),
        Math.round(base * 1.45),
        Math.round(base * 1.22),
        Math.round(base * 1.03),
      ];
    }

    return { dates, prices, historyAvgLine, roomType: hotel.roomType };
  },
    closePriceWarningModal() {
      this.showPriceWarningModal = false
      this.destroyPriceWarningModalChart()
    },
    destroyPriceWarningModalChart() {
      if (this.priceWarningModalChart) {
        this.priceWarningModalChart.dispose()
        this.priceWarningModalChart = null
      }
    },
    initPriceWarningModalChart() {
      var chartDom = document.getElementById('priceWarningModalChart')
      if (!chartDom || !this.priceWarningModalTrend) {
        return
      }
      this.destroyPriceWarningModalChart()
      this.priceWarningModalChart = this.echarts.init(chartDom)
      var trend = this.priceWarningModalTrend
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: function (params) {
            if (!params || !params.length) {
              return ''
            }
            var lines = [params[0].axisValue]
            params.forEach(function (p) {
              lines.push(p.marker + p.seriesName + '：¥' + p.value)
            })
            return lines.join('<br/>')
          }
        },
        legend: {
          data: ['当日挂牌价', '历史均价'],
          textStyle: { color: '#a8c5e8', fontSize: 12 },
          top: 0
        },
        grid: {
          top: '18%',
          left: '8%',
          right: '5%',
          bottom: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: trend.dates,
          axisLabel: {
            color: '#a8c5e8',
            fontSize: 12
          },
          axisLine: {
            lineStyle: { color: 'rgba(0, 170, 255, 0.45)' }
          }
        },
        yAxis: {
          type: 'value',
          name: '价格(元)',
          nameTextStyle: { color: '#a8c5e8', fontSize: 11 },
          axisLabel: {
            color: '#a8c5e8',
            formatter: '¥{value}'
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(0, 170, 255, 0.12)',
              type: 'dashed'
            }
          }
        },
        series: [
          {
            name: '当日挂牌价',
            type: 'bar',
            barWidth: '42%',
            data: trend.prices,
            itemStyle: {
              color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#01f1e3' },
                { offset: 1, color: '#023aff' }
              ]),
              borderRadius: [4, 4, 0, 0]
            },
            label: {
              show: true,
              position: 'top',
              color: '#ffffff',
              fontSize: 11,
              formatter: '¥{c}'
            }
          },
          {
            name: '历史均价',
            type: 'line',
            data: trend.historyAvgLine,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: { color: '#ff9f43' },
            lineStyle: { width: 2, type: 'dashed' }
          }
        ]
      }
      this.priceWarningModalChart.setOption(option)
    },
    initPriceSupervisionSelection() {
      this.priceFenceRegionId = 'huangling'
      this.priceTrendActiveFilter = 'fence'
      this.priceTrendMerchantId = ''
      this.priceTrendDayCount = 7
    },
    onPriceTrendMerchantChange() {
      this.priceTrendActiveFilter = 'merchant'
      this.refreshPriceFluctuationChart()
    },
    onPriceTrendFenceChange() {
      this.priceTrendActiveFilter = 'fence'
      this.priceTrendMerchantId = ''
      this.renderPriceFenceLayer()
      this.refreshPriceFluctuationChart()
    },
    onPriceTrendTimeChange() {
      this.priceTrendActiveFilter = 'time'
      this.priceTrendMerchantId = ''
      this.refreshPriceFluctuationChart()
    },
    removePriceFenceLayer() {
      if (this.priceFenceLayer && this.priceFenceLayer.setMap) {
        this.priceFenceLayer.setMap(null)
        this.priceFenceLayer = null
      }
    },
    renderPriceFenceLayer() {
      if (this.typeIndex !== PRICE_SUPERVISION_TYPE_INDEX || !this.map) {
        return
      }
      var region = getPriceFenceRegionById(this.priceFenceRegionId)
      if (!region || !region.paths || !region.paths.length) {
        return
      }
      this.removePriceFenceLayer()
      var fenceStyle = new TMap.PolygonStyle({
        color: 'rgba(255, 77, 79, 0.18)',
        showBorder: true,
        borderColor: 'rgba(255, 193, 7, 0.95)',
        borderWidth: 3
      })
      this.priceFenceLayer = new TMap.MultiPolygon({
        map: this.map,
        zIndex: 12,
        styles: {
          priceFence: fenceStyle
        },
        geometries: [{
          id: 'price-fence-' + region.id,
          styleId: 'priceFence',
          paths: region.paths
        }]
      })
      if (region.mapCenter && this.map.setCenter) {
        this.map.setCenter(this.normalizeWuyuanCenter(new TMap.LatLng(region.mapCenter.lat, region.mapCenter.lng)))
      }
      if (region.mapZoom && this.map.setZoom) {
        this.map.setZoom(Math.max(Number(region.mapZoom), WUYUAN_MAP_MIN_ZOOM))
      }
    },
    calcHotelPriceOnDate(hotel, targetDate, dayOffset, hotelIndex, dayCount) {
      var avgPrice = Number(hotel.historyAvgPrice) || 0
      var endPrice = Number(hotel.realTimePrice) || avgPrice
      var progress = dayCount <= 1 ? 1 : (dayCount - dayOffset) / (dayCount - 1)
      var seed = 0
      for (var i = 0; i < (hotel.hotelId || '').length; i++) {
        seed += (hotel.hotelId || '').charCodeAt(i)
      }
      var monthSeed = targetDate.getMonth() + 1
      var wave = ((seed + dayOffset * 13 + hotelIndex * 7 + monthSeed) % 9 - 4) * 5
      var price = Math.round(avgPrice + (endPrice - avgPrice) * progress + wave)
      return price < 0 ? 0 : price
    },
    buildPriceTrendSeries(hotels, dayCount) {
      const baseDate = new Date(2026, 4, 7);
      const dates = [];
      const recentSeries = [];
      const lastMonthSeries = [];

      if (!hotels || hotels.length === 0) return { dates, recentSeries, lastMonthSeries };

      // 生成日期
      for (let i = dayCount - 1; i >= 0; i--) {
        const d = new Date(baseDate);
        d.setDate(baseDate.getDate() - i);
        dates.push(`${d.getMonth() + 1}-${d.getDate()}`);
      }

      // 取出当前选中的第一个酒店（区域筛选）
      const hotel = hotels[0];
      const isHuangling = hotel.fenceRegionId === 'huangling';
      const isWunvzhou = hotel.fenceRegionId === 'wunvzhou';

      for (let idx = 0; idx < dayCount; idx++) {
        let nowPrice;

        if (dayCount === 7) {
          // --------------------- 7天：5.1~5.7 ---------------------
          if (isHuangling) {
            const arr = [1240, 1250, 1250, 1120, 960, 810, 680];
            nowPrice = arr[idx];
          } else if (isWunvzhou) {
            const arr = [880, 915, 931, 922, 775, 640, 495];
            nowPrice = arr[idx];
          } else {
            const base = hotel.historyAvgPrice || 300;
            const peak = base * 1.8;
            const drop = base * 1.0;
            nowPrice = Math.round(peak - ((peak - drop) * idx / 6));
          }
        } else {
          // --------------------- 14天 ---------------------
          if (isHuangling) {
            if (idx < 7) {
              nowPrice = 320 + idx * 46;
            } else {
              const arr = [1240, 1250, 1250, 1120, 960, 810, 680];
              nowPrice = arr[idx - 7];
            }
          } else if (isWunvzhou) {
            if (idx < 7) {
              nowPrice = 288 + idx * 35;
            } else {
              const arr = [880, 915, 931, 922, 775, 640, 495];
              nowPrice = arr[idx - 7];
            }
          } else {
            const base = hotel.historyAvgPrice || 260;
            if (idx < 7) {
              nowPrice = Math.round(base * 0.8 + idx * 15);
            } else {
              const peak = base * 1.8;
              const drop = base * 1.0;
              nowPrice = Math.round(peak - ((peak - drop) * (idx - 7) / 6));
            }
          }
        }

        const lastMonthPrice = Math.round(nowPrice * 0.5);
        recentSeries.push(nowPrice);
        lastMonthSeries.push(lastMonthPrice);
      }

      return { dates, recentSeries, lastMonthSeries };
    },
    getPriceTrendTargetHotels() {
      if (this.priceTrendActiveFilter === 'merchant') {
        if (!this.priceTrendMerchantId) {
          return []
        }
        var merchant = this.accommodationPriceList.find(function (item) {
          return item.hotelId === this.priceTrendMerchantId
        }.bind(this))
        return merchant ? [merchant] : []
      }
      if (this.priceTrendActiveFilter === 'time') {
        return this.accommodationPriceList.slice()
      }
      return filterHotelsByFenceRegion(
        this.accommodationPriceList,
        this.priceFenceRegionId
      )
    },
    refreshPriceFluctuationChart() {
      this.$nextTick(() => {
        this.initPriceFluctuationChart()
      })
    },
    destroyMainMap() {
      this.stopBusinessFenceDrawing()
      this.clearBusinessResourceMarkers()
      this.clearBusinessFenceLayers()
      this.removeScenic4AMarkerLayer()
      this.removePriceFenceLayer()
      this.unbindWuyuanMapGuard()
      if (this.boundaryMaskLayer && this.boundaryMaskLayer.setMap) {
        this.boundaryMaskLayer.setMap(null)
        this.boundaryMaskLayer = null
      }
      if (this.boundaryLayer && this.boundaryLayer.setMap) {
        this.boundaryLayer.setMap(null)
        this.boundaryLayer = null
      }
      if (this.flightMap) {
        this.flightMap.remove()
        this.flightMap = null
      }
      if (this.map && this.map.destroy) {
        this.map.destroy()
      }
      this.map = null
    },
    clearFlightLayer() {
      if (this.flightMap) {
        this.flightMap.remove()
        this.flightMap = null
      }
    },
    businessDrawingToolActive(action) {
      return action === 'redraw' && this.isBusinessFenceDrawing
    },
    businessDrawingToolDisabled(action) {
      if (action === 'confirm' || action === 'save') {
        return this.businessFencePoints.length < 3
      }
      if (action === 'cancel') {
        return !this.isBusinessFenceDrawing && !this.businessFencePoints.length
      }
      return false
    },
    handleDrawingToolAction(action) {
      if (action === 'redraw') {
        this.startBusinessFenceDrawing()
      } else if (action === 'confirm') {
        this.confirmBusinessFenceArea()
      } else if (action === 'save') {
        this.saveBusinessFenceArea()
      } else if (action === 'cancel') {
        this.cancelBusinessFenceDrawing()
      }
    },
    startBusinessFenceDrawing() {
      if (!this.map) {
        return
      }
      this.clearBusinessFenceLayers()
      this.clearBusinessResourceMarkers()
      this.businessFencePoints = []
      this.selectedBusinessResourceKeys = []
      this.businessFenceBoundaryTip = ''
      this.isBusinessFenceDrawing = true
      this.bindBusinessFenceMapClick()
    },
    confirmBusinessFenceArea() {
      if (this.businessFencePoints.length < 3) {
        return
      }
      this.isBusinessFenceDrawing = false
      this.businessFenceBoundaryTip = ''
      this.unbindBusinessFenceMapClick()
      this.renderBusinessFenceLayers()
      this.refreshBusinessFenceDynamicData()
    },
    saveBusinessFenceArea() {
      if (this.businessFencePoints.length < 3) {
        return
      }
      this.confirmBusinessFenceArea()
      this.businessSavedFenceCount += 1
      this.businessFenceList = this.businessFenceList.map(item => Object.assign({}, item, { active: false }))
      this.businessFenceList.push({
        name: '围栏名称' + this.businessSavedFenceCount,
        active: true,
        deletable: true
      })
    },
    cancelBusinessFenceDrawing() {
      this.stopBusinessFenceDrawing()
      this.businessFencePoints = []
      this.selectedBusinessResourceKeys = []
      this.businessFenceBoundaryTip = ''
      this.clearBusinessFenceLayers()
      this.clearBusinessResourceMarkers()
    },
    bindBusinessFenceMapClick() {
      if (!this.map || !this.map.on) {
        return
      }
      this.unbindBusinessFenceMapClick()
      this.map.on('click', this.handleBusinessFenceMapClick)
    },
    unbindBusinessFenceMapClick() {
      if (this.map && this.map.off) {
        this.map.off('click', this.handleBusinessFenceMapClick)
      }
    },
    stopBusinessFenceDrawing() {
      this.isBusinessFenceDrawing = false
      this.businessFenceBoundaryTip = ''
      clearTimeout(this.businessFenceBoundaryTipTimer)
      this.businessFenceBoundaryTipTimer = null
      this.unbindBusinessFenceMapClick()
    },
    handleBusinessFenceMapClick(event) {
      if (!this.isBusinessFenceDrawing || !event || !event.latLng) {
        return
      }
      if (!this.canAddBusinessFencePointInWuyuan(event.latLng)) {
        this.showBusinessFenceBoundaryTip()
        return
      }
      this.businessFenceBoundaryTip = ''
      this.businessFencePoints.push(event.latLng)
      this.renderBusinessFenceLayers()
      if (this.businessFencePoints.length >= 3) {
        this.refreshBusinessFenceDynamicData()
      }
    },
    showBusinessFenceBoundaryTip() {
      this.businessFenceBoundaryTip = '只能在婺源县范围内绘制和选择区域'
      clearTimeout(this.businessFenceBoundaryTipTimer)
      this.businessFenceBoundaryTipTimer = setTimeout(() => {
        this.businessFenceBoundaryTip = ''
        this.businessFenceBoundaryTipTimer = null
      }, 1800)
    },
    canAddBusinessFencePointInWuyuan(point) {
      if (!this.isPointInWuyuanBoundary(point)) {
        return false
      }
      const lastPoint = this.businessFencePoints[this.businessFencePoints.length - 1]
      if (lastPoint && !this.isSegmentInWuyuanBoundary(lastPoint, point)) {
        return false
      }
      const firstPoint = this.businessFencePoints[0]
      if (firstPoint && this.businessFencePoints.length >= 2 && !this.isSegmentInWuyuanBoundary(point, firstPoint)) {
        return false
      }
      return true
    },
    clearBusinessFenceLayers() {
      if (this.businessFenceMarkers && this.businessFenceMarkers.setMap) {
        this.businessFenceMarkers.setMap(null)
      }
      this.businessFenceMarkers = null
      if (this.businessFencePolyline && this.businessFencePolyline.setMap) {
        this.businessFencePolyline.setMap(null)
      }
      this.businessFencePolyline = null
      if (this.businessFencePolygon && this.businessFencePolygon.setMap) {
        this.businessFencePolygon.setMap(null)
      }
      this.businessFencePolygon = null
    },
    clearBusinessResourceMarkers() {
      if (this.businessResourceMarkerLayer && this.businessResourceMarkerLayer.setMap) {
        this.businessResourceMarkerLayer.setMap(null)
      }
      this.businessResourceMarkerLayer = null
    },
    renderBusinessFenceLayers() {
      if (!this.map) {
        return
      }
      this.clearBusinessFenceLayers()
      if (!this.businessFencePoints.length) {
        return
      }

      const markerPoints = this.normalizeBusinessFencePoints(this.businessFencePoints)
      const fenceAreaPoints = this.getBusinessFenceAreaPoints()
      const markerGeometries = markerPoints.map((point, index) => ({
        id: 'business-fence-point-' + index,
        styleId: 'businessFencePoint',
        position: point,
        properties: {
          title: '点位' + (index + 1)
        }
      }))

      this.businessFenceMarkers = new TMap.MultiMarker({
        id: 'business-fence-marker-layer',
        map: this.map,
        zIndex: 30,
        styles: {
          businessFencePoint: new TMap.MarkerStyle({
            width: 14,
            height: 14,
            src: BUSINESS_FENCE_POINT_ICON_URL,
            anchor: { x: 7, y: 7 },
          })
        },
        geometries: markerGeometries
      })

      if (fenceAreaPoints.length > 1) {
        const linePath = fenceAreaPoints.slice()
        if (fenceAreaPoints.length >= 3) {
          linePath.push(fenceAreaPoints[0])
        }
        this.businessFencePolyline = new TMap.MultiPolyline({
          id: 'business-fence-polyline-layer',
          map: this.map,
          zIndex: 29,
          styles: {
            businessFenceLine: new TMap.PolylineStyle({
              color: 'rgba(127, 255, 255, 0.95)',
              width: 3,
              borderColor: 'rgba(15, 80, 110, 0.75)',
              borderWidth: 1
            })
          },
          geometries: [{
            id: 'business-fence-line',
            styleId: 'businessFenceLine',
            paths: linePath
          }]
        })
      }

      if (fenceAreaPoints.length >= 3) {
        this.businessFencePolygon = new TMap.MultiPolygon({
          id: 'business-fence-polygon-layer',
          map: this.map,
          zIndex: 28,
          styles: {
            businessFencePolygon: new TMap.PolygonStyle({
              color: 'rgba(65, 234, 232, 0.22)',
              showBorder: true,
              borderColor: 'rgba(127, 255, 255, 0.95)',
              borderWidth: 3
            })
          },
          geometries: [{
            id: 'business-fence-polygon',
            styleId: 'businessFencePolygon',
            paths: fenceAreaPoints
          }]
        })
      }
    },
    refreshBusinessFenceDynamicData() {
      const fenceAreaPoints = this.getBusinessFenceAreaPoints()
      if (fenceAreaPoints.length < 3) {
        return
      }
      const metric = this.calculateBusinessFenceMetric(fenceAreaPoints)
      this.businessFenceMetric = metric
      const resourceSourceList = this.businessResourceTypeList.length ? this.businessResourceTypeList : this.businessResourceSeedList
      const isApiResourceSource = !!this.businessResourceTypeList.length
      this.businessResourceList = resourceSourceList.map((item, index) => {
        const jitter = this.seededBusinessRandom(metric, index) * 0.38 + 0.82
        const areaRatio = Math.max(0.08, Math.min(0.95, metric / 9000))
        const base = Number(item.base || item.value || 0)
        const areaValue = Math.max(1, Math.round(base * areaRatio * jitter))
        return Object.assign({}, item, {
          base: base,
          value: isApiResourceSource ? item.value : areaValue,
          areaValue: areaValue,
          points: this.buildBusinessResourcePoints(item, areaValue, index, fenceAreaPoints)
        })
      })
      this.refreshBusinessSaturationData(metric)
      this.refreshBusinessAreaStats(metric)
      this.refreshBusinessFlowRanking(metric)
      this.refreshBusinessPassengerSummary(metric)
      this.renderBusinessResourceMarkers()
    },
    getMapResourceList() {
      getMapResourceApi().then(res => {
        const responseData = res && res.data ? res.data : {}
        if (Number(responseData.code) !== 1 || !Array.isArray(responseData.data)) {
          console.warn('[ScenicData] 业态资源类型汇总列表获取失败。', responseData)
          return
        }
        const resourceList = responseData.data
          .slice()
          .sort((a, b) => Number(a.idx || 0) - Number(b.idx || 0))
          .map((item, index) => this.normalizeBusinessResourceType(item, index))
        this.businessResourceTypeList = resourceList
        this.businessResourceList = resourceList
        this.selectedBusinessResourceKeys = this.selectedBusinessResourceKeys.filter(key => {
          return resourceList.some(item => item.key === key)
        })
        if (this.businessFencePoints.length >= 3) {
          this.refreshBusinessFenceDynamicData()
        }
      }).catch(error => {
        console.warn('[ScenicData] 业态资源类型汇总列表请求异常。', error)
      })
    },
    normalizeBusinessResourceType(item, index) {
      const seedResource = this.businessResourceSeedList[index % this.businessResourceSeedList.length] || {}
      const id = item && item.id !== undefined ? item.id : index
      const key = 'business_resource_' + id
      const count = Number(item && item.point_count)
      return {
        id: id,
        idx: item && item.idx !== undefined ? item.idx : index,
        key: key,
        name: item && item.name ? item.name : '未命名资源',
        icon: this.normalizeBusinessResourceIcon(item && item.icon),
        value: isFinite(count) ? count : 0,
        base: isFinite(count) ? count : 0,
        markerColor: seedResource.markerColor || '#8fffff',
        points: []
      }
    },
    normalizeBusinessResourceIcon(icon) {
      const iconUrl = String(icon || '').trim()
      if (!iconUrl) {
        return ''
      }
      if (/^(https?:)?\/\//.test(iconUrl) || iconUrl.indexOf('data:') === 0) {
        return iconUrl
      }
      return iconUrl.charAt(0) === '/'
        ? QIANJING_SERVICE_ORIGIN + iconUrl
        : QIANJING_SERVICE_ORIGIN + '/' + iconUrl
    },
    getBusinessFenceAreaPoints() {
      const fencePoints = this.normalizeBusinessFencePoints(this.businessFencePoints)
      if (fencePoints.length < 4 || !this.hasBusinessFenceSelfIntersection(fencePoints)) {
        return fencePoints
      }
      const outerHullPoints = this.getBusinessFenceOuterHullPoints(fencePoints)
      return outerHullPoints.length >= 3 ? outerHullPoints : fencePoints
    },
    normalizeBusinessFencePoints(points) {
      const normalizedPoints = []
        ; (points || []).forEach(point => {
          const lat = this.getBusinessFencePointLat(point)
          const lng = this.getBusinessFencePointLng(point)
          if (!isFinite(lat) || !isFinite(lng)) {
            return
          }
          const duplicated = normalizedPoints.some(item => this.isSameBusinessFencePoint(item, point))
          if (!duplicated) {
            normalizedPoints.push(point)
          }
        })
      return normalizedPoints
    },
    getBusinessFencePointLat(point) {
      if (!point) {
        return NaN
      }
      return Number(typeof point.getLat === 'function' ? point.getLat() : point.lat)
    },
    getBusinessFencePointLng(point) {
      if (!point) {
        return NaN
      }
      return Number(typeof point.getLng === 'function' ? point.getLng() : point.lng)
    },
    isSameBusinessFencePoint(firstPoint, secondPoint) {
      const latGap = Math.abs(this.getBusinessFencePointLat(firstPoint) - this.getBusinessFencePointLat(secondPoint))
      const lngGap = Math.abs(this.getBusinessFencePointLng(firstPoint) - this.getBusinessFencePointLng(secondPoint))
      return latGap < 0.0000001 && lngGap < 0.0000001
    },
    getBusinessFenceOuterHullPoints(points) {
      const sortedPoints = points.slice().sort((firstPoint, secondPoint) => {
        const lngDiff = this.getBusinessFencePointLng(firstPoint) - this.getBusinessFencePointLng(secondPoint)
        if (lngDiff !== 0) {
          return lngDiff
        }
        return this.getBusinessFencePointLat(firstPoint) - this.getBusinessFencePointLat(secondPoint)
      })
      const lowerPoints = []
      sortedPoints.forEach(point => {
        while (
          lowerPoints.length >= 2 &&
          this.getBusinessFenceTurnDirection(lowerPoints[lowerPoints.length - 2], lowerPoints[lowerPoints.length - 1], point) <= 0
        ) {
          lowerPoints.pop()
        }
        lowerPoints.push(point)
      })
      const upperPoints = []
      for (let index = sortedPoints.length - 1; index >= 0; index--) {
        const point = sortedPoints[index]
        while (
          upperPoints.length >= 2 &&
          this.getBusinessFenceTurnDirection(upperPoints[upperPoints.length - 2], upperPoints[upperPoints.length - 1], point) <= 0
        ) {
          upperPoints.pop()
        }
        upperPoints.push(point)
      }
      return lowerPoints.slice(0, -1).concat(upperPoints.slice(0, -1))
    },
    getBusinessFenceTurnDirection(firstPoint, secondPoint, targetPoint) {
      return (
        (this.getBusinessFencePointLng(secondPoint) - this.getBusinessFencePointLng(firstPoint)) *
        (this.getBusinessFencePointLat(targetPoint) - this.getBusinessFencePointLat(firstPoint))
      ) - (
          (this.getBusinessFencePointLat(secondPoint) - this.getBusinessFencePointLat(firstPoint)) *
          (this.getBusinessFencePointLng(targetPoint) - this.getBusinessFencePointLng(firstPoint))
        )
    },
    hasBusinessFenceSelfIntersection(points) {
      if (!points || points.length < 4) {
        return false
      }
      for (let firstIndex = 0; firstIndex < points.length; firstIndex++) {
        const firstStart = points[firstIndex]
        const firstEnd = points[(firstIndex + 1) % points.length]
        for (let secondIndex = firstIndex + 1; secondIndex < points.length; secondIndex++) {
          const isAdjacent = Math.abs(firstIndex - secondIndex) <= 1 || (firstIndex === 0 && secondIndex === points.length - 1)
          if (isAdjacent) {
            continue
          }
          const secondStart = points[secondIndex]
          const secondEnd = points[(secondIndex + 1) % points.length]
          if (this.doBusinessFenceSegmentsIntersect(firstStart, firstEnd, secondStart, secondEnd)) {
            return true
          }
        }
      }
      return false
    },
    doBusinessFenceSegmentsIntersect(firstStart, firstEnd, secondStart, secondEnd) {
      const firstStartPoint = this.toBusinessFencePlanePoint(firstStart)
      const firstEndPoint = this.toBusinessFencePlanePoint(firstEnd)
      const secondStartPoint = this.toBusinessFencePlanePoint(secondStart)
      const secondEndPoint = this.toBusinessFencePlanePoint(secondEnd)
      const firstOrientation = this.getBusinessFenceOrientation(firstStartPoint, firstEndPoint, secondStartPoint)
      const secondOrientation = this.getBusinessFenceOrientation(firstStartPoint, firstEndPoint, secondEndPoint)
      const thirdOrientation = this.getBusinessFenceOrientation(secondStartPoint, secondEndPoint, firstStartPoint)
      const fourthOrientation = this.getBusinessFenceOrientation(secondStartPoint, secondEndPoint, firstEndPoint)

      if (firstOrientation * secondOrientation < 0 && thirdOrientation * fourthOrientation < 0) {
        return true
      }
      return (
        this.isBusinessFencePointOnSegment(firstStartPoint, secondStartPoint, firstEndPoint, firstOrientation) ||
        this.isBusinessFencePointOnSegment(firstStartPoint, secondEndPoint, firstEndPoint, secondOrientation) ||
        this.isBusinessFencePointOnSegment(secondStartPoint, firstStartPoint, secondEndPoint, thirdOrientation) ||
        this.isBusinessFencePointOnSegment(secondStartPoint, firstEndPoint, secondEndPoint, fourthOrientation)
      )
    },
    toBusinessFencePlanePoint(point) {
      return {
        x: this.getBusinessFencePointLng(point),
        y: this.getBusinessFencePointLat(point)
      }
    },
    getBusinessFenceOrientation(firstPoint, secondPoint, targetPoint) {
      const orientation = (secondPoint.x - firstPoint.x) * (targetPoint.y - firstPoint.y) - (secondPoint.y - firstPoint.y) * (targetPoint.x - firstPoint.x)
      return Math.abs(orientation) < 0.000000000001 ? 0 : orientation
    },
    isBusinessFencePointOnSegment(startPoint, targetPoint, endPoint, orientation) {
      if (orientation !== 0) {
        return false
      }
      return targetPoint.x >= Math.min(startPoint.x, endPoint.x) - 0.000000000001 &&
        targetPoint.x <= Math.max(startPoint.x, endPoint.x) + 0.000000000001 &&
        targetPoint.y >= Math.min(startPoint.y, endPoint.y) - 0.000000000001 &&
        targetPoint.y <= Math.max(startPoint.y, endPoint.y) + 0.000000000001
    },
    calculateBusinessFenceMetric(fencePoints) {
      const points = fencePoints || this.getBusinessFenceAreaPoints()
      if (points.length < 3) {
        return 0
      }
      let area = 0
      for (let index = 0; index < points.length; index++) {
        const currentPoint = points[index]
        const nextPoint = points[(index + 1) % points.length]
        const currentLat = this.getBusinessFencePointLat(currentPoint)
        const currentLng = this.getBusinessFencePointLng(currentPoint)
        const nextLat = this.getBusinessFencePointLat(nextPoint)
        const nextLng = this.getBusinessFencePointLng(nextPoint)
        area += currentLng * nextLat - nextLng * currentLat
      }
      return Math.max(1, Math.round(Math.abs(area) * 50000000))
    },
    getBusinessFenceBounds(fencePoints) {
      const points = fencePoints || this.getBusinessFenceAreaPoints()
      if (!points.length) {
        return null
      }
      let minLat = Infinity
      let maxLat = -Infinity
      let minLng = Infinity
      let maxLng = -Infinity
      points.forEach(point => {
        const lat = this.getBusinessFencePointLat(point)
        const lng = this.getBusinessFencePointLng(point)
        minLat = Math.min(minLat, lat)
        maxLat = Math.max(maxLat, lat)
        minLng = Math.min(minLng, lng)
        maxLng = Math.max(maxLng, lng)
      })
      if (!isFinite(minLat) || !isFinite(maxLat) || !isFinite(minLng) || !isFinite(maxLng)) {
        return null
      }
      return { minLat, maxLat, minLng, maxLng }
    },
    seededBusinessRandom(seed, offset) {
      const value = Math.sin(Number(seed || 1) * 12.9898 + offset * 78.233) * 43758.5453
      return value - Math.floor(value)
    },
    buildBusinessResourcePoints(resource, count, offset, fencePoints) {
      const bounds = this.getBusinessFenceBounds(fencePoints)
      if (!bounds) {
        return []
      }
      const pointCount = Math.min(Math.max(Math.round(count / 28), 3), 28)
      const points = []
      let attempt = 0
      while (points.length < pointCount && attempt < pointCount * 8) {
        const index = attempt
        const latRatio = this.seededBusinessRandom(count + offset * 31, index + 1)
        const lngRatio = this.seededBusinessRandom(count + offset * 47, index + 11)
        const lat = bounds.minLat + (bounds.maxLat - bounds.minLat) * (0.12 + latRatio * 0.76)
        const lng = bounds.minLng + (bounds.maxLng - bounds.minLng) * (0.12 + lngRatio * 0.76)
        attempt += 1
        if (!this.isBusinessPointInFence(lat, lng, fencePoints)) {
          continue
        }
        points.push({
          id: resource.key + '-' + points.length,
          name: resource.name + (points.length + 1),
          position: new TMap.LatLng(lat, lng)
        })
      }
      return points
    },
    isBusinessPointInFence(lat, lng, fencePoints) {
      const points = fencePoints || this.getBusinessFenceAreaPoints()
      if (points.length < 3) {
        return false
      }
      let isInside = false
      for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
        const pointI = points[i]
        const pointJ = points[j]
        const latI = this.getBusinessFencePointLat(pointI)
        const lngI = this.getBusinessFencePointLng(pointI)
        const latJ = this.getBusinessFencePointLat(pointJ)
        const lngJ = this.getBusinessFencePointLng(pointJ)
        const intersects = ((latI > lat) !== (latJ > lat)) &&
          (lng < (lngJ - lngI) * (lat - latI) / (latJ - latI || 0.000001) + lngI)
        if (intersects) {
          isInside = !isInside
        }
      }
      return isInside
    },
    refreshBusinessSaturationData(metric) {
      const source = [
        {
          title: '住宿饱和度',
          labels: ['酒店', '民宿', '客栈', '露营地', '度假村'],
          advice: [
            '住宿高负荷资源增加错峰入住提示，并优先推荐低负荷民宿、客栈承接游客。',
            '对围栏内高饱和住宿点位增加接驳与停车引导，降低核心区域停留压力。'
          ]
        },
        {
          title: '餐饮饱和度',
          labels: ['正餐', '小吃', '咖啡茶饮', '团餐', '夜宵'],
          advice: [
            '餐饮高峰前推送错峰用餐提示，将客流导向围栏周边低负荷餐饮点。',
            '小吃、茶饮可作为排队缓冲资源，适合承接短停游客分流。'
          ]
        },
        {
          title: '互娱饱和度',
          labels: ['演艺', '夜游', '研学体验', '亲子互动', '文创体验'],
          advice: [
            '互娱高负荷项目建议采用分时预约，并在入口处提示候场时长。',
            '将家庭与团队游客导向研学、亲子、文创体验点，分散演艺和夜游压力。'
          ]
        }
      ]
      this.businessSaturationList = source.map((group, groupIndex) => {
        const ranking = group.labels.map((name, index) => {
          const value = Math.round(48 + this.seededBusinessRandom(metric + groupIndex * 17, index) * 47)
          return { name, value }
        }).sort((a, b) => b.value - a.value)
        return {
          title: group.title,
          period: '周',
          axis: [40, 60, 80, 100],
          ranking,
          advice: group.advice
        }
      })
    },
    refreshBusinessAreaStats(metric) {
      const hotel = this.findBusinessResourceByKeywords(['hotel', '住宿', '酒店', '民宿'])
      const restaurant = this.findBusinessResourceByKeywords(['restaurant', '餐饮', '餐厅', '美食'])
      const venue = this.findBusinessResourceByKeywords(['venue', '互娱', '娱乐', '园馆', '场馆'])
      this.businessAreaStats = [
        this.buildBusinessAreaStat('酒店', this.getBusinessResourceAreaValue(hotel), metric, 0),
        this.buildBusinessAreaStat('餐饮', this.getBusinessResourceAreaValue(restaurant), metric, 1),
        this.buildBusinessAreaStat('互娱', this.getBusinessResourceAreaValue(venue), metric, 2)
      ]
    },
    findBusinessResourceByKeywords(keywords) {
      return this.businessResourceList.find(item => {
        const key = item && item.key ? item.key : ''
        const name = item && item.name ? item.name : ''
        return keywords.some(keyword => key === keyword || name.indexOf(keyword) !== -1)
      })
    },
    getBusinessResourceAreaValue(resource) {
      if (!resource) {
        return 0
      }
      const areaValue = Number(resource.areaValue)
      if (isFinite(areaValue)) {
        return areaValue
      }
      const value = Number(resource.value)
      return isFinite(value) ? value : 0
    },
    buildBusinessAreaStat(type, count, metric, offset) {
      const loadValue = Math.round(38 + this.seededBusinessRandom(metric, offset) * 57)
      let loadType = 'normal'
      let capacity = '良好'
      if (loadValue >= 85) {
        loadType = 'danger'
        capacity = '紧张'
      } else if (loadValue >= 65) {
        loadType = 'warning'
        capacity = '偏高'
      }
      return {
        type,
        count,
        load: loadValue + '%',
        capacity,
        loadType
      }
    },
    refreshBusinessFlowRanking(metric) {
      const names = ['篁岭', '弦高古城', '婺女洲', '卧龙谷', '月亮湾']
      this.businessFlowRanking = names.map((name, index) => ({
        name,
        percent: Math.round(54 + this.seededBusinessRandom(metric, index + 9) * 41)
      })).sort((a, b) => b.percent - a.percent)
    },
    refreshBusinessPassengerSummary(metric) {
      const online = Math.round(28000 + metric * 12 + this.seededBusinessRandom(metric, 21) * 52000)
      const saturation = (58 + this.seededBusinessRandom(metric, 22) * 38).toFixed(2)
      this.businessPassengerSummary = {
        online: String(online).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        saturation
      }
      if (Number(saturation) >= 85) {
        this.businessDiversionAdvice = [
          '区域客流接近承载上限，建议立即开放外围资源点和临时疏散通道。',
          '高负荷点位增加现场引导与预约限流提示，优先分流至低饱和业态。'
        ]
      } else if (Number(saturation) >= 70) {
        this.businessDiversionAdvice = [
          '区域客流处于高位，建议推送错峰游览线路和周边可承接资源。',
          '餐饮、住宿、互娱资源按负荷分级推荐，减少核心片区持续聚集。'
        ]
      } else {
        this.businessDiversionAdvice = [
          '区域承载相对平稳，可承接周边游客导入并保持常规巡检频次。',
          '持续观察重点点位客流变化，保留低负荷资源作为后续分流承接。'
        ]
      }
    },
    renderBusinessResourceMarkers() {
      this.clearBusinessResourceMarkers()
      if (!this.map || !this.selectedBusinessResourceKeys.length) {
        return
      }
      const selectedResources = this.businessResourceList.filter(item => this.selectedBusinessResourceKeys.indexOf(item.key) !== -1)
      const geometries = []
      const styles = {}
      selectedResources.forEach(resource => {
        styles[resource.key] = new TMap.MarkerStyle({
          width: 13,
          height: 13,
          src: this.buildBusinessResourceIcon(resource.markerColor),
          anchor: { x: 6, y: 6 }
        })
          ; (resource.points || []).forEach(point => {
            geometries.push({
              id: point.id,
              styleId: resource.key,
              position: point.position,
              properties: {
                title: point.name
              }
            })
          })
      })
      if (!geometries.length) {
        return
      }
      this.businessResourceMarkerLayer = new TMap.MultiMarker({
        id: 'business-resource-marker-layer',
        map: this.map,
        zIndex: 31,
        styles,
        geometries
      })
    },
    buildBusinessResourceIcon(color) {
      const safeColor = encodeURIComponent(color || '#8fffff')
      return 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2213%22%20height%3D%2213%22%20viewBox%3D%220%200%2013%2013%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Ccircle%20cx%3D%226.5%22%20cy%3D%226.5%22%20r%3D%225.5%22%20fill%3D%22' + safeColor + '%22%20stroke%3D%22%2300142b%22%20stroke-width%3D%222%22/%3E%3C/svg%3E'
    },
    isResourceItemActive(item) {
      if (!item || !item.key) {
        return false
      }
      return this.activeResourceItemKeys.indexOf(item.key) !== -1
    },
    isBusinessResourceSelected(item) {
      return !!(item && item.key && this.selectedBusinessResourceKeys.indexOf(item.key) !== -1)
    },
    handleResourceItemClick(item) {
      if (!item || !item.key) {
        return
      }
      if (this.typeIndex === 5) {
        if (this.businessFencePoints.length < 3) {
          return
        }
        const currentIndex = this.selectedBusinessResourceKeys.indexOf(item.key)
        if (currentIndex === -1) {
          this.selectedBusinessResourceKeys.push(item.key)
        } else {
          this.selectedBusinessResourceKeys.splice(currentIndex, 1)
        }
        this.renderBusinessResourceMarkers()
        return
      }
      if (item.key === SCENIC_4A_RESOURCE_KEY) {
        this.toggleScenic4AResource()
      }
    },
    toggleResourceItemKey(key, forceActive) {
      if (!key) {
        return false
      }
      const currentIndex = this.activeResourceItemKeys.indexOf(key)
      const shouldActivate = typeof forceActive === 'boolean' ? forceActive : currentIndex === -1
      if (shouldActivate && currentIndex === -1) {
        this.activeResourceItemKeys.push(key)
      }
      if (!shouldActivate && currentIndex !== -1) {
        this.activeResourceItemKeys.splice(currentIndex, 1)
      }
      return shouldActivate
    },
    toggleScenic4AResource(forceActive) {
      const shouldActivate = this.toggleResourceItemKey(SCENIC_4A_RESOURCE_KEY, forceActive)
      if (shouldActivate) {
        this.renderScenic4AMarkerLayer()
      } else {
        this.removeScenic4AMarkerLayer()
      }
    },
    removeScenic4AMarkerLayer() {
      if (this.scenic4AMarkerLayer && this.scenic4AMarkerLayer.setMap) {
        this.scenic4AMarkerLayer.setMap(null)
      }
      this.scenic4AMarkerLayer = null
      if (this.scenic4ALabelLayer && this.scenic4ALabelLayer.setMap) {
        this.scenic4ALabelLayer.setMap(null)
      }
      this.scenic4ALabelLayer = null
    },
    renderScenic4AMarkerLayer() {
      if (!this.map || this.typeIndex !== 2) {
        return
      }

      this.removeScenic4AMarkerLayer()

      const markerGeometries = SCENIC_4A_SPOTS.map(item => ({
        id: item.id,
        styleId: 'scenic4a',
        position: new TMap.LatLng(item.lat, item.lng),
        properties: {
          title: item.name
        }
      }))
      const labelGeometries = SCENIC_4A_SPOTS.map(item => ({
        id: item.id + '-label',
        styleId: 'scenic4aLabel',
        position: new TMap.LatLng(item.lat, item.lng),
        content: item.name,
        rank: 12,
        properties: {
          title: item.name
        }
      }))

      this.scenic4AMarkerLayer = new TMap.MultiMarker({
        id: 'scenic4a-marker-layer',
        map: this.map,
        zIndex: 12,
        styles: {
          scenic4a: new TMap.MarkerStyle({
            width: 18,
            height: 24,
            src: LOCATION_ICON_URL,
            anchor: { x: 9, y: 24 }
          })
        },
        disableInteractive: true,
        isStopPropagation: false,
        geometries: markerGeometries
      })

      this.scenic4ALabelLayer = new TMap.MultiLabel({
        id: 'scenic4a-label-layer',
        map: this.map,
        zIndex: 13,
        styles: {
          scenic4aLabel: new TMap.LabelStyle({
            color: '#ffffff',
            size: 15,
            offset: { x: 0, y: -42 },
            angle: 0,
            alignment: 'center',
            verticalAlignment: 'middle',
            padding: '7px 12px',
            backgroundColor: 'rgba(3, 10, 69, 0.88)',
            borderWidth: 1,
            borderRadius: 4,
            borderColor: 'rgba(120, 238, 255, 0.56)',
            strokeColor: 'rgba(3, 10, 69, 0.95)',
            strokeWidth: 1
          })
        },
        disableInteractive: true,
        isStopPropagation: false,
        geometries: labelGeometries
      })
    },
    syncDashboardResourceOverlays() {
      if (this.isResourceItemActive({ key: SCENIC_4A_RESOURCE_KEY })) {
        this.renderScenic4AMarkerLayer()
      } else {
        this.removeScenic4AMarkerLayer()
      }
    },
    ensureWuyuanBoundaryReady() {
      if (this.boundaryGeometries.length) {
        this.calculateBoundaryBounds()
        return Promise.resolve(this.boundaryGeometries)
      }
      if (this.boundaryLoadingPromise) {
        return this.boundaryLoadingPromise
      }

      this.boundaryLoadingPromise = fetchJsonWithFallback(WUYUAN_BOUNDARY_URLS)
        .then(data => {
          const parsedBoundary = this.parseBoundaryGeometries(data)
          this.boundaryGeometries = parsedBoundary.geometries
          this.boundaryHitPolygons = parsedBoundary.hitPolygons
          this.calculateBoundaryBounds()
          return this.boundaryGeometries
        })
        .catch(error => {
          this.boundaryGeometries = []
          this.boundaryHitPolygons = []
          this.boundaryBounds = null
          this.viewportBounds = null
          console.warn('[ScenicData] 婺源县边界数据加载失败，已降级为婺源县外接范围。', error)
          return []
        })
        .then(result => {
          this.boundaryLoadingPromise = null
          return result
        }, error => {
          this.boundaryLoadingPromise = null
          throw error
        })

      return this.boundaryLoadingPromise
    },
    parseBoundaryGeometries(geojson) {
      const geometries = []
      const hitPolygons = []
      let geometryIndex = 0
      const features = geojson && geojson.features ? geojson.features : []

      const appendPolygon = polygonCoordinates => {
        if (!polygonCoordinates || !polygonCoordinates.length) {
          return
        }
        const paths = polygonCoordinates.map(ring => {
          return ring.map(point => ({
            lat: Number(point[1]),
            lng: Number(point[0])
          }))
        }).filter(ring => ring.length > 2)

        if (!paths.length) {
          return
        }

        geometries.push({
          id: 'wuyuan-boundary-' + geometryIndex++,
          styleId: 'boundary',
          paths: paths.length === 1 ? paths[0] : paths
        })
        hitPolygons.push(paths)
      }

      for (let index = 0; index < features.length; index++) {
        const geometry = features[index].geometry || {}
        if (geometry.type === 'Polygon') {
          appendPolygon(geometry.coordinates)
        } else if (geometry.type === 'MultiPolygon') {
          for (let polygonIndex = 0; polygonIndex < geometry.coordinates.length; polygonIndex++) {
            appendPolygon(geometry.coordinates[polygonIndex])
          }
        }
      }

      return {
        geometries,
        hitPolygons
      }
    },
    calculateBoundaryBounds() {
      if (!this.boundaryGeometries.length) {
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      let minLat = Infinity
      let maxLat = -Infinity
      let minLng = Infinity
      let maxLng = -Infinity

      const walkPoints = points => {
        for (let index = 0; index < points.length; index++) {
          const point = points[index]
          if (Array.isArray(point)) {
            walkPoints(point)
          } else if (point && typeof point.lat === 'number' && typeof point.lng === 'number') {
            minLat = Math.min(minLat, point.lat)
            maxLat = Math.max(maxLat, point.lat)
            minLng = Math.min(minLng, point.lng)
            maxLng = Math.max(maxLng, point.lng)
          }
        }
      }

      for (let index = 0; index < this.boundaryGeometries.length; index++) {
        walkPoints(this.boundaryGeometries[index].paths)
      }

      if (!isFinite(minLat) || !isFinite(maxLat) || !isFinite(minLng) || !isFinite(maxLng)) {
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      this.boundaryBounds = {
        sw: new TMap.LatLng(minLat, minLng),
        ne: new TMap.LatLng(maxLat, maxLng)
      }
      const latSpan = maxLat - minLat
      const lngSpan = maxLng - minLng
      const latPadding = latSpan * WUYUAN_VIEW_VERTICAL_PADDING_RATIO
      const lngPadding = lngSpan * WUYUAN_VIEW_HORIZONTAL_PADDING_RATIO
      this.viewportBounds = {
        sw: new TMap.LatLng(minLat - latPadding, minLng - lngPadding),
        ne: new TMap.LatLng(maxLat + latPadding, maxLng + lngPadding)
      }
      return this.boundaryBounds
    },
    getMapPointLat(point) {
      if (!point) {
        return NaN
      }
      return Number(typeof point.getLat === 'function' ? point.getLat() : point.lat)
    },
    getMapPointLng(point) {
      if (!point) {
        return NaN
      }
      return Number(typeof point.getLng === 'function' ? point.getLng() : point.lng)
    },
    getWuyuanFallbackBounds() {
      return {
        sw: new TMap.LatLng(WUYUAN_FALLBACK_BOUNDS.minLat, WUYUAN_FALLBACK_BOUNDS.minLng),
        ne: new TMap.LatLng(WUYUAN_FALLBACK_BOUNDS.maxLat, WUYUAN_FALLBACK_BOUNDS.maxLng)
      }
    },
    normalizeWuyuanCenter(center) {
      const lat = this.getMapPointLat(center)
      const lng = this.getMapPointLng(center)
      if (isFinite(lat) && isFinite(lng) && this.isPointInWuyuanBoundary(center)) {
        return center
      }
      return new TMap.LatLng(WUYUAN_CENTER.lat, WUYUAN_CENTER.lng)
    },
    isPointInWuyuanBoundary(point) {
      const lat = this.getMapPointLat(point)
      const lng = this.getMapPointLng(point)
      if (!isFinite(lat) || !isFinite(lng)) {
        return false
      }
      if (this.boundaryHitPolygons.length) {
        return this.boundaryHitPolygons.some(polygon => this.isPointInBoundaryPolygon(lat, lng, polygon))
      }
      const bounds = this.boundaryBounds || this.getWuyuanFallbackBounds()
      return lat >= this.getMapPointLat(bounds.sw) &&
        lat <= this.getMapPointLat(bounds.ne) &&
        lng >= this.getMapPointLng(bounds.sw) &&
        lng <= this.getMapPointLng(bounds.ne)
    },
    isSegmentInWuyuanBoundary(startPoint, endPoint) {
      const startLat = this.getMapPointLat(startPoint)
      const startLng = this.getMapPointLng(startPoint)
      const endLat = this.getMapPointLat(endPoint)
      const endLng = this.getMapPointLng(endPoint)
      if (!isFinite(startLat) || !isFinite(startLng) || !isFinite(endLat) || !isFinite(endLng)) {
        return false
      }
      if (this.boundaryHitPolygons.length) {
        return this.boundaryHitPolygons.some(polygon => {
          if (!this.isPointInBoundaryPolygon(startLat, startLng, polygon) || !this.isPointInBoundaryPolygon(endLat, endLng, polygon)) {
            return false
          }
          return !polygon.some(ring => this.doesSegmentCrossBoundaryRing(startPoint, endPoint, ring))
        })
      }
      const sampleCount = 14
      for (let index = 0; index <= sampleCount; index++) {
        const ratio = index / sampleCount
        const samplePoint = {
          lat: startLat + (endLat - startLat) * ratio,
          lng: startLng + (endLng - startLng) * ratio
        }
        if (!this.isPointInWuyuanBoundary(samplePoint)) {
          return false
        }
      }
      return true
    },
    doesSegmentCrossBoundaryRing(startPoint, endPoint, ring) {
      if (!ring || ring.length < 2) {
        return false
      }
      for (let index = 0; index < ring.length; index++) {
        const ringStart = ring[index]
        const ringEnd = ring[(index + 1) % ring.length]
        if (this.doBusinessFenceSegmentsIntersect(startPoint, endPoint, ringStart, ringEnd)) {
          return true
        }
      }
      return false
    },
    isPointInBoundaryPolygon(lat, lng, polygonRings) {
      if (!polygonRings || !polygonRings.length || !this.isPointInBoundaryRing(lat, lng, polygonRings[0])) {
        return false
      }
      for (let index = 1; index < polygonRings.length; index++) {
        if (this.isPointInBoundaryRing(lat, lng, polygonRings[index])) {
          return false
        }
      }
      return true
    },
    isPointInBoundaryRing(lat, lng, ring) {
      if (!ring || ring.length < 3) {
        return false
      }
      let isInside = false
      for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
        const pointI = ring[i]
        const pointJ = ring[j]
        const latI = this.getMapPointLat(pointI)
        const lngI = this.getMapPointLng(pointI)
        const latJ = this.getMapPointLat(pointJ)
        const lngJ = this.getMapPointLng(pointJ)
        const intersects = ((latI > lat) !== (latJ > lat)) &&
          (lng < (lngJ - lngI) * (lat - latI) / (latJ - latI || 0.000001) + lngI)
        if (intersects) {
          isInside = !isInside
        }
      }
      return isInside
    },
    applyWuyuanMapBoundary(mapOptions) {
      const options = Object.assign({}, mapOptions)
      const mapBounds = this.viewportBounds || this.boundaryBounds || this.getWuyuanFallbackBounds()
      const minZoom = Math.max(Number(options.minZoom || 0), WUYUAN_MAP_MIN_ZOOM)
      options.minZoom = minZoom
      if (options.zoom) {
        options.zoom = Math.max(Number(options.zoom), minZoom)
      } else {
        options.zoom = minZoom
      }
      if (mapBounds) {
        options.boundary = new TMap.LatLngBounds(mapBounds.sw, mapBounds.ne)
      }
      options.center = this.normalizeWuyuanCenter(options.center)
      return options
    },
    createRestrictedWuyuanMap(containerId, mapOptions) {
      this.map = new TMap.Map(containerId, this.applyWuyuanMapBoundary(mapOptions))
      this.bindWuyuanMapGuard()
      this.renderWuyuanBoundaryLayer()
      return this.map
    },
    bindWuyuanMapGuard() {
      if (!this.map || !this.map.on) {
        return
      }
      this.unbindWuyuanMapGuard()
      const handleBoundsChange = () => {
        this.limitWuyuanMapViewport()
      }
      this.wuyuanMapGuardHandlers = {
        dragend: handleBoundsChange,
        zoom_changed: handleBoundsChange
      }
      this.map.on('dragend', handleBoundsChange)
      this.map.on('zoom_changed', handleBoundsChange)
    },
    unbindWuyuanMapGuard() {
      if (!this.map || !this.map.off || !this.wuyuanMapGuardHandlers) {
        this.wuyuanMapGuardHandlers = null
        return
      }
      this.map.off('dragend', this.wuyuanMapGuardHandlers.dragend)
      this.map.off('zoom_changed', this.wuyuanMapGuardHandlers.zoom_changed)
      this.wuyuanMapGuardHandlers = null
    },
    limitWuyuanMapViewport() {
      if (!this.map || this.isWuyuanViewportResetting) {
        return
      }
      const center = this.map.getCenter && this.map.getCenter()
      const minZoom = WUYUAN_MAP_MIN_ZOOM
      const zoom = this.map.getZoom && this.map.getZoom()
      const shouldResetCenter = center && !this.isPointInWuyuanBoundary(center)
      const shouldResetZoom = isFinite(Number(zoom)) && Number(zoom) < minZoom
      if (!shouldResetCenter && !shouldResetZoom) {
        return
      }
      this.isWuyuanViewportResetting = true
      if (shouldResetCenter && this.map.setCenter) {
        this.map.setCenter(new TMap.LatLng(WUYUAN_CENTER.lat, WUYUAN_CENTER.lng))
      }
      if (shouldResetZoom && this.map.setZoom) {
        this.map.setZoom(minZoom)
      }
      this.$nextTick(() => {
        this.isWuyuanViewportResetting = false
      })
    },
    renderWuyuanBoundaryLayer() {
      if (!this.map || !this.boundaryGeometries.length) {
        return
      }

      this.renderWuyuanBoundaryMaskLayer()

      if (this.boundaryLayer && this.boundaryLayer.setMap) {
        this.boundaryLayer.setMap(null)
      }

      const boundaryStyle = new TMap.PolygonStyle({
        color: 'rgba(24, 50, 112, 0.10)',
        showBorder: true,
        borderColor: 'rgba(120, 238, 255, 0.95)',
        borderWidth: 3
      })

      this.boundaryLayer = new TMap.MultiPolygon({
        map: this.map,
        zIndex: 2,
        styles: {
          boundary: boundaryStyle
        },
        geometries: this.boundaryGeometries
      })
    },
    renderWuyuanBoundaryMaskLayer() {
      if (!this.map || !this.boundaryHitPolygons.length) {
        return
      }

      if (this.boundaryMaskLayer && this.boundaryMaskLayer.setMap) {
        this.boundaryMaskLayer.setMap(null)
      }

      const maskStyle = new TMap.PolygonStyle({
        color: 'rgba(3, 9, 25, 0.62)',
        showBorder: false
      })
      const worldRing = [
        { lat: 85, lng: -180 },
        { lat: 85, lng: 180 },
        { lat: -85, lng: 180 },
        { lat: -85, lng: -180 }
      ]
      const maskPaths = [worldRing]
      this.boundaryHitPolygons.forEach(polygon => {
        polygon.forEach(ring => {
          maskPaths.push(ring.slice().reverse())
        })
      })

      this.boundaryMaskLayer = new TMap.MultiPolygon({
        map: this.map,
        zIndex: 1,
        styles: {
          wuyuanMask: maskStyle
        },
        geometries: [{
          id: 'wuyuan-map-mask',
          styleId: 'wuyuanMask',
          paths: maskPaths
        }]
      })
    },
    createDashboardMap() {
      const dashboardMapZoom = Math.max(Number(this.setting.map_show || 0), WUYUAN_MAP_MIN_ZOOM)
      const maxZoom = Math.max(dashboardMapZoom + 2.3, 14)
      const center = new TMap.LatLng(
        WUYUAN_CENTER.lat + Number(this.setting.lat_offset || 0),
        WUYUAN_CENTER.lng + Number(this.setting.lng_offset || 0)
      )
      const mapOptions = {
        zoom: dashboardMapZoom,
        minZoom: dashboardMapZoom,
        maxZoom: maxZoom,
        pitch: 12,
        center: center,
        mapStyleId: 'style3',
        showControl: false,
        baseMap: {
          type: 'vector',
          features: ['base', 'building3d', 'point']
        }
      }

      this.createRestrictedWuyuanMap('migrateMap', mapOptions)
      this.syncDashboardResourceOverlays()
    },
    startWarningPushBoardTimer() {
      this.clearWarningPushBoardTimer()
      this.warningPushBoardVisible = false
      this.warningPushBoardTimer = setTimeout(() => {
        this.warningPushBoardVisible = true
        this.warningPushBoardTimer = null
      }, 5000)
    },
    clearWarningPushBoardTimer() {
      if (this.warningPushBoardTimer) {
        clearTimeout(this.warningPushBoardTimer)
        this.warningPushBoardTimer = null
      }
    },
    closeWarningPushBoard() {
      this.warningPushBoardVisible = false
      this.clearWarningPushBoardTimer()
    },
    createFlvPlayer(videoElement, url, options) {
      if (!videoElement || typeof flvjs === 'undefined' || !flvjs.isSupported()) {
        return null
      }
      var playerOptions = options || {}
      if (playerOptions.muted) {
        videoElement.muted = true
      }
      var player = flvjs.createPlayer({
        type: 'flv',
        url: url,
        isLive: true,
        hasAudio: false,
        hasVideo: true,
        enableStashBuffer: false,
        stashInitialSize: 128,
        lazyLoad: false,
        lazyLoadMaxDuration: 0,
        seekType: 'range',
        cors: true
      })
      player.attachMediaElement(videoElement)
      player.load()
      var playPromise = player.play()
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => { })
      }
      return player
    },
    initSentimentPlayersIfNeeded() {
      if (this.typeIndex !== 3 || this.sentimentPlayers.length) {
        return
      }
      var videoConfigs = [
        { refName: 'sentimentVideoOne', url: SENTIMENT_STREAM_URLS[0] },
        { refName: 'sentimentVideoTwo', url: SENTIMENT_STREAM_URLS[1] }
      ]
      this.sentimentPlayers = videoConfigs.map(item => {
        var videoElement = this.$refs[item.refName]
        var player = this.createFlvPlayer(videoElement, item.url, { muted: true })
        if (!player) {
          return null
        }
        return {
          player: player,
          refName: item.refName
        }
      }).filter(Boolean)
    },
    destroySentimentPlayers() {
      if (!this.sentimentPlayers.length) {
        return
      }
      this.sentimentPlayers.forEach(item => {
        var videoElement = this.$refs[item.refName]
        try {
          if (item.player) {
            item.player.pause()
            item.player.unload()
            item.player.detachMediaElement()
            item.player.destroy()
          }
        } catch (error) {
        }
        if (videoElement) {
          try {
            videoElement.pause()
            videoElement.removeAttribute('src')
            videoElement.load()
          } catch (error) {
          }
        }
      })
      this.sentimentPlayers = []
    },
    initPlayer(url) {
      var videoUrl = url || this.modalVideoUrl || DEFAULT_MONITOR_STREAM_URL
      this.modalVideoUrl = videoUrl
      this.destroyPlayer()
      this.player = this.createFlvPlayer(
        this.$refs.videoElement,
        videoUrl
      )
    },
    openDefaultMonitorVideo() {
      this.openMonitorVideo('篁岭晒秋平台', DEFAULT_MONITOR_STREAM_URL)
    },
    openMonitorVideo(title, url) {
      this.videoTitle = title || '视频监控'
      this.modalVideoUrl = url || DEFAULT_MONITOR_STREAM_URL
      this.videoElementKey += 1
      if (!this.showModal) {
        this.showModal = true
        return
      }
      this.$nextTick(() => {
        this.initPlayer(this.modalVideoUrl)
      })
    },
    closeModal() {
      this.showModal = false
    },
    destroyPlayer() {
      if (this.player) {
        try {
          this.player.pause()
          this.player.unload()
          this.player.detachMediaElement()
          this.player.destroy()
        } catch (error) {
        }
        this.player = null
      }
      if (this.$refs.videoElement) {
        try {
          this.$refs.videoElement.pause()
          this.$refs.videoElement.removeAttribute('src')
          this.$refs.videoElement.load()
        } catch (error) {
        }
      }
    },
    formatWarningCount(value) {
      var num = Number(value)
      if (isNaN(num)) {
        return '0'
      }
      return num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    formatWarningPercent(value) {
      var num = Number(value)
      if (isNaN(num)) {
        return '0.00'
      }
      return num.toFixed(2)
    },
    buildWarningList() {
      var crowdingValue = Number(this.crowding) * Number(this.coefficient_data || 100) / 100
      var ticketValue = Number(this.ticket_of_data) * Number(this.coefficient_data || 100) / 100
      var inParkNum = Number(this.dateInSum.join(''))
      var totalNum = Number(this.dateSum.join(''))
      var crowdingText = '园区承载平稳，请保持现场巡检。'
      var ticketText = '售票压力可控，请持续关注入口排队情况。'

      if (crowdingValue >= 90) {
        crowdingText = '客流已接近承载上限，请立即安排人员进行疏导。'
      } else if (crowdingValue >= 80) {
        crowdingText = '客流处于高位，请提前部署园区分流力量。'
      } else if (crowdingValue >= 60) {
        crowdingText = '客流持续攀升，建议加强重点区域巡查。'
      }

      if (ticketValue >= 90) {
        ticketText = '售票占比过高，请视情况开放备用检票通道。'
      } else if (ticketValue >= 75) {
        ticketText = '售票压力持续走高，建议提前做好游客分流。'
      }

      var warningLength = this.warningList.length
      this.warningList = [
        {
          title: crowdingValue >= 80 ? '客流预警' : '园区承载',
          text: '在园游客饱和度 ' + this.formatWarningPercent(crowdingValue) + '%，' + crowdingText
        },
        {
          title: ticketValue >= 75 ? '售票预警' : '售票监测',
          text: '当日售票占比 ' + this.formatWarningPercent(ticketValue) + '%，' + ticketText
        },
        {
          title: '实时客流',
          text: '当前在园游客 ' + this.formatWarningCount(inParkNum) + ' 人，今日累计入园 ' + this.formatWarningCount(totalNum) + ' 人。'
        }
      ]

      if (this.warningCurrentIndex >= this.warningList.length) {
        this.warningCurrentIndex = 0
      }
      if (warningLength !== this.warningList.length) {
        this.startWarningScroll()
      } else if (!this.warningTimer && this.warningList.length > 1) {
        this.startWarningScroll()
      } else if (this.warningList.length <= 1) {
        this.stopWarningScroll()
      }
    },
    startWarningScroll() {
      this.stopWarningScroll()
      if (this.warningList.length <= 1) {
        return
      }
      let _this = this
      this.warningTimer = setInterval(function () {
        _this.warningCurrentIndex = (_this.warningCurrentIndex + 1) % _this.warningList.length
      }, 3000)
    },
    stopWarningScroll() {
      if (this.warningTimer) {
        clearInterval(this.warningTimer)
        this.warningTimer = null
      }
    },
    initVoiceRecognitionSupport() {
      this.voiceRecognitionSupported = !!(
        XfyunSpeechRecognizer &&
        typeof XfyunSpeechRecognizer.isSupported === 'function' &&
        XfyunSpeechRecognizer.isSupported()
      )
    },
    ensureVoiceRecognition() {
      if (this.voiceRecognition) {
        return this.voiceRecognition
      }
      if (!this.voiceRecognitionSupported) {
        return null
      }
      var recognition = createXfyunSpeechRecognizer({
        eos: VOICE_RECOGNITION_EOS_MS
      })
      recognition.on('start', () => {
        if (this.voiceRecognition !== recognition) {
          return
        }
        this.voiceStarting = false
        this.voiceListening = true
        this.voiceKeepListening = true
        this.voiceCommandHandled = false
        this.voiceEndReason = ''
        this.voiceSuppressEndStatus = false
        this.setVoiceStatus('语音持续监听中，请讲话', 'listening', true)
      })
      recognition.on('partialResult', payload => {
        if (this.voiceRecognition !== recognition || !this.voiceListening) {
          return
        }
        if (payload && payload.text) {
          if (this.handleVoiceRecognitionText(payload.text, { isPartial: true })) {
            return
          }
          this.setVoiceStatus('正在识别中', 'listening', true)
        }
      })
      recognition.on('finalResult', payload => {
        if (this.voiceRecognition !== recognition || this.voiceCommandHandled) {
          return
        }
        this.handleVoiceRecognitionText(payload && payload.text ? payload.text : '', {
          isPartial: false
        })
      })
      recognition.on('error', payload => {
        if (this.voiceRecognition !== recognition) {
          return
        }
        this.handleVoiceRecognitionError(payload)
      })
      recognition.on('close', () => {
        if (this.voiceRecognition !== recognition) {
          return
        }
        if (!this.voiceListening && !this.voiceStarting) {
          return
        }
        if (this.voiceKeepListening && this.voiceEndReason !== 'manual') {
          this.destroyVoiceRecognitionInstance({ preserveStatus: true, keepListening: true })
          this.setVoiceStatus('语音持续监听中', 'listening', true)
          this.scheduleVoiceRecognitionRestart()
          return
        }
        this.setVoiceStatus('语音连接已关闭，请重试', 'warning')
        this.destroyVoiceRecognitionInstance({ preserveStatus: true })
      })
      this.voiceRecognition = recognition
      return recognition
    },
    toggleVoiceRecognition() {
      if (this.voiceKeepListening || this.voiceListening || this.voiceStarting) {
        this.stopVoiceRecognition('manual')
        return
      }
      this.startVoiceRecognition()
    },
    async startVoiceRecognition() {
      if (this.voiceListening || this.voiceStarting) {
        return
      }
      this.voiceKeepListening = true
      this.clearVoiceRestartTimer()
      this.clearVoiceStatusTimer()
      var recognition = this.ensureVoiceRecognition()
      if (!recognition) {
        this.voiceRecognitionSupported = false
        this.voiceKeepListening = false
        this.setVoiceStatus('当前环境不支持讯飞语音识别', 'error')
        return
      }
      this.voiceCommandHandled = false
      this.voiceEndReason = ''
      this.voiceSuppressEndStatus = false
      this.voiceListening = false
      this.voiceStarting = true
      this.setVoiceStatus('正在启动语音监听', 'info', true)
      try {
        await recognition.startListening()
        if (this.voiceRecognition !== recognition) {
          return
        }
      } catch (error) {
        if (this.voiceRecognition !== recognition || this.voiceEndReason === 'manual') {
          return
        }
        this.voiceStarting = false
        this.voiceListening = false
        if (this.voiceKeepListening && !this.shouldStopVoiceRecognitionOnError(error)) {
          this.destroyVoiceRecognitionInstance({ preserveStatus: true, keepListening: true })
          this.setVoiceStatus(this.getVoiceErrorMessage(error) + '，正在重新连接', 'warning', true)
          this.scheduleVoiceRecognitionRestart(1200)
          return
        }
        this.voiceKeepListening = false
        this.destroyVoiceRecognitionInstance({ preserveStatus: true })
        this.setVoiceStatus(this.getVoiceErrorMessage(error), 'error')
      }
    },
    stopVoiceRecognition(reason) {
      var wasActive = this.voiceRecognition || this.voiceListening || this.voiceStarting || this.voiceRestartTimer || this.voiceKeepListening
      this.voiceEndReason = reason || ''
      this.voiceKeepListening = false
      this.clearVoiceRestartTimer()
      if (!wasActive) {
        return
      }
      if (reason === 'manual') {
        this.setVoiceStatus('已停止监听', 'info')
      } else if (reason === 'no-match') {
        this.setVoiceStatus('未识别到有效指令', 'warning')
      }
      this.destroyVoiceRecognitionInstance({ preserveStatus: true })
    },
    handleVoiceRecognitionText(text, options) {
      console.log('语音识别结果：', text)
      var matchOptions = options || {}
      var matched = findVoiceCommandMatch(text, {
        preventPrefixOnlyMatch: !!matchOptions.isPartial
      })
      if (!matched || !matched.command) {
        if (!matchOptions.isPartial) {
          this.restartVoiceRecognitionSession('未识别到有效指令，继续监听', 'warning')
        }
        return false
      }
      this.voiceCommandHandled = true
      this.destroyVoiceRecognitionInstance({ preserveStatus: true, keepListening: this.voiceKeepListening })
      this.executeVoiceCommand(matched.command)
      this.scheduleVoiceRecognitionRestart(600)
      return true
    },
    handleVoiceRecognitionError(payload) {
      var error = payload && payload.error ? payload.error : payload
      if (this.voiceKeepListening && !this.shouldStopVoiceRecognitionOnError(error)) {
        this.destroyVoiceRecognitionInstance({ preserveStatus: true, keepListening: true })
        this.setVoiceStatus(this.getVoiceErrorMessage(error) + '，正在重新连接', 'warning', true)
        this.scheduleVoiceRecognitionRestart(1200)
        return
      }
      this.setVoiceStatus(this.getVoiceErrorMessage(error), 'error')
      this.destroyVoiceRecognitionInstance({ preserveStatus: true })
    },
    shouldStopVoiceRecognitionOnError(error) {
      if (!error) {
        return false
      }
      if (
        error.name === 'NotAllowedError' ||
        error.name === 'PermissionDeniedError' ||
        error.name === 'NotFoundError' ||
        error.name === 'DevicesNotFoundError'
      ) {
        return true
      }
      var message = error.message || String(error)
      return (
        message.indexOf('不支持') !== -1 ||
        message.indexOf('权限') !== -1 ||
        message.indexOf('未检测到') !== -1 ||
        message.indexOf('缺少') !== -1 ||
        message.indexOf('鉴权') !== -1 ||
        message.indexOf('签名') !== -1 ||
        message.indexOf('APIKey') !== -1 ||
        message.indexOf('APISecret') !== -1 ||
        message.indexOf('AppID') !== -1
      )
    },
    getVoiceErrorMessage(error) {
      if (!error) {
        return '语音识别失败，请重试'
      }
      if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
        return '麦克风权限未开启'
      }
      if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
        return '未检测到可用麦克风'
      }
      var message = error.message || String(error)
      if (message.indexOf('当前环境不支持前端签名') !== -1) {
        return '当前环境不支持讯飞语音鉴权'
      }
      if (message.indexOf('当前浏览器不支持') !== -1 || message.indexOf('不支持讯飞语音识别所需能力') !== -1) {
        return '当前环境不支持讯飞语音识别'
      }
      if (message.indexOf('连接失败') !== -1 || message.indexOf('连接已关闭') !== -1) {
        return '语音识别服务连接失败'
      }
      if (message.indexOf('麦克风采集') !== -1) {
        return '当前浏览器不支持麦克风采集'
      }
      return message || '语音识别失败，请重试'
    },
    executeVoiceCommand(command) {
      if (!command) {
        return
      }
      if (command.action === 'switchType') {
        this.executeVoiceTypeSwitch(command)
        return
      }
      if (command.action === 'changeDate') {
        this.setVoiceStatus('正在执行指令：' + command.label, 'success')
        this.changeTheDate(command.payload.day)
        return
      }
      if (command.action === 'openBusRouteViewer') {
        this.executeVoiceBusRouteCommand()
        return
      }
      if (command.action === 'playCamera') {
        this.executeVoiceCameraCommand(command)
        return
      }
    },
    executeVoiceTypeSwitch(command) {
      var targetTypeIndex = command && command.payload ? command.payload.typeIndex : this.typeIndex
      if (this.typeIndex === targetTypeIndex) {
        this.setVoiceStatus('当前已在' + this.getVoiceTypeLabel(targetTypeIndex), 'success')
        return
      }
      this.setVoiceStatus('正在执行指令：' + command.label, 'success')
      this.typeChange(targetTypeIndex)
    },
    executeVoiceBusRouteCommand() {
      this.setPendingVoiceAction('open-bus-route-viewer')
      if (this.typeIndex !== 4) {
        this.setVoiceStatus('正在执行指令：打开公交路线图', 'success')
        this.typeChange(4)
        return
      }
      this.$nextTick(() => {
        this.consumePendingVoiceAction(0)
      })
    },
    executeVoiceCameraCommand(command) {
      var cameraName = command && command.payload ? command.payload.cameraName : ''
      var cameraUrl = command && command.payload ? command.payload.cameraUrl : ''
      if (!cameraUrl) {
        this.setVoiceStatus('未找到该摄像头的视频源', 'warning')
        return
      }
      this.setVoiceStatus('正在执行指令：' + command.label, 'success')
      this.playCameraVideo(cameraName, cameraUrl)
    },
    playCameraVideo(cameraName, cameraUrl) {
      this.openMonitorVideo(cameraName || '视频监控', cameraUrl)
      this.$nextTick(() => {
        if (!this.player) {
          this.setVoiceStatus('视频播放器初始化失败，请检查浏览器兼容性', 'warning')
        }
      })
    },
    getVoiceTypeLabel(typeIndex) {
      var typeLabelMap = {
        0: '文旅市场页面',
        1: '客流分析页面',
        2: '大数据驾驶舱页面',
        3: '舆情分析页面',
        4: '客流预警页面',
        5: '业态资源页面',
        6: '决策分析页面',
        7: '客群画像分析页面',
        8: '价格监管页面'
      }
      return typeLabelMap[typeIndex] || '当前页面'
    },
    restartVoiceRecognitionSession(text, tone) {
      if (!this.voiceKeepListening) {
        return
      }
      this.destroyVoiceRecognitionInstance({ preserveStatus: true, keepListening: true })
      this.setVoiceStatus(text || '语音持续监听中', tone || 'listening')
      this.scheduleVoiceRecognitionRestart(600)
    },
    scheduleVoiceRecognitionRestart(delay) {
      if (!this.voiceKeepListening) {
        return
      }
      this.clearVoiceRestartTimer()
      this.voiceRestartTimer = setTimeout(() => {
        this.voiceRestartTimer = null
        if (!this.voiceKeepListening || this.voiceListening || this.voiceStarting) {
          return
        }
        this.startVoiceRecognition()
      }, typeof delay === 'number' ? delay : 300)
    },
    clearVoiceRestartTimer() {
      if (this.voiceRestartTimer) {
        clearTimeout(this.voiceRestartTimer)
        this.voiceRestartTimer = null
      }
    },
    clearVoiceStatusTimer() {
      if (this.voiceStatusTimer) {
        clearTimeout(this.voiceStatusTimer)
        this.voiceStatusTimer = null
      }
    },
    setVoiceStatus(text, tone, persistent) {
      this.voiceStatusText = text
      this.voiceStatusTone = tone || 'info'
      this.voiceStatusVisible = true
      this.clearVoiceStatusTimer()
      if (persistent) {
        return
      }
      this.voiceStatusTimer = setTimeout(() => {
        this.voiceStatusVisible = false
      }, VOICE_STATUS_HIDE_MS)
    },
    setPendingVoiceAction(actionId) {
      sessionStorage.setItem(VOICE_PENDING_ACTION_KEY, JSON.stringify({
        actionId: actionId,
        createdAt: Date.now()
      }))
    },
    getPendingVoiceAction() {
      var pendingAction = sessionStorage.getItem(VOICE_PENDING_ACTION_KEY)
      if (!pendingAction) {
        return null
      }
      try {
        return JSON.parse(pendingAction)
      } catch (error) {
        sessionStorage.removeItem(VOICE_PENDING_ACTION_KEY)
        return null
      }
    },
    clearPendingVoiceAction() {
      sessionStorage.removeItem(VOICE_PENDING_ACTION_KEY)
    },
    consumePendingVoiceAction(retryCount) {
      var pendingAction = this.getPendingVoiceAction()
      if (!pendingAction) {
        return
      }
      if (!pendingAction.createdAt || Date.now() - pendingAction.createdAt > 5 * 60 * 1000) {
        this.clearPendingVoiceAction()
        return
      }
      if (pendingAction.actionId !== 'open-bus-route-viewer' || this.typeIndex !== 4) {
        return
      }
      var embeddedWarning = this.$refs.embeddedWarning
      if (!embeddedWarning || typeof embeddedWarning.openBusRouteViewer !== 'function') {
        if (retryCount < 8) {
          setTimeout(() => {
            this.consumePendingVoiceAction(retryCount + 1)
          }, 250)
        }
        return
      }
      this.clearPendingVoiceAction()
      embeddedWarning.openBusRouteViewer()
      this.setVoiceStatus('已打开公交路线图', 'success')
    },
    destroyVoiceRecognitionInstance(options) {
      var destroyOptions = options || {}
      var recognition = this.voiceRecognition
      if (!destroyOptions.keepListening) {
        this.voiceKeepListening = false
      }
      if (!destroyOptions.keepListening) {
        this.clearVoiceRestartTimer()
      }
      this.voiceListening = false
      this.voiceStarting = false
      this.voiceCommandHandled = false
      this.voiceEndReason = ''
      this.voiceSuppressEndStatus = false
      this.voiceRecognition = null
      if (recognition) {
        try {
          recognition.removeAllListeners()
        } catch (error) {
        }
        try {
          recognition.destroy()
        } catch (error) {
        }
      }
      if (!destroyOptions.preserveStatus) {
        this.clearVoiceStatusTimer()
        this.voiceStatusVisible = false
      }
    },
    destroyVoiceRecognition() {
      this.destroyVoiceRecognitionInstance()
    },
    // 系数
    getCoefficientDataSetting() {
      getCoefficientDataSettingApi({ scenic_id: this.scenic_id }).then(res => {
        // if (res.data.data.coefficient_data) {
        //   this.coefficient_data = res.data.data.coefficient_data
        // }
        if (this.typeIndex === 0) {
          this.getSettingById();
          this.type_index()
        } else if (this.typeIndex === 1) {
          this.getSettingById();
          this.type_user()
        } else if (this.typeIndex === 2) {
          this.getSettingById();
          this.type_revenue()
        } else if (this.typeIndex === 3) {
          this.getSettingById();
          this.getTimeTrend()
          this.handleGetList()
          this.tendenciesScroll()
        } else if (this.typeIndex === 5) {
          this.getSettingById();
          this.type_business_resource()
        } else if (this.typeIndex === 6) {
          this.getSettingById()
          this.type_decision()
        } else if (this.typeIndex === PRICE_SUPERVISION_TYPE_INDEX) {
          this.getSettingById();
          this.type_price_supervision()
        } else if (this.typeIndex === 7) {
          this.getSettingById();
          this.typeTouristProfile()
        }
      })
    },
    prevImage(index) {
      this.actIndex--
      this.$refs.imagesList[index].style.marginLeft = `-${this.actIndex * 114}px`
    },
    nextImage(index) {
      this.actIndex++
      this.$refs.imagesList[index].style.marginLeft = `-${this.actIndex * 114}px`
    },
    isDataShow(state) {
      this.isYearSumShow = !state
    },
    type_index() {
      //调用接口
      this.getUserPortraitData()
      this.getTouristsDataNew()
      this.getTouristsData();
      this.getGenderSchedule();
      this.getWeatherData();
      this.getOriginList();
      // this.getEnrollmentTime();
      // this.getTicketNumberStatistics();
      // this.getCurrentTrafficTrend();
      // this.getRealTimeTraffic();
      this.getHistoryData();

      // this.getTouristAgencyType()
      this.getVisitorTrendData()
      this.getScenicRankingData()
      let _this = this;
      setInterval(function () {
        _this.getTouristsData('change');
        _this.getTouristsDataNew()
      }, 5000)
    },
    type_user() {
      this.getTouristsDataNew()
      this.getScenicRankingData()
      this.getUserPortraitData()
      // this.getCurrentTrafficTrend();
      this.getAnalysisMonth()
      // this.getGenderSchedule()
      // this.getTicketNumberStatistics();
      this.getOriginList()
      this.getWeatherData();
      this.getVisitorTrendData()
      // this.flight_coordinates(1)
      this.getScenicHourlyData()
    },
    type_revenue() {
      // this.changeTheDate('last')
      // this.getTradingNum()
      // this.getTouristAgencyType()
      this.getSalesNum()
      this.getBusinessNum()
      this.getBusinessList()
      this.getBigDataOfflineRetail()
      // this.salesComparison()
      this.xcxGetHotelData()
      this.getDeliciousFoodData()
      this.getTradingNum_bar()
      this.getScenicRankingData()
      this.getVisitorTrendData()
      this.getWeatherData();
      this.getData()
    },
    type_business_resource() {
      this.getWeatherData()
      this.getMapResourceList()
    },
    type_decision() {
      this.getScenicHourlyData()
      this.getOriginList()
      this.getAnalysisMonth()
      this.getTouristsDataNew()
      this.getWeatherData();
    },
    typeTouristProfile() {
      this.getWeatherData();
      this.getUserPortraitData()
      this.getAnalysisMonth()
      this.getTravelMode()
      this.getLevel(1)
    },
    getScenicHourlyData() {
      scenicHourlyData({
        date: this.req_date
      }).then(res => {
        console.log(res.data.data, '测试接口，看看')
        var categories = []
        var series = []
        const today = new Date();
        if (!this.req_date) {
          const hour = today.getHours()
          res.data.data.categories.forEach(item => {
            if (item <= hour) {
              categories.push(item)
            }
          })
          for (var i = 0; i < res.data.data.series.length; i++) {
            series.push({
              name: res.data.data.series[i].name,
              data: res.data.data.series[i].data.slice(0, categories.length)
            })
          }
        }

        this.getInTime({ categories: categories, series: series })
      })
    },
    //根据ID获取景区大数据参数设置详情
    getSettingById() {
      getSettingByIdApi({
        scenic_id: this.scenic_id,
      }).then(res => {
        this.setting = res.data.data;
        if (this.req_date && this.req_date != '' && this.req_date != this.nowDay2) {
          this.isToday = false;
        } else {
          let _this = this;
          setInterval(function () {
            _this.getTouristsData();
            _this.getTouristsDataNew()
            _this.getWeatherData(1);
            _this.getToday();
            // _this.getWaitingIn()
          }, this.setting.first_refresh_time * 60 * 1000)
          setInterval(function () {
            // _this.getTicketNumberStatistics();
          }, this.setting.second_refresh_time * 60 * 1000)
          setInterval(function () {
            _this.originIndex = 0;
            _this.getUserPortraitData()
            _this.getOriginList();
            // _this.getGenderSchedule(1);

            // _this.getCurrentTrafficTrend();

          }, this.setting.third_refresh_time * 60 * 1000)

        }
      })
    },
    //获取星期几
    getWeek(day) {
      switch (day) {
        case 0:
          return '周日'

        case 1:
          return '周一'

        case 2:
          return '周二'

        case 3:
          return '周三'

        case 4:
          return '周四'

        case 5:
          return '周五'

        case 6:
          return '周六'

      }
    },
    // 30天客流趋势
    getVisitorTrendData() {
      visitorTrendData({
        date: this.req_date,
        days: 30
      }).then(res => {
        console.log(res, '30天')
        var trend = res.data.data.trend
        this.trend_list = []
        this.real_time_traffic_list = {
          time_list: [],
          data_list: []
        }

        for (var i = 0; i < trend.length; i++) {
          if (i < 1) {
            this.real_time_traffic_list.time_list.push(trend[i].date)
            this.real_time_traffic_list.data_list.push(trend[i].count)
          } else {
            var length = this.real_time_traffic_list.data_list.length - 1
            if (this.real_time_traffic_list.time_list[length] == trend[i].date) {
              this.real_time_traffic_list.data_list[length] += trend[i].count
            } else {
              this.real_time_traffic_list.time_list.push(trend[i].date)
              this.real_time_traffic_list.data_list.push(trend[i].count)
            }
          }
        }
        this.real_time_traffic_list.time_list.reverse()
        this.real_time_traffic_list.data_list.reverse()
        var today_hourly = res.data.data.today_hourly
        const today = new Date();
        this.current_traffic_trend = {
          categories: [],
          series: [],
        }
        if (!this.req_date) {
          const hour = today.getHours()
          console.log(hour, 'hoiur')
          today_hourly.categories.forEach(item => {
            if (item <= hour) {
              this.current_traffic_trend.categories.push(item)
            }
          })
          for (var i = 0; i < today_hourly.series.length; i++) {
            this.current_traffic_trend.series.push({
              name: today_hourly.series[i].name,
              data: today_hourly.series[i].data.slice(0, this.current_traffic_trend.categories.length)
            })
          }
        } else {
          const target = new Date(this.req_date);
          if (target.setHours(0, 0, 0, 0) < today.setHours(0, 0, 0, 0)) {
            this.current_traffic_trend = {
              categories: JSON.parse(JSON.stringify(today_hourly.categories)),
              series: JSON.parse(JSON.stringify(today_hourly.series)),
            }
          } else {
            const hour = today.getHours()
            console.log(hour, 'hoiur')
            today_hourly.categories.forEach(item => {
              if (item <= hour) {
                this.current_traffic_trend.categories.push(item)
              }
            })
            for (var i = 0; i < today_hourly.series.length; i++) {
              this.current_traffic_trend.series.push({
                name: today_hourly.series[i].name,
                data: today_hourly.series[i].data.slice(0, this.current_traffic_trend.categories.length)
              })
            }
          }
        }
        this.getTouristLine()
        this.getInOrOut();
        this.showPeakLine(this.current_traffic_trend)
      })
    },
    // 景区排行
    getScenicRankingData() {
      scenicRankingData({
        date: this.req_date
      }).then(res => {
        console.log(res.data.data, '景区排行')
        if (this.typeIndex == 2) {
          this.setInParkRanking(res.data.data)
          this.setOnParkRanking(res.data.data)
        } else {
          this.setScenicRankingData(res.data.data)
        }
      })
    },
    setScenicRankingData(data) {
      var color = ['#FF00FF', '#FF69B4', '#FFD700', '#32CD32', '#00CED1', '#1E90FF', '#4169E1', '#8A2BE2']
      var chartData = []
      var categories = []
      var series_data = []
      var total = 0
      for (var i = 0; i < data.length; i++) {
        var entry_today = data[i].entry_today
        if (data[i].scenic_name == '篁岭') {
          entry_today = (data[i].entry_today * 0.85).toFixed(0)
        }
        chartData.push({
          value: entry_today, // 今日入园人数
          name: data[i].scenic_name,
          itemStyle: { color: color[i] }
        })
        categories.push(data[i].scenic_name)
        series_data.push(entry_today)
        total += entry_today
      }
      var categories_1 = JSON.parse(JSON.stringify(categories))
      var series_data_1 = JSON.parse(JSON.stringify(series_data))
      categories_1.reverse()
      series_data_1.reverse()
      // var scenic_ranking = this.echarts.init(document.getElementById('scenic_ranking'));
      const option = {
        padding: [0, 0, 0, 0],
        series: [
          {
            type: 'pie',
            // radius: '50%',
            data: chartData,
            radius: [12, 60],
            roseType: 'area',
            itemStyle: {
              borderRadius: 8
            },
            center: ['50%', '30%'],
            label: {
              show: false
            }
          }
        ],
        toolbox: {
          show: true
        },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return params.data.name + ":<br/>" + ((params.data.value / total) * 100).toFixed(1) + '%'
          },
        },
        legend: {
          bottom: '20',
          left: 'center',
          icon: 'roundRect',
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          data: chartData.map(item => item.name)
        },
      }
      // scenic_ranking.setOption(option)
      var scenic_ranking_list = this.echarts.init(document.getElementById('scenic_ranking_list'));
      var scenic_ranking_list_1 = this.echarts.init(document.getElementById('scenic_ranking_list_1'));
      var option_list = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          top: '0',
          left: '0',
          right: '10%',
          bottom: '6%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLabel: {
            textStyle: {
              color: '#ffffff',
              fontSize: 8      //更改坐标轴文字大小
            }
          },
        },
        yAxis: {
          type: 'category',
          data: categories_1,
          axisLabel: {
            textStyle: {
              color: '#ffffff',
              fontSize: 10      //更改坐标轴文字大小
            },
            formatter: function (value) {
              return value.slice(0, 5);
            }
          }
        },
        series: [
          {
            name: '',
            type: 'bar',
            data: series_data_1,
            itemStyle: {
              color: "#0437ea"
            }
          }
        ]
      }
      scenic_ranking_list.setOption(option_list)
      scenic_ranking_list_1.setOption(option_list)
      var touristType_1 = this.echarts.init(document.getElementById('touristType_1'));

      var touristType_option = {
        grid: {
          top: "10%",
          left: "15%",
          right: "4%",
          bottom: "25%"
        },
        tooltip: {
          formatter: function (params) {
            return params.data
          }
        },
        xAxis: {
          data: categories,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#8184a2',
              fontSize: 8      //更改坐标轴文字大小
            }
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          axisLabel: {
            show: true,
            formatter: '{value}',
            textStyle: {
              color: '#8184a2',
              fontSize: 10      //更改坐标轴文字大小
            }
          },
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          }
        },
        series: [
          {
            type: 'bar',
            color: '#023aff',
            data: series_data,
            barWidth: 10
          },
        ]
      }
      touristType_1.setOption(touristType_option)
    },
    setOnParkRanking(data) {
      var categories = []
      var series_data = []
      for (var i = 0; i < data.length; i++) {
        categories.push(data[i].scenic_name)
        series_data.push(data[i].in_park)
      }
      categories.reverse()
      series_data.reverse()
      var option_list = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          top: '0',
          left: '0',
          right: '10%',
          bottom: '6%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLabel: {
            textStyle: {
              color: '#ffffff',
              fontSize: 10     //更改坐标轴文字大小
            }
          },
        },
        yAxis: {
          type: 'category',
          data: categories,
          axisLabel: {
            textStyle: {
              color: '#ffffff',
              fontSize: 10      //更改坐标轴文字大小
            },
            formatter: function (value) {
              return value.slice(0, 5);
            }
          }
        },
        series: [
          {
            name: '',
            type: 'bar',
            data: series_data,
            itemStyle: {
              color: "#0437ea"
            },
            label: {
              show: true,
              position: 'right',
              color: '#ffffff'
            }
          }
        ]
      }
      var on_ranking_list = this.echarts.init(document.getElementById('on_ranking_list'));
      on_ranking_list.setOption(option_list)
    },
    setInParkRanking(data) {
      var categories = []
      var series_data = []
      for (var i = 0; i < data.length; i++) {
        var entry_today = data[i].entry_today
        if (data[i].scenic_name == '篁岭') {
          entry_today = (data[i].entry_today * 0.85).toFixed(0)
        }
        categories.push(data[i].scenic_name)
        series_data.push(entry_today)
      }
      categories.reverse()
      series_data.reverse()
      var option_list = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          top: '0',
          left: '0',
          right: '10%',
          bottom: '6%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLabel: {
            textStyle: {
              color: '#ffffff',
              fontSize: 10     //更改坐标轴文字大小
            }
          },
        },
        yAxis: {
          type: 'category',
          data: categories,
          axisLabel: {
            textStyle: {
              color: '#ffffff',
              fontSize: 10      //更改坐标轴文字大小
            },
            formatter: function (value) {
              return value.slice(0, 5);
            }
          }
        },
        series: [
          {
            name: '',
            type: 'bar',
            data: series_data,
            itemStyle: {
              color: "#0437ea"
            },
            label: {
              show: true,
              position: 'right',
              color: '#ffffff'
            }
          }
        ]
      }
      var in_ranking_list = this.echarts.init(document.getElementById('in_ranking_list'));
      in_ranking_list.setOption(option_list)
    },
    //切换类型
    focusPrice() {
      this.isShowType = true;
    },
    blurPrice() {
      this.isShowType = false;
    },
    changeOrigin(index) {
      this.originIndex = index;
      this.isShowType = false;
      this.getOriginList()
      this.getUserPortraitData()
    },
    //点击头部切换类型
    typeChange(index) {
      this.typeIndex = index;
      this.$router.push({ path: '/', query: { id: this.scenic_id, date: this.req_date, typeIndex: this.typeIndex, token: store.state.token } })
      this.$router.go(0)
    },
    // 获取是否需额外的IOT数据
    getIotAppendData(params) {
      if (this.IotAppendDataCache == null) {
        return iotSettingData(params).then(res => {
          this.IotAppendDataCache = res.data.data.mini_program_data || []
          return this.IotAppendDataCache || []
        })
      } else {
        return Promise.resolve(this.IotAppendDataCache)
      }
    },
    //获取实时游客数据
    getTouristsDataNew() {
      todayVisitorsData({
        date: this.req_date
      }).then(res => {
        this.county_total_value = (res.data.data.county_total.value * 4.9).toFixed(0)
        this.getTradingNum()
        this.dateSum = (res.data.data.county_total.value * 4.9).toFixed(0).toString().split('');
        if (6 - this.dateSum.length > 0) {
          var dateArr = []
          for (let i = 0; i < 6 - this.dateSum.length; i++) {
            dateArr.unshift('0')
          }
          this.dateSum.unshift(...dateArr)
        }
      })
    },
    getTouristsData(data) {
      realTouristsWYData({
        dates: this.req_date
      }).then(res => {
        this.yearSum = (res.data.data.year.county_total * this.coefficient_data / 100).toFixed(0).toString().split('');
        this.carSum = (res.data.data.year.county_total * this.coefficient_data / 100 / 13.9).toFixed(0).toString().split('');
        this.realTourists_data = res.data.data
        //不够位数前面补零
        if (8 - this.yearSum.length > 0) {
          var yearArr = []
          for (let i = 0; i < 8 - this.yearSum.length; i++) {
            yearArr.unshift('0')
          }
          this.yearSum.unshift(...yearArr)
        }
        if (8 - this.carSum.length > 0) {
          var yearArr = []
          for (let i = 0; i < 8 - this.carSum.length; i++) {
            yearArr.unshift('0')
          }
          this.carSum.unshift(...yearArr)
        }
        if (5 - this.dateInSum.length > 0) {
          var dateInArr = []
          for (let i = 0; i < 5 - this.dateInSum.length; i++) {
            dateInArr.unshift('0')
          }
          this.dateInSum.unshift(...dateInArr)
        }
        if (5 - this.dateOutSum.length > 0) {
          var dateInArr = []
          for (let i = 0; i < 5 - this.dateOutSum.length; i++) {
            dateInArr.unshift('0')
          }
          this.dateOutSum.unshift(...dateInArr)
        }
      })
      realTouristsData({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        return this.getIotAppendData({ scenic_biz: this.scenic_id, }).then(appendDataList => {
          if (appendDataList.find(item => item === 'villager_in_out')) {
            return getIotScenicVillageRealData({ scenic_id: this.scenic_id, dates: this.req_date }).then(realRes => {
              res.data.data.total_tourists_num += realRes.data.data.total_tourists_num
              res.data.data.out_park_num += realRes.data.data.villager_out_num
              res.data.data.mouth_tourists_num += realRes.data.data.month_villager_num
              res.data.data.years_tourists_num += realRes.data.data.year_villager_num

              var in_tourists_num = res.data.data.total_tourists_num - res.data.data.out_park_num
              res.data.data.in_tourists_num = in_tourists_num > 0 ? in_tourists_num : 0
              return res
            })
          } else {
            return res
          }
        })
      }).then(res => {
        // if (data == 'change') {
        //   this.dateSum =  res.data.data.total_tourists_num.toString().split('');
        //   if(6-this.dateSum.length>0){
        //     var dateArr = []
        //     for(let i=0;i<6-this.dateSum.length;i++){
        //       dateArr.unshift('0')
        //     }
        //     this.dateSum.unshift(...dateArr)
        //   }
        //   return
        // }
        // if (this.scenic_id == 'e7bfd798d9ca461c9f37a4191d55edea') {
        //   this.yearSum = (res.data.data.years_tourists_num * this.coefficient_data / 100 + 330000).toFixed(0).toString().split('');
        // } else {
        //   this.yearSum = (res.data.data.years_tourists_num * this.coefficient_data / 100).toFixed(0).toString().split('');
        // }
        // this.dateSum =  (res.data.data.total_tourists_num * this.coefficient_data / 100).toFixed(0).toString().split('');
        this.dateInSum = (res.data.data.in_tourists_num * this.coefficient_data / 100).toFixed(0).toString().split('');
        this.dateOutSum = (res.data.data.out_park_num * this.coefficient_data / 100).toFixed(0).toString().split('');
        this.crowding = res.data.data.crowding.replace('%', '');
        this.ticket_of_data = res.data.data.ticket_of_data.replace('%', '');
        this.mouth_tourists_num = (res.data.data.mouth_tourists_num * this.coefficient_data / 100).toFixed(0);
        this.total_tourists_num = (res.data.data.total_tourists_num * this.coefficient_data / 100).toFixed(0);
        this.free_check_gate_record_num = (res.data.data.free_check_gate_record_num * this.coefficient_data / 100).toFixed(0);

        // if (6 - this.dateSum.length > 0) {
        //   var dateArr = []
        //   for (let i = 0; i < 6 - this.dateSum.length; i++) {
        //     dateArr.unshift('0')
        //   }
        //   this.dateSum.unshift(...dateArr)
        // }

        if (data != 'change') {
          // this.getWaitingIn()
        }
      });
    },
    // 首页大屏 - 用户画像
    getUserPortraitData() {
      userPortraitData({
        scenic_id: this.scenic_id,
        date: this.req_date
      }).then(res => {
        console.log(res.data.data, '首页大屏 - 用户画像getUserPortraitData')
        this.gender = res.data.data.age_range
        this.gender.male = res.data.data.gender.male
        this.gender.female = res.data.data.gender.female
        this.getGender(res.data.data.gender);
      })
    },
    //获取历史游客数据
    getHistoryData() {
      var yesterday_tourists_num = 0
      var last_month_villager_num = 0
      var last_years_tourists_num = 0
      historyTouristsData({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        yesterday_tourists_num = (res.data.data.yesterday_tourists_num * this.coefficient_data / 100).toFixed(0);
        this.last_mouth_tourists_num = (res.data.data.last_mouth_tourists_num * this.coefficient_data / 100).toFixed(0);
        if (this.scenic_id == 'e7bfd798d9ca461c9f37a4191d55edea') {
          last_years_tourists_num = (res.data.data.last_years_tourists_num * this.coefficient_data / 100 + 220000).toFixed(0);
        } else {
          last_years_tourists_num = (res.data.data.last_years_tourists_num * this.coefficient_data / 100).toFixed(0);
        }
      }).then(res => {
        this.getIotAppendData({ scenic_biz: this.scenic_id, }).then(appendDataList => {

          if (appendDataList.find(item => item === 'villager_in_out')) {
            getIotScenicHistoryData({ scenic_id: this.scenic_id, dates: this.req_date }).then(res => {
              this.yesterday_tourists_num = Number(yesterday_tourists_num) + Number((res.data.data.yesterday_villager_in_num * this.coefficient_data / 100).toFixed(0));
              this.last_month_villager_num = Number(last_month_villager_num) + Number((res.data.data.last_month_villager_num * this.coefficient_data / 100).toFixed(0));
              this.last_years_tourists_num = Number(last_years_tourists_num) + Number((res.data.data.last_year_villager_num * this.coefficient_data / 100).toFixed(0));
            })
          } else {
            this.yesterday_tourists_num = yesterday_tourists_num
            this.last_month_villager_num = last_month_villager_num
            this.last_years_tourists_num = last_years_tourists_num
          }
        })
      })
    },
    //获取游客性别及时间安排
    getGenderSchedule(i) {
      genderScheduleData({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        this.gender = res.data.data.gender;
        this.schedule = res.data.data.schedule;
        // var total = res.data.data.matinee_evening.matinee + res.data.data.matinee_evening.evening
        // if(total>0){
        // 	this.matinee = (res.data.data.matinee_evening.matinee/total*100).toFixed(2)
        // 	this.evening = (res.data.data.matinee_evening.evening/total*100).toFixed(2)
        // }else{
        // 	this.matinee = 0;
        // 	this.evening = 0;
        // }
        this.matinee_evening = res.data.data.matinee_evening;
        if (res.data.data.men_total > 0) {
          this.menP = res.data.data.men_total / (res.data.data.men_total + res.data.data.women_total) * 100
        } else { this.menP = 0 }
        if (res.data.data.women_total > 0) {
          this.womenP = res.data.data.women_total / (res.data.data.men_total + res.data.data.women_total) * 100
        } else { this.womenP = 0 }
        // this.getGender();
        if (i == 1) {
          return false
        } else {
          this.getTime();
          this.getMatineeEvening();
        }

      })
    },
    //早晚场次
    getMatineeEvening() {
      var series = [];
      series.push({ value: this.matinee_evening[0].replace('%', ''), name: '日游场' })
      series.push({ value: this.matinee_evening[1].replace('%', ''), name: '夜游场' })
      series.push({ value: this.matinee_evening[2].replace('%', ''), name: '日转夜' })
      series.push({ value: this.matinee_evening[3].replace('%', ''), name: '过夜' })
      series.push({ value: this.matinee_evening[4].replace('%', ''), name: '其他' })

      var MatineeEvening_1 = this.echarts.init(document.getElementById('matinee_evening_1'));
      var option = {
        color: ['#01f1e3', '#023aff', '#bb63ff', '#ffa63f', '#f13b01'],
        series: [
          {
            type: 'pie',
            // radius: '50%',
            data: series,
            label: {
              show: false
            },
          }
        ],
        tooltip: {
          formatter: function (params) {
            return params.data.name + ":<br/>" + params.data.value + '%'
          },
        }
      }

      MatineeEvening_1.setOption(option)
    },
    //获取时间
    getToday() {
      var today = new Date();
      var year = today.getFullYear();
      var month = today.getMonth() > 8 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1);
      var date = today.getDate() > 9 ? today.getDate() : '0' + today.getDate();
      this.hour = today.getHours() > 9 ? today.getHours() : '0' + today.getHours();
      var min = today.getMinutes() > 9 ? today.getMinutes() : '0' + today.getMinutes();
      var second = today.getSeconds() > 9 ? today.getSeconds() : '0' + today.getSeconds();
      this.nowDay = year + '/' + month + '/' + date;
      this.nowYear = year;
      this.nowDay2 = year + '-' + month + '-' + date;
      this.nowTime = this.hour + ":" + min + ":" + second;
      this.week = this.getWeek(today.getDay())
    },
    //获取天气
    getWeatherData(i) {
      weatherDataNew({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        // this.temperature = res.data.data.weather.temperature;
        // this.winddirection = res.data.data.weather.winddirection;
        // this.windpower = res.data.data.weather.windpower;
        this.weather = res.data.data.weather;
        if (i && i != undefined) {
          this.getToday();
          return
        } else {
          if (this.typeIndex === 0) {
            this.getPlaneFigure();
          } else if (this.typeIndex === 1) {
            this.getPlaneFigure();
          } else if (this.typeIndex === 2 || this.typeIndex === 5 || this.typeIndex === PRICE_SUPERVISION_TYPE_INDEX) {
            this.getPlaneFigure();
          } else if (this.typeIndex === 6) {
            this.getPlaneFigure();
          } else if (this.typeIndex === 7) {
            this.getPlaneFigure();
          }
        }
      })
    },
    //获取飞机图数据
    getPlaneFigure(i) {
      planeFigure({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        var to = { lat: parseFloat(this.weather.lat), lng: parseFloat(this.weather.lng) }
        var arr = [];
        fly = [];
        this.hotMapList = []

        arcData = [];
        heatData = [];
        for (var j = 0; j < res.data.data.lists.length; j++) {
          var fly = res.data.data.lists[j]
          for (var city in fly) {
            this.hotMapList.push({ name: city, value: fly[city].total })
            arcData.push({ to: to, from: { lat: parseFloat(fly[city].latitude), lng: parseFloat(fly[city].longitude) }, count: fly[city].total })
            heatData.push({ lat: parseFloat(fly[city].latitude), lng: parseFloat(fly[city].longitude), count: fly[city].total })
          }

        }
        // arcData = res.data.data.dicts
        this.flight_coordinates(i)
      })

    },
    //获取游客入园时间统计
    // getEnrollmentTime(){
    //   enrollmentTimeData({
    //     scenic_id:2,
    //     dates:'2021-07-17'
    //   }).then(res => {
    //     this.touristsData = res.data.data;
    //     this.getInTime()
    //   })
    // },
    //获取客源地(省份/城市)数据
    getOriginList() {
      originList({
        scenic_id: this.scenic_id,
        dates: this.req_date,
        sort_type: this.originIndex + 1,
        data_type: 2
      }).then(res => {
        this.origin_list_dict = res.data.data.origin_list_dict
        this.getAddress();
      })
      // visitorSourceData({
      //   date: this.req_date,
      // }).then(res => {
      //   console.log(res, '客源地visitorSourceData')
      // })
    },
    //游客进出园时间分析
    getCurrentTrafficTrend() {
      currentTrafficTrend({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        var obj = res.data.data.current_traffic_trend
        // this.current_traffic_trend.categories = [];
        // this.current_traffic_trend.series = [];
        this.$set(this.current_traffic_trend, 'categories', []);
        this.$set(this.current_traffic_trend, 'series', []);
        return obj
      }).then(current_traffic_trend => {
        return this.getIotAppendData({ scenic_biz: this.scenic_id, }).then(appendDataList => {
          if (appendDataList.find(item => item === 'villager_in_out')) {
            return getIotScenicVillageTrend({ scenic_id: this.scenic_id, dates: this.req_date }).then(res => {
              res.data.data.villager_trend.series.forEach(item => { current_traffic_trend.series.push(item) })
              return current_traffic_trend
            })
          } else {
            return current_traffic_trend
          }
        })
      }).then(current_traffic_trend => {
        if (!this.req_date || this.req_date == '' || this.req_date == this.nowDay2) {
          for (var i = 0; i < current_traffic_trend.categories.length; i++) {
            if (current_traffic_trend.categories[i] <= (parseInt(this.hour) + 1)) {
              this.current_traffic_trend.categories.push(current_traffic_trend.categories[i])
            } else {
              break
            }
          }
          for (var j = 0; j < current_traffic_trend.series.length; j++) {
            this.current_traffic_trend.series.push({ name: current_traffic_trend.series[j].name, data: current_traffic_trend.series[j].data.slice(0, this.current_traffic_trend.categories.length) })
          }
        } else {
          this.current_traffic_trend = current_traffic_trend
        }
        for (var i = 0; i < this.current_traffic_trend.categories.length; i++) {
          var series = this.current_traffic_trend.series
          series[0].data[i] = (series[0].data[i] * this.coefficient_data / 100).toFixed(0)
          series[1].data[i] = (series[1].data[i] * this.coefficient_data / 100).toFixed(0)
          series[2].data[i] = (series[2].data[i] * this.coefficient_data / 100).toFixed(0)
          series[3].data[i] = (series[3].data[i] * this.coefficient_data / 100).toFixed(0)
          series[4].data[i] = (series[4].data[i] * this.coefficient_data / 100).toFixed(0)
          series[5].data[i] = (series[5].data[i] * this.coefficient_data / 100).toFixed(0)
          series[6].data[i] = (series[6].data[i] * this.coefficient_data / 100).toFixed(0)
          if (series[7]) {
            series[7].data[i] = (series[7].data[i] * this.coefficient_data / 100).toFixed(0)
          }
          if (series[8]) {
            series[8].data[i] = (series[8].data[i] * this.coefficient_data / 100).toFixed(0)
          }
        }
        // this.getInOrOut();
        this.getInTime()
        // this.showPeakLine(this.current_traffic_trend)
      })
    },
    // 入园出园趋势
    showPeakLine(chartData) {
      console.log(chartData, '入园出园趋势')
      var categories = [];
      var series = [];
      var order_series = [];
      if (this.isToday) {
        for (var i = 0; i < chartData.categories.length; i++) {
          if (chartData.categories[i] <= (parseInt(this.hour) + 1)) {
            categories.push(chartData.categories[i])
          } else {
            break
          }
        }
      } else {
        categories = chartData.categories;
      }
      let series_0, series_1, series_6
      series_0 = JSON.parse(JSON.stringify(chartData.series[0]));
      series_1 = JSON.parse(JSON.stringify(chartData.series[1]));
      // series_6 = JSON.parse(JSON.stringify(chartData.series[6]));
      series_0.data = this.pushTrafficLine(chartData.series[0].data)
      series_1.data = this.pushTrafficLine(chartData.series[1].data)
      for (var i = 0; i < categories.length; i++) {
        series_0.data[i] = (series_0.data[i] * 4.9).toFixed(0)
        series_1.data[i] = (series_1.data[i] * 4.9).toFixed(0)
      }

      // series_6.data = this.pushTrafficLine(chartData.series[6].data)

      console.log(series, '峰值')
      var option = {
        grid: {
          top: "20%",
          left: "15%",
          right: "5%",
          bottom: "16%"
        },
        legend: {
          show: true,
          y: 'top',
          x: 'right',
          icon: 'rect',
          width: 200,
          itemWidth: 9,
          itemHeight: 9,
          align: "auto",
          textStyle: {
            color: '#fff',
            fontSize: 10
          }
        },
        tooltip: {},
        xAxis: {
          boundaryGap: false,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 10
            },
            formatter: (value, index) => {
              return value + '点'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          data: this.current_traffic_trend.categories
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 11
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          splitNumber: 4,
        },
        color: ['#01f1e3', '#023aff', '#bb63ff', '#ffa63f', '#f13b01', '#c40449', '#f03fff', '#07a198', '#4c4c87', '#797983'],
        series: [{
          data: series_0.data.slice(0, categories.length),
          type: 'line',
          smooth: true,
          name: series_0.name,
          // name: '峰值',
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 0.5
              },
              borderColor: '#fff',
              borderWidth: 2
            },
          },
          areaStyle: {}
        },
        {
          data: series_1.data.slice(0, categories.length),
          type: 'line',
          smooth: true,
          name: series_1.name,
          // name: '同比',
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 0.5
              },
              borderColor: '#fff',
              borderWidth: 2,
            }
          },
          areaStyle: {}
        },
          // {
          //   data: series_6.data.slice(0, categories.length),
          //   type: 'line',
          //   smooth: true,
          //   name: series_6.name,
          //   symbol: 'circle',
          //   symbolSize: 6,
          //   itemStyle: {
          //     normal: {
          //       lineStyle: {
          //         width: 0.5
          //       },
          //       borderColor: '#fff',
          //       borderWidth: 2,
          //     }
          //   },
          //   areaStyle: {}
          // }
        ]
      }
      var peakLine = this.echarts.init(document.getElementById('peakLine'));
      var peakLine_2 = this.echarts.init(document.getElementById('peakLine_2'));
      peakLine.setOption(option)
      peakLine_2.setOption(option)
      this.setHourScenic()
    },
    setHourScenic(chartData) {
      const today = new Date();
      const hour = today.getHours()
      var categories = [hour + ':00', hour + ':10', hour + ':20', hour + ':30', hour + ':40', hour + ':50'];
      var series = [];
      series = [
        { name: '篁岭', data: [20, 32, 53, 22, 43, 19, 24, 41, 22, 43, 19, 24], type: 'line', smooth: true, },
        { name: '弦高', data: [12, 13, 15, 12, 14, 11, 12, 14, 12, 14, 11], type: 'line', smooth: true, },
        { name: '婺女洲', data: [2, 3, 5, 2, 4, 1, 2, 4, 5, 2, 4, 1], type: 'line', smooth: true, },
      ]
      var option = {
        grid: {
          top: "12%",
          left: "12%",
          right: "5%",
          bottom: "18%"
        },
        legend: {
          show: true,
          y: 'top',
          x: 'right',
          icon: 'rect',
          width: 200,
          itemWidth: 9,
          itemHeight: 9,
          align: "auto",
          textStyle: {
            color: '#fff',
            fontSize: 10
          }
        },
        tooltip: {},
        xAxis: {
          boundaryGap: false,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 10
            },
            formatter: (value, index) => {
              return value + '点'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          data: categories
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 11
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          splitNumber: 4,
        },
        color: ['#01f1e3', '#023aff', '#bb63ff', '#ffa63f', '#f13b01', '#c40449', '#f03fff', '#07a198', '#4c4c87', '#797983'],
        series: series
      }
      var hourScenic = this.echarts.init(document.getElementById('hourScenic'));
      hourScenic.setOption(option)
    },
    //入园游客类型统计
    getTicketNumberStatistics() {
      ticketNumberStatistics({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        this.ticket_number_statistics = res.data.data.ticket_number_statistics
        this.getTouristType()
      })
    },
    //游客入园时间图表
    getInTime(data) {
      var inTime = this.echarts.init(document.getElementById('inTime'));
      var inTime_5 = this.echarts.init(document.getElementById('inTime_5'));
      // var xAxisArr = [];
      // for(let i=this.touristsData.dates_list.length-1;i>=0;i--){
      //   xAxisArr.push(this.touristsData.dates_list[i].slice(5))
      // }
      // var yAxisArr = []
      // for(var name in this.touristsData.tourists_list){
      //   yAxisArr.push({type:'line',name:name,data:[]});
      // }
      // for(let i=0;i<yAxisArr.length;i++){
      //   for(let j=0;j<this.touristsData.tourists_list[yAxisArr[i].name].length;j++){
      //     yAxisArr[i].data.unshift(this.touristsData.tourists_list[yAxisArr[i].name][j])
      //   }
      // }

      var iotAppendData = []
      var dataItem = JSON.stringify({
        type: 'line', areaStyle: {}, smooth: true,
        symbol: 'circle', symbolSize: 6,
        data: [],
        name: '',
        itemStyle: { normal: { lineStyle: { width: 0.5 }, borderColor: '#fff', borderWidth: 2 } }
      })
      // iotAppendData.push({ ...JSON.parse(dataItem), data: this.current_traffic_trend.series[9].data, name: this.current_traffic_trend.series[9].name })
      var option = {
        grid: {
          top: "20%",
          left: "15%",
          right: "5%",
          bottom: "20%"
        },
        legend: {
          show: true,
          y: 'top',
          x: 'right',
          icon: 'rect',
          width: 200,
          itemWidth: 9,
          itemHeight: 9,
          align: "auto",
          textStyle: {
            color: '#fff',
            fontSize: 10
          }
        },
        tooltip: {},
        xAxis: {
          boundaryGap: false,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 10
            },
            formatter: (value, index) => {
              return value + '点'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          data: data.categories
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 11
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          splitNumber: 4,
        },
        color: ['#01f1e3', '#023aff', '#bb63ff', '#ffa63f', '#f13b01', '#c40449', '#f03fff', '#07a198', '#4c4c87', '#797983'],
        series: [{
          data: data.series[3].data,
          type: 'line',
          smooth: true,
          name: '散客',
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 0.5
              },
              borderColor: '#fff',
              borderWidth: 2,
              // color:{
              //   type: 'linear',
              //   x: 0,
              //   y: 0,
              //   x2: 0,
              //   y2: 1,
              //   colorStops: [{
              //       offset: 0, color: '#01F1E3' // 0% 处的颜色
              //   }, {
              //       offset: 1, color: '#4DA1FF' // 100% 处的颜色
              //   }],
              // }
            },
          },
          areaStyle: {}
        },
        {
          data: data.series[4].data,
          type: 'line',
          smooth: true,
          name: '团队',
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 0.5
              },
              borderColor: '#fff',
              borderWidth: 2,
              // color:{
              //   type: 'linear',
              //   x: 0,
              //   y: 0,
              //   x2: 0,
              //   y2: 1,
              //   colorStops: [{
              //       offset: 0, color: '#02A4FF' // 0% 处的颜色
              //   }, {
              //       offset: 1, color: '#7D40FF' // 100% 处的颜色
              //   }],
              // }
            }
          },
          areaStyle: {}
        },
        {
          data: data.series[5].data,
          type: 'line',
          smooth: true,
          name: '企业',
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 0.5
              },
              borderColor: '#fff',
              borderWidth: 2,
              // color:{
              //   type: 'linear',
              //   x: 0,
              //   y: 0,
              //   x2: 0,
              //   y2: 1,
              //   colorStops: [{
              //       offset: 0, color: '#02A4FF' // 0% 处的颜色
              //   }, {
              //       offset: 1, color: '#7D40FF' // 100% 处的颜色
              //   }],
              // }
            }
          },
          areaStyle: {}
        },
        {
          data: data.series[6].data,
          type: 'line',
          smooth: true,
          name: '贵宾',
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 0.5
              },
              borderColor: '#fff',
              borderWidth: 2,
              // color:{
              //   type: 'linear',
              //   x: 0,
              //   y: 0,
              //   x2: 0,
              //   y2: 1,
              //   colorStops: [{
              //       offset: 0, color: '#02A4FF' // 0% 处的颜色
              //   }, {
              //       offset: 1, color: '#7D40FF' // 100% 处的颜色
              //   }],
              // }
            }
          },
          areaStyle: {}
        }].concat(iotAppendData)
      }
      inTime.setOption(option);
      inTime_5.setOption(option);
    },
    //性别占比图表
    getGender() {
      var xAxisArr = [];
      var yAxisMen = [];
      var yAxisWomen = [];
      for (let i = 0; i < this.gender.men.length; i++) {
        // var name;
        // if(this.gender.men[i].name.indexOf('+')==-1){
        //   name = this.gender.men[i].name +'岁'
        // }else{
        //   name = this.gender.men[i].name.replace('+','岁以上')
        // }
        xAxisArr.push(this.gender.men[i].name);
        yAxisMen.push(this.gender.men[i].data);
        yAxisWomen.push(this.gender.women[i].data);
      }
      var yAxisArr = [
        { type: 'bar', name: '男', data: yAxisMen },
        { type: 'bar', name: '女', data: yAxisWomen },
      ]
      this.gender.men.type = 'bar';
      this.gender.men.name = '男';
      this.gender.women.type = 'bar';
      this.gender.women.name = '女'
      // var gender = this.echarts.init(document.getElementById('gender'));
      var gender_1 = this.echarts.init(document.getElementById('gender_1'));
      var gender_7 = this.echarts.init(document.getElementById('gender_7'));
      var option = {
        grid: {
          top: "10%",
          left: "15%",
          right: "4%",
          bottom: "25%"
        },
        tooltip: {},
        xAxis: {
          axisLabel: {
            show: true,
            textStyle: {
              color: '#8184a2',
              fontSize: 7     //更改坐标轴文字大小
            }
          },
          splitLine: {
            show: false
          },
          data: xAxisArr
        },
        yAxis: {
          axisLabel: {
            show: true,
            textStyle: {
              color: '#8184a2',
              fontSize: 8,      //更改坐标轴文字大小
            },
          },
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          }
        },
        color: ['#023aff', '#991bfa'],
        barWidth: 6,
        series: yAxisArr
      }
      // gender.setOption(option)
      gender_1.setOption(option)
      gender_7.setOption(option)
    },
    //时间占比图表
    getTime() {
      var label = ['1天内', '1天', '2天', '3天', '3天以上']
      var yAxisArr = [23.73, 39.81, 21.82, 11.72, 2.92];
      // for (let i = 0; i < this.schedule.value.length; i++) {
      //   yAxisArr.push(this.schedule.value[i].replace('%', ''))
      // }
      console.log(yAxisArr, this.schedule.label, '????????????????????')
      // var time = this.echarts.init(document.getElementById('time'));
      var time_1 = this.echarts.init(document.getElementById('time_1'));
      var option = {
        grid: {
          top: "10%",
          left: "10%",
          right: "4%",
          bottom: "25%"
        },
        tooltip: {
          formatter: function (params) {
            return params.data + '%'
          }
        },
        xAxis: {
          data: label,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 12     //更改坐标轴文字大小
            }
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          axisLabel: {
            show: true,
            formatter: '{value}%',
            textStyle: {
              color: '#fff',
              fontSize: 10      //更改坐标轴文字大小
            }
          },
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          }
        },
        series: [
          {
            type: 'bar',
            color: '#023aff',
            data: yAxisArr,
            barWidth: 12
          },
        ]
      }
      // time.setOption(option)
      var option_1 = JSON.parse(JSON.stringify(option))
      option_1.grid.right = '6%'
      option_1.grid.left = '12%'
      option_1.xAxis.axisLabel.textStyle.fontSize = 10
      option_1.tooltip.formatter = function (params) {
        return params.data + '%'
      }
      time_1.setOption(option_1)
    },
    //入园游客类型图表
    getTouristType() {
      // 每项顺序['散客票数','团队票数',"贵宾接待",'单位VIP','本地游客']
      var qianjing = [
        this.ticket_number_statistics.wx_mini_pro_member_num,
        this.ticket_number_statistics.wx_mini_pro_agency_num,
        this.ticket_number_statistics.wx_mini_pro_vip_num,
        this.ticket_number_statistics.wx_mini_pro_enterprise_vip_num
      ]

      var ota = [this.ticket_number_statistics.ota_num, 0, 0, 0, 0]
      var unLine = [
        this.ticket_number_statistics.member,
        this.ticket_number_statistics.agency,
        this.ticket_number_statistics.vip,
        this.ticket_number_statistics.enterprise_vip,
        this.ticket_number_statistics.free_check_gate_record_num
      ]
      // var touristType = this.echarts.init(document.getElementById('touristType'));
      var touristType_1 = this.echarts.init(document.getElementById('touristType_1'));
      var option = {
        grid: {
          top: "5%",
          left: "15%",
          right: "4%",
          bottom: "25%"
        },
        legend: {
          show: true,
          y: 'bottom',
          icon: "circle",
          itemWidth: 5,
          itemHeight: 5,
          itemGap: 30,
          textStyle: {  // 图例文字的样式
            color: '#fff',
          },
        },
        tooltip: {},
        xAxis: {
          data: ['散客票数', '团队票数', "贵宾接待", '单位VIP', '本地游客'],
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 9      //更改坐标轴文字大小
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          }
        },
        yAxis: {
          splitNumber: 4,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 12     //更改坐标轴文字大小
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          }
        },
        series: [
          {
            type: 'bar',
            name: '线下窗口',
            color: '#023aff',
            data: unLine,
            barWidth: 10,
            stack: 'x'
          },
          {
            type: 'bar',
            name: '牵景平台',
            color: '#01f1e3',
            data: qianjing,
            barWidth: 10,
            stack: 'x'
          },
          {
            type: 'bar',
            name: 'OTA',
            color: '#991bfa',
            data: ota,
            barWidth: 10,
            stack: 'x'
          }
        ]
      }
      // touristType.setOption(option)
      touristType_1.setOption(option)
    },
    //客源地统计图表
    getAddress() {
      var xAxisArr = [];
      var max = Math.max.apply(null, this.origin_list_dict.area_total_list);
      var divisor = max / 4;
      var maxmax = max + max / 3;
      var area_total_list = []
      var area_member_list = []
      var area_agency_list = []
      console.log(this.origin_list_dict, 'getAddress客源地统计图表')
      for (let i = 0; i < this.origin_list_dict.area_total_list.length; i++) {
        area_total_list.push(this.origin_list_dict.area_total_list[i] + divisor)
      }
      for (let i = 0; i < this.origin_list_dict.area_member_list.length; i++) {
        area_member_list.push(this.origin_list_dict.area_member_list[i] + divisor)
      }
      for (let i = 0; i < this.origin_list_dict.area_agency_list.length; i++) {
        area_agency_list.push(this.origin_list_dict.area_agency_list[i] + divisor)
      }
      // var address = this.echarts.init(document.getElementById('address'));
      var address_1 = this.echarts.init(document.getElementById('address_1'));
      var address_2 = this.echarts.init(document.getElementById('address_2'));
      var address_5 = this.echarts.init(document.getElementById('address_5'));
      option = {
        color: ['#01f1e3', '#023aff', '#bb63ff'],
        legend: {
          show: true,
          // y: '10px',    //延Y轴居中
          bottom: 0,
          left: 10,
          // orient: 'vertical',
          align: 'left',
          itemWidth: 10,
          itemHeight: 2,
          textStyle: {
            color: '#fff'
          }
        },
        radar: {
          splitNumber: 1,
          radius: 45,
          nameGap: 6,
          textStyle: {
            fontSize: 10,
            color: '#fff'
          },
          center: ['50%', '45%'],
          indicator: [
            { name: '东北', max: maxmax },
            { name: '华东', max: maxmax },
            { name: '华北', max: maxmax },
            { name: '华中', max: maxmax },
            { name: '西北', max: maxmax },
            { name: '西南', max: maxmax },
            { name: '华南', max: maxmax },
          ],
          splitLine: {
            show: true,
            lineStyle: {
              width: 0.5
            }
          },
          axisLine: {
            lineStyle: {
              width: 0.5
            }
          },
          splitArea: {
            show: false
          },

        },
        tooltip: {
          formatter: function (params) {
            var arr = []
            var _address = ['东北', '华东', '华北', '华中', '西北', '西南', '华南']
            for (let i = 0; i < params.value.length; i++) {
              arr.push(_address[i] + ':' + (params.value[i] - divisor) + ' ')
            }
            return params.name + '：[ ' + arr + ' ]'
          }
        },
        series: [

          {
            symbol: 'none',
            type: 'radar',
            data: [
              {
                value: area_total_list,
                name: '总数',
                lineStyle: { // 单项线条样式。

                  normal: {

                    opacity: 0.8, // 图形透明度

                  }
                },
                areaStyle: {
                  normal: {
                    type: 'default',
                    opacity: 0.6, // 图表中各个图区域的透明
                  }
                },
                label: {
                  normal: {
                    show: true,

                  }
                },
              }
            ]
          },

          {
            symbol: 'none',
            type: 'radar',
            data: [
              {
                value: area_member_list,
                name: '散客',
                lineStyle: { // 单项线条样式。
                  normal: {
                    opacity: 0.8, // 图形透明度
                  }
                },
                areaStyle: {
                  normal: {
                    type: 'default',
                    opacity: 0.6, // 图表中各个图区域的透明度

                  }
                },
                label: {
                  normal: {
                    show: true,
                    formatter: function (params) {
                      // return this.origin_list_dict.area_member_list[params.dataIndex] ;
                      return params.value - divisor
                    }
                  }
                },
              }
            ]
          },
          {
            symbol: 'none',
            type: 'radar',
            data: [
              {
                value: area_agency_list,
                name: '团队',
                lineStyle: { // 单项线条样式。
                  normal: {
                    opacity: 0.8, // 图形透明度

                  }
                },
                areaStyle: {
                  normal: {
                    type: 'default',
                    opacity: 0.6, // 图表中各个图区域的透明
                  }
                },
                label: {
                  normal: {
                    show: true,
                    formatter: function (params) {
                      // return this.origin_list_dict.area_agency_list[params.dataIndex] ;
                      return params.value - divisor
                    }
                  }
                },
              }
            ]
          },
        ]
      }
      option.tooltip.position = 'right'
      var option_1 = JSON.parse(JSON.stringify(option))
      option_1.radar.radius = 60
      // address.setOption(option);
      address_1.setOption(option);
      address_2.setOption(option_1);
      address_5.setOption(option_1);
      // var addressBar = this.echarts.init(document.getElementById('addressBar'));
      var addressBar_1 = this.echarts.init(document.getElementById('addressBar_1'));
      var addressBar_2 = this.echarts.init(document.getElementById('addressBar_2'));
      var addressBar_5 = this.echarts.init(document.getElementById('addressBar_5'));
      var newAddressArr = [];
      for (var i = this.origin_list_dict.o_total_list.length - 1; i >= 0; i--) {
        newAddressArr[newAddressArr.length] = this.origin_list_dict.o_total_list[i];
      }

      var newAddressName = [];
      for (var i = this.origin_list_dict.o_address_list.length - 1; i >= 0; i--) {
        newAddressName[newAddressName.length] = this.origin_list_dict.o_address_list[i];
      }
      var option = {
        grid: {
          top: "0",
          left: "0",
          right: "0",
          bottom: "0"
        },
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: function (params) {
            return params.value;
          },
        },
        xAxis: {
          splitLine: {
            show: false
          }
        },
        yAxis: {
          data: newAddressName
        },

        series: [
          {
            type: 'bar',
            color: '#023aff',
            data: newAddressArr,
            barWidth: 10
          },
        ]
      }
      // addressBar.setOption(option)
      addressBar_1.setOption(option)
      addressBar_2.setOption(option)
      addressBar_5.setOption(option)
    },
    //获取游客客流分析
    getTouristLine() {
      var xAxisArr = [];
      var yAxisArr = [];
      for (var i = this.real_time_traffic_list.time_list.length - 1; i >= 0; i--) {
        xAxisArr.push(this.real_time_traffic_list.time_list[i].slice(5, 10))
      }
      for (var i = this.real_time_traffic_list.data_list.length - 1; i >= 0; i--) {
        yAxisArr.push((this.real_time_traffic_list.data_list[i] * this.coefficient_data / 100).toFixed(0))
      }
      var touristLine = this.echarts.init(document.getElementById('touristLine'));
      var touristLine_1 = this.echarts.init(document.getElementById('touristLine_1'));
      var option = {
        grid: {
          top: "5%",
          left: "8%",
          right: "2%",
          bottom: "10%"
        },
        xAxis: {
          boundaryGap: false,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 11
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          data: xAxisArr
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 11
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          splitNumber: 5,
        },
        tooltip: {},
        series: [
          {
            data: yAxisArr,
            type: 'line',
            symbol: 'circle',
            symbolSize: 6,
            smooth: true,
            lineStyle: {
              color: {
                type: 'linear',
                x: 1,
                y: 0,
                x2: 0,
                y2: 0,
                colorStops: [{
                  offset: 0, color: '#7D40FF' // 0% 处的颜色
                }, {
                  offset: 1, color: '#02A4FF' // 100% 处的颜色
                }],
              }
            },
            itemStyle: {
              normal: {
                color: {
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [{
                    offset: 0, color: '#7D40FF' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#02A4FF' // 100% 处的颜色
                  }],
                },
                borderColor: '#fff',
                borderWidth: 2,
              }

            }
          }
        ]
      }
      touristLine.setOption(option);
      var option_1 = JSON.parse(JSON.stringify(option))
      option_1.grid.left = '15%'
      option_1.grid.right = '5%'
      option_1.grid.top = '20%'
      option_1.grid.bottom = '20%'
      touristLine_1.setOption(option_1)
    },
    //获取游客进出园时间
    getInOrOut() {
      var inOrOut = this.echarts.init(document.getElementById('inOrOut'));

      var f = (e, i, t) => Number(e) + Number(t[i])
      inOrOut.setOption({
        grid: {
          top: "20%",
          left: "12%",
          right: "5%",
          bottom: "16%"
        },
        color: [
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#01F1E3' // 0% 处的颜色
            }, {
              offset: 1, color: '#4DA1FF' // 100% 处的颜色
            }],
          },
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#02A4FF' // 0% 处的颜色
            }, {
              offset: 1, color: '#7D40FF' // 100% 处的颜色
            }],
          }
        ],
        legend: {
          show: true,
          y: 'top',
          x: 'right',
          icon: 'rect',
          itemWidth: 9,
          itemHeight: 9,
          textStyle: {
            fontSize: 10,
            color: '#fff'
          }
        },

        xAxis: {
          boundaryGap: false,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 10
            },
            formatter: (value, index) => {
              return value + '点'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          data: this.current_traffic_trend.categories,

        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 11
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          splitNumber: 5,
        },
        lineStyle: {
          color: '#fff',
        },
        tooltip: {},
        series: [
          {
            data: (this.current_traffic_trend.series[7] ?
              this.current_traffic_trend.series[0].data.map((e, i) => f(e, i, this.current_traffic_trend.series[7].data)) :
              this.current_traffic_trend.series[0].data),
            type: 'line',
            name: '进园',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 0.5
                },
                borderColor: '#fff',
                borderWidth: 2,
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#01F1E3' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#4DA1FF' // 100% 处的颜色
                  }],
                }
              },
            },
            areaStyle: {}
          },
          {
            data: (this.current_traffic_trend.series[8] ?
              this.current_traffic_trend.series[0].data.map((e, i) => f(e, i, this.current_traffic_trend.series[8].data)) :
              this.current_traffic_trend.series[1].data),
            type: 'line',
            name: '出园',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 0.5
                },
                borderColor: '#fff',
                borderWidth: 2,
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#02A4FF' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#7D40FF' // 100% 处的颜色
                  }],
                }
              }
            },
            areaStyle: {}
          },
        ]
      })
    },
    convertData(data, geoCoordMap) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var dataItem = data[i];
        var fromCoord = geoCoordMap[dataItem[0].name];
        var toCoord = geoCoordMap[dataItem[1].name];
        if (fromCoord && toCoord) {
          res.push({
            fromName: dataItem[0].name,
            toName: dataItem[1].name,
            coords: [toCoord, fromCoord]
          });
        }
      }
      return res;
    },
    // 飞机图或热力图
    flight_coordinates(i) {
      var data = arcData.slice(0, 50);
      const renderMapLayer = () => {
        if (i == 1) {
          this.clearFlightLayer()
        } else if (this.typeIndex == 2 || this.typeIndex == PRICE_SUPERVISION_TYPE_INDEX) {
          this.destroyMainMap()
          this.createDashboardMap()
        } else {
          this.destroyMainMap()
          var center = new TMap.LatLng(
            parseFloat(this.weather.lat) + this.setting.lat_offset,
            parseFloat(this.weather.lng) + this.setting.lng_offset
          );
          this.createRestrictedWuyuanMap("migrateMap", {
            zoom: this.setting.map_show,//设置地图缩放级别
            pitch: 30,
            center: center,//设置地图中心点坐标
            mapStyleId: "style3", //个性化样式
            showControl: false, //禁止所有控件
            baseMap: {
              type: "vector",
              features: ["base", "building3d", "point"], // 隐藏矢量文字
            },
          });
        }

        if (!this.map) {
          if (this.typeIndex == 2 || this.typeIndex == PRICE_SUPERVISION_TYPE_INDEX) {
            this.createDashboardMap()
          } else {
            return
          }
        }

        if (this.typeIndex == PRICE_SUPERVISION_TYPE_INDEX) {
          this.renderPriceFenceLayer()
        }

        if (this.typeIndex == 0 || this.typeIndex == 7) {
          this.flightMap = new TMap.visualization.Arc({
            pickStyle: function (arcLine) { // 样式映射函数
              return {
                color: "rgba(29,211,253,0.3)",
                animateColor: "rgba(255, 255, 255, 1)",
                width: 2
              };
            },
            mode: 'vertical' // 弧线平面与地平面垂直
          }).addTo(this.map).setData(data);//设置数据
        } else if (this.typeIndex == 1 || this.typeIndex == 5 || this.typeIndex == 6 || this.typeIndex == PRICE_SUPERVISION_TYPE_INDEX) {
          this.flightMap = new TMap.visualization.Heat({
            max: 600, // 热力最强阈值
            min: 0, // 热力最弱阈值
            height: 6, // 峰值高度
            radius: 36, // 最大辐射半径
          }).addTo(this.map)
          this.flightMap.setOpacity(0.8); // 设置透明度变化范围
          var gradient = this.flightMap.getGradientColor(); // 获取渐变色
          gradient.stops[0.1] = "#fff";
          gradient.stops[0.3] = '#5589f2'
          gradient.stops[0.6] = '#E9AB1D'
          gradient.stops[0.8] = '#e53f31'
          gradient.stops[0.99] = '#b84b41'
          gradient.stops[1.0] = '#652074'
          this.flightMap.setGradientColor(gradient); // 设置渐变色
          this.flightMap.setData(this.getWuyuanHeatData(heatData));//设置数据
          if (this.typeIndex == 5) {
            this.renderBusinessFenceLayers()
            this.renderBusinessResourceMarkers()
            if (this.isBusinessFenceDrawing) {
              this.bindBusinessFenceMapClick()
            }
          }
        }
      }

      this.ensureWuyuanBoundaryReady().then(() => {
        renderMapLayer()
      })
    },
    getWuyuanHeatData(sourceData) {
      return (sourceData || []).filter(item => this.isPointInWuyuanBoundary(item))
    },
    changeTheDate(day) {
      if (day == 0) {
        var date = '';
        this.$router.push({ path: '/', query: { id: this.scenic_id, date: date, typeIndex: this.typeIndex, token: store.state.token } })
        this.$router.go(0)
      } else {
        if (this.req_date != null) {
          var today = new Date(this.req_date)
        } else {
          var today = new Date()
        }
        var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
        today.setTime(targetday_milliseconds) //注意，这行是关键代码
        var tYear = today.getFullYear()
        var tMonth = today.getMonth()
        var tDate = today.getDate()
        this.nowYear = tYear;
        tMonth = this.doHandleMonth(tMonth + 1)
        tDate = this.doHandleMonth(tDate)
        var date = tYear + "-" + tMonth + "-" + tDate
        this.$router.push({ path: '/', query: { id: this.scenic_id, date: date, typeIndex: this.typeIndex, token: store.state.token } })
        this.$router.go(0)
      }

    },
    doHandleMonth(month) {
      var m = month
      if (month.toString().length == 1) {
        m = "0" + month
      }
      return m
    },
    // 获取客源月份
    getAnalysisMonth() {
      getAnalysisMonthApi({
        scenic_id: this.scenic_id
      }).then(res => {
        for (var month in res.data.data) {
          this.monthList = res.data.data[month]
          break
        }
        this.getCityCome()
        this.getOldCome()
      })
    },
    // 获取城市客源结构分析
    getCityCome() {
      getDataCustomerSourceMarketApi({
        scenic_id: this.scenic_id,
        city_name: this.city_name,
        month: this.monthList[0]
      }).then(res => {
        this.now_city_name = this.city_name
        this.cityComeData = res.data.data
        var categories = []
        var series = []
        var series_num = []
        var five_type = 'zongti_list'
        var five_num_type = 'zongti_list_num'
        for (let i = 0; i < this.monthList[1].length; i++) {
          categories.push(this.monthList[1][i] + '月')
        }
        series.push({ name: '60+', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][0] })
        series.push({ name: '50-60', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][1] })
        series.push({ name: '40-50', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][2] })
        series.push({ name: '30-40', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][3] })
        series.push({ name: '18-30', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][4] })
        series.push({ name: '18-', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][5] })
        // for(let i=0;i<series_num.length;i++){
        // 	series_num[i].data.unshift(series_num[i].data[11])
        // 	series_num[i].data.splice(12,1)
        // }
        var cityCome = this.echarts.init(document.getElementById('cityCome'));
        var cityCome_5 = this.echarts.init(document.getElementById('cityCome_5'));
        var cityCome_7 = this.echarts.init(document.getElementById('cityCome_7'));
        var option = {
          legend: {
            // Try 'horizontal'
            orient: 'horizontal',
            right: 'center',
            width: 325,
            bottom: 0,
            textStyle: {
              color: "#ffffff"
            }
          },
          tooltip: {
            trigger: 'axis',
            position: function (point, params, dom, rect, size) {
              return [point[0] - 100, '10%']  //返回x、y（横向、纵向）两个点的位置
            },
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#1e5671'
              }
            },
            textStyle: {
              fontSize: 10,
            }
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          grid: {
            top: '20%',
            left: '3%',
            right: '3%',
            bottom: '24%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: categories,
              minorTick: {
                splitNumber: 12
              },
              axisLabel: {
                fontSize: 9,
                color: '#ffffff'
              }
            }
          ],
          yAxis: [
            {
              max: 1,
              type: 'value',
              axisLabel: {
                formatter: function (value, index) {
                  return (value * 100).toFixed(0) + '%';
                },
                color: '#ffffff'
              }
            }
          ],
          series: series
        }
        cityCome.setOption(option)
        cityCome_5.setOption(option)
        cityCome_7.setOption(option)
      })
    },
    getOldCome() {
      getDataMainSourceMarketApi({
        scenic_id: this.scenic_id,
        data_type: 1,
        month: this.monthList[0]
      }).then(res => {
        this.oldComeData = res.data.data
        this.drawOldCome(this.oldComeIndex)
      })
    },
    getTradingNum_bar() {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      getTradingNumApi(params).then(res => {
        var categories = []
        var series_data = []

        res.data.data.ote_type_sale_volume_list.slice(0, 10).forEach(item => {
          categories.push(item[0])
          series_data.push(item[1])
        })
        categories.reverse()
        series_data.reverse()
        var obj = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {},
          grid: {
            left: '3%',
            right: '10%',
            bottom: '5%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            // boundaryGap: [0, 0.01],
            axisLabel: {
              textStyle: {
                color: '#ffffff',
                fontSize: 8     //更改坐标轴文字大小
              }
            },
            splitNumber: 3,
          },
          yAxis: {
            type: 'category',
            data: categories,
            axisLabel: {
              textStyle: {
                color: '#ffffff',
                fontSize: 10      //更改坐标轴文字大小
              },
              formatter: function (value) {
                return value.slice(0, 5);
              }
            }
          },
          series: [
            {
              name: '',
              type: 'bar',
              data: series_data,
              itemStyle: {
                color: "#0437ea"
              }
            }
          ]
        }
        var OTArank = this.echarts.init(document.getElementById('OTArank'));
        OTArank.setOption(obj)
      })
    },
    //今日交易总额
    getTradingNum() {
      // var params = {}
      // if (this.typeIndex === 2 && this.isToday) {
      //   params = { scenic_id: this.scenic_id, dates: this.last_day }
      // } else {
      //   params = { scenic_id: this.scenic_id, dates: this.req_date }
      // }

      // getTradingNumApi(params).then(res => {
      //   if (this.typeIndex === 0) {
      //     this.ote_type_sale_person_list = res.data.data.ote_type_sale_person_list
      //     this.showOtaPie(this.ote_type_sale_person_list)
      //     return
      //   }
      //   this.tradingNum = res.data.data;
      // })
      this.ote_type_sale_person_list = [
        { name: '餐饮', value: 2132728 },
        { name: '住宿', value: 1852012 },
        { name: '游玩', value: 2802215 },
        { name: '交通', value: 3293002 },
        { name: '购物', value: 379484 },
        { name: '其他', value: 109226 }
      ]
      this.showOtaPie(this.ote_type_sale_person_list)
      // channelAnalysisData({
      //   date: this.req_date
      // }).then(res => {
      //   this.ote_type_sale_person_list = res.data.data.ota

      //   this.getTouristAgencyType(res.data.data.travel_agency)
      // })
    },
    // 出行方式
    getTravelMode() {
      this.travel_mode_list = [
        { name: '高铁', value: 5023078 },
        { name: '自驾', value: 4270830 },
        { name: '大巴', value: 2608603 },
        { name: '其他', value: 230528 }
      ]
      this.showTravelPie(this.travel_mode_list)
    },
    // ota饼图
    showOtaPie(data) {
      var series = [];
      var total = 0
      for (let i = 0; i < data.length; i++) {
        series.push({ value: (data[i].value * this.coefficient_data / 100).toFixed(0), name: data[i].name })
        total += data[i].value
      }
      var ota_pie = this.echarts.init(document.getElementById('ota_pie'));
      var ota_pie_5 = this.echarts.init(document.getElementById('ota_pie_5'));
      var option = {
        color: this.pieColor,
        padding: [0, 0, 0, 0],
        series: [
          {
            type: 'pie',
            // radius: '50%',
            data: series,
            label: {
              show: false
            },
            center: ['35%', '38%'],
          }
        ],
        toolbox: {
          show: true
        },
        tooltip: {
          position: 'rigth',
          formatter: function (params) {
            return params.data.name + ":<br/>" + ((params.data.value / total) * 100).toFixed(2) + "%<br/>" + params.data.value + '元'
          },
        },
        legend: {
          show: true,
          bottom: 0,
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
        },
      }
      ota_pie.setOption(option)
      ota_pie_5.setOption(option)
    },
    showTravelPie(data) {
      var series = [];
      var total = 0
      for (let i = 0; i < data.length; i++) {
        series.push({value: (data[i].value * this.coefficient_data / 100).toFixed(0), name:data[i].name})
        total += data[i].value
      }
      console.log(series, '出行')
      var travel_pie = this.echarts.init(document.getElementById('travel_pie'));
      var option = {
        color: this.pieColor,
        padding: [0, 0, 0, 0],
        series: [
          {
            type: 'pie',
            // radius: '50%',
            data: series,
            label: {
              show: false
            },
            center: ['35%', '38%'],
          }
        ],
        toolbox: {
          show: true
        },
        tooltip: {
          position: 'rigth',
          formatter: function (params) {
            return params.data.name + ":<br/>" + ((params.data.value / total) * 100).toFixed(2) + "%<br/>" + params.data.value + '人次'
          },
        },
        legend: {
          show: true,
          bottom: 0,
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
        },
      }
      travel_pie.setOption(option)
    },
    // 旅行社交易排名
    getTouristAgencyType(data) {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      getTouristAgencyType(params).then(res => {
        let list = []
        if (this.typeIndex === 0) {
          list = data
        } else {
          list = res.data.data.tourist_agency_type_sale_volume_list
        }
        let categories = []
        let series_data = []
        list.slice(0, 10).forEach(item => {
          categories.push(item[0].tourist_agency__name)
          series_data.push((item[1] * this.coefficient_data / 100).toFixed(0))
        })
        categories.reverse()
        series_data.reverse()
        var res = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {},
          grid: {
            left: '0',
            right: '10%',
            bottom: '6%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLabel: {
              textStyle: {
                color: '#ffffff',
                fontSize: 8      //更改坐标轴文字大小
              }
            },
          },
          yAxis: {
            type: 'category',
            data: categories,
            axisLabel: {
              textStyle: {
                color: '#ffffff',
                fontSize: 10      //更改坐标轴文字大小
              },
              formatter: function (value) {
                return value.slice(0, 5);
              }
            }
          },
          series: [
            {
              name: '',
              type: 'bar',
              data: series_data,
              itemStyle: {
                color: "#0437ea"
              }
            }
          ]
        }
        var res_1 = JSON.parse(JSON.stringify(res))
        res_1.yAxis.axisLabel.formatter = function (value) {
          return value.slice(0, 5);
        }
        res_1.grid.top = '1%'
        res_1.grid.bottom = '0'
        res.xAxis.splitNumber = 3
        if (this.typeIndex === 0) {
          var travelPerson = this.echarts.init(document.getElementById('travelPerson'));
          travelPerson.setOption(res_1)
        } else {
          var travelRank = this.echarts.init(document.getElementById('travelRank'));
          travelRank.setOption(res)
        }

      })
    },
    // 销售数量占比、销售金额占比
    getSalesNum() {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      getSalesNumApi(params).then(res => {
        this.showTicketProductMoney(res.data.data.ticket_product_money)
      })
    },
    // 销售金额占比(产品)
    showTicketProductMoney(data) {
      var total = 0;
      var series = [];
      var productMoney = this.echarts.init(document.getElementById('productMoney'));
      for (let j = 0; j < data.value.length; j++) {
        total += data.value[j]
      }
      for (let i = 0; i < data.label.length; i++) {
        this.productMoneyList.push({
          name: data.label[i],
          data: (data.value[i] / total * 100).toFixed(2) + '%'
        })
        series.push({
          name: data.label[i],
          value: data.value[i]
        })
      }
      var option = {
        color: this.pieColor,
        series: [
          {
            type: 'pie',
            data: series,
            radius: '80%',
            label: {
              show: false
            },
          }
        ],
        tooltip: {
          trigger: 'item'
        },

      }
      productMoney.setOption(option)
    },
    // 获取酒店信息
    xcxGetHotelData() {
      var params = {}
      if (this.isToday) {
        params = { scenic_id: this.scenic_id, dates: this.last_day, store_id: '' }
      } else {
        params = { scenic_id: this.scenic_id, dates: this.req_date, store_id: '' }
      }
      xcxGetHotelDataApi(params).then(res => {
        this.hotelData = res.data.data
        this.setHotelList()
      })
    },
    setHotelList() {
      let categories = []
      let series_data = []
      this.hotelData.room_charge_list.slice(0, 10).forEach(item => {
        var value = Object.values(item)
        var key = Object.keys(item)
        categories.push(key[0].slice(0, 5))
        series_data.push(value[0])
      })
      categories.reverse()
      series_data.reverse()
      var hotelRank = this.echarts.init(document.getElementById('hotelRank'));

      var res = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          top: '0',
          left: '6%',
          right: '6%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLabel: {
            textStyle: {
              color: '#ffffff',
              fontSize: 10      //更改坐标轴文字大小
            }
          },
          splitNumber: 3
        },
        yAxis: {
          type: 'category',
          data: categories,
          axisLabel: {
            textStyle: {
              color: '#ffffff',
              fontSize: 10      //更改坐标轴文字大小
            },
            formatter: function (value) {
              return value.slice(0, 5);
            }
          }
        },
        series: [
          {
            name: '',
            type: 'bar',
            data: series_data,
            itemStyle: {
              color: "#0437ea"
            }
          }
        ]
      }
      hotelRank.setOption(res)

    },
    getBusinessNum() {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      getMerchantOrder(params).then(res => {
        this.businessNum = res.data.data
      })
    },
    getBusinessList() {
      var obj = { scenic_id: this.scenic_id, time_type: 3, is_all: 1, dates: this.req_date }
      getMerchantOrderList(obj).then(res => {
        let categories = []
        let series_data = []
        let categories_1 = []
        let categories_2 = []
        let series_data_1 = []
        let series_data_2 = []
        this.merchant_order_total_list = res.data.data.merchant_order_total_list
        for (let i = 0; i < this.merchant_order_total_list.length; i++) {
          var item = this.merchant_order_total_list[i]
          if (i < 10) {
            if (item.is_scenic_own) {
              series_data.push({ value: item.num, itemStyle: { color: '#05dfd6' } })
              categories.push(item.name)
            } else {
              series_data.push({ value: item.num, itemStyle: { color: '#063aef' } })
              categories.push(item.name)
            }
          }
          if (this.merchant_order_total_list.length > 40) {
            if (i % 2 === 1) {
              if (item.is_scenic_own) {
                series_data_1.push({ value: item.num, itemStyle: { color: '#05dfd6' } })
                categories_1.push(item.name)
              } else {
                series_data_1.push({ value: item.num, itemStyle: { color: '#063aef' } })
                categories_1.push(item.name)
              }
            } else {
              if (item.is_scenic_own) {
                series_data_2.push({ value: item.num, itemStyle: { color: '#05dfd6' } })
                categories_2.push(item.name)
              } else {
                series_data_2.push({ value: item.num, itemStyle: { color: '#063aef' } })
                categories_2.push(item.name)
              }
            }
          } else {
            if (item.is_scenic_own) {
              series_data_1.push({ value: item.num, itemStyle: { color: '#05dfd6' } })
              categories_1.push(item.name)
            } else {
              series_data_1.push({ value: item.num, itemStyle: { color: '#063aef' } })
              categories_1.push(item.name)
            }
          }
        }
        let integer
        if (this.merchant_order_total_list.length > 40) {
          integer = Math.ceil(series_data_2[0].value)
        } else {
          integer = Math.ceil(series_data_1[0].value)
        }
        categories_1.reverse()
        series_data_1.reverse()
        categories_2.reverse()
        series_data_2.reverse()
        let length = String(integer).length
        console.log(integer, length)
        let max_num = Math.ceil(integer / Math.pow(10, length - 1)) * Math.pow(10, length - 1)
        var businessRank = this.echarts.init(document.getElementById('businessRank'));
        var option = {
          grid: {
            top: "20%",
            left: "10%",
            right: "3%",
            bottom: "26%"
          },
          tooltip: {},
          xAxis: {
            axisLabel: {
              show: true,
              rotate: 36, // 倾斜30度<<<<<-----复制这里----------
              interval: 0,
              textStyle: {
                color: '#fff',
                fontSize: 10    //更改坐标轴文字大小
              }
            },
            splitLine: {
              show: false
            },
            data: categories
          },
          yAxis: {
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 10,      //更改坐标轴文字大小
              },
            },
            splitNumber: 4,
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.5)',
                type: 'dashed'
              }
            }
          },
          barWidth: 10,
          series: [{
            data: series_data, type: 'bar'
          }]
        }
        var option_1 = {
          legend: {},
          grid: {
            top: '0',
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLabel: {
              show: true,
              interval: 0,
              textStyle: {
                color: '#fff',
                fontSize: 12    //更改坐标轴文字大小
              }
            },
            splitNumber: 3,
            max: max_num
          },
          yAxis: {
            type: 'category',
            data: categories_2,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 12,      //更改坐标轴文字大小
              },
            },
            formatter: function (value) {
              return value.slice(0, 5);
            }
          },
          series: [
            {
              name: '',
              type: 'bar',
              data: series_data_2,
              itemStyle: {
                color: "#0437ea"
              }
            }
          ]
        }
        if (this.merchant_order_total_list.length > 40) {
          var option_2 = {
            legend: {},
            grid: {
              top: '0',
              left: '3%',
              right: '3%',
              bottom: '3%',
              containLabel: true
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01],
              axisLabel: {
                show: true,
                interval: 0,
                textStyle: {
                  color: '#fff',
                  fontSize: 12    //更改坐标轴文字大小
                }
              },
              splitNumber: 3,
              max: max_num
            },
            yAxis: {
              type: 'category',
              data: categories_1,
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#fff',
                  fontSize: 12,      //更改坐标轴文字大小
                },
              },
              formatter: function (value) {
                return value.slice(0, 5);
              }
            },
            series: [
              {
                name: '',
                type: 'bar',
                data: series_data_1,
                itemStyle: {
                  color: "#0437ea"
                }
              }
            ]
          }
        }

        businessRank.setOption(option)
        if (this.merchant_order_total_list.length > 40) {
          var shopRank_1 = this.echarts.init(document.getElementById('shopRank_1'));
          shopRank_1.setOption(option_1)
          var shopRank_2 = this.echarts.init(document.getElementById('shopRank_2'));
          shopRank_2.setOption(option_2)
        } else {
          var shopRank = this.echarts.init(document.getElementById('shopRank'));
          shopRank.setOption(option_1)
        }
      })

    },
    getBigDataOfflineRetail() {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      getBigDataOfflineRetailInfo(params).then(res => {
        this.offlineRetailInfo = res.data.data
      })
    },
    salesComparison() {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      salesComparisonApi(params).then(res => {
        var categories = [];
        var series = [];
        var itemStyle = {
          normal: {
            lineStyle: {
              width: 0.5
            },
            borderColor: '#fff',
            borderWidth: 2
          },
        }
        series.push({ name: '总额', data: [], type: 'line', smooth: true, symbol: 'circle', symbolSize: 6, itemStyle: itemStyle, areaStyle: {} })
        series.push({ name: '票务', data: [], type: 'line', smooth: true, symbol: 'circle', symbolSize: 6, itemStyle: itemStyle, areaStyle: {} })
        series.push({ name: '酒店', data: [], type: 'line', smooth: true, symbol: 'circle', symbolSize: 6, itemStyle: itemStyle, areaStyle: {} })
        series.push({ name: '线下商户', data: [], type: 'line', smooth: true, symbol: 'circle', symbolSize: 6, itemStyle: itemStyle, areaStyle: {} })
        series.push({ name: '美食', data: [], type: 'line', smooth: true, symbol: 'circle', symbolSize: 6, itemStyle: itemStyle, areaStyle: {} })
        for (let i = res.data.data.sales_comparison_list.length - 1; i >= 0; i--) {
          var item = res.data.data.sales_comparison_list[i]
          categories.push(item.create_time.slice(5, 10))
          series[0].data.push(item.today_total_amount)
          series[1].data.push(item.ticket_sales_revenue)
          series[2].data.push(item.hotel_sales_revenue)
          series[3].data.push(item.offline_order_total)
          series[4].data.push(item.delicious_food_sales_revenue)
        }
        var thirtyDays = this.echarts.init(document.getElementById('thirtyDays'));
        var option = {
          grid: {
            top: "10%",
            left: "2%",
            right: "2%",
            bottom: "6%"
          },
          color: ['#01f1e3', '#023aff', '#bb63ff', '#ffa63f', '#f13b01', '#c40449', '#f03fff', '#07a198', '#4c4c87', '#797983'],
          legend: {
            show: true,
            y: 'top',
            x: 'center',
            icon: 'rect',
            width: 360,
            itemWidth: 10,
            itemHeight: 10,
            align: "auto",
            textStyle: {
              color: '#fff',
              fontSize: 18
            }
          },

          xAxis: {
            boundaryGap: false,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 11
              }
            },
            axisLine: {
              show: false, // 不显示坐标轴线
            },
            splitLine: {
              show: false // 不显示网格线
            },
            data: categories
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: false,
            },
            axisLine: {
              show: false, // 不显示坐标轴线
            },
            splitLine: {
              show: false // 不显示网格线
            },
            axisTick: {
              show: false // 不显示坐标轴刻度线
            },
            splitNumber: 5,
          },
          lineStyle: {
            color: '#fff',
          },
          tooltip: {},
          series: series
        }
        thirtyDays.setOption(option)
      })
    },
    totalWait(obj) {
      let total = 0
      for (let key in obj) {
        total += Number((obj[key] * this.coefficient_data / 100).toFixed(0))
      }
      return total
    },
    // 近三天
    getWaitingIn() {
      getWaitingInApi({ scenic_id: this.scenic_id, dates: this.req_date }).then(res => {
        console.log("近三天", res.data.data.data)
        var chartData = res.data.data.data.slice(0, 3)
        var series = []
        series.push({ name: '待入园', data: [], type: 'bar', color: '#023aff', barWidth: 10, stack: 'x' })
        series.push({ name: '已入园', data: [], type: 'bar', color: '#01f1e3', barWidth: 10, stack: 'x' })
        var categories = [];
        console.log(this.total_tourists_num, 'this.total_tourists_num')
        for (var i = 0; i < chartData.length; i++) {
          categories.push(chartData[i].create_time.slice(5, 10))
          // series[0].data.push(chartData[i].waiting_in)
          var total = this.totalWait(chartData[i].waiting_in_list)
          series[0].data.push(total)
          if (this.total_tourists_num > 0 && i === 0) {
            series[1].data.push(this.total_tourists_num)
            this.three_series.push({
              // data_1:chartData[i].waiting_in,
              data_1: total,
              data_2: this.total_tourists_num,
              list: chartData[i].waiting_in_list,
            })
          } else {
            series[1].data.push(null)
            this.three_series.push({
              // data_1:chartData[i].waiting_in,
              data_1: total,
              data_2: this.total_tourists_num,
              list: chartData[i].waiting_in_list,
            })
          }

        }

        var option = {
          grid: {
            top: "6%",
            left: "26%",
            right: "3%",
            bottom: "18%"
          },
          legend: {
            show: true,
            y: 'bottom',
            icon: "circle",
            itemWidth: 5,
            itemHeight: 5,
            itemGap: 30,
            textStyle: {  // 图例文字的样式
              color: '#fff',
            },
          },
          tooltip: {},
          xAxis: {
            data: categories,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 9      //更改坐标轴文字大小
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.5)',
                type: 'dashed'
              }
            }
          },
          yAxis: {
            splitNumber: 4,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 10     //更改坐标轴文字大小
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.5)',
                type: 'dashed'
              }
            }
          },
          series: series
        }

        var waitInPart = this.echarts.init(document.getElementById('waitInPart'));
        waitInPart.setOption(option)
        this.pushThreeShow(0)
        var _this = this
        waitInPart.on('click', function (params) {
          _this.pushThreeShow(params.dataIndex)
        });
      })
    },
    pushThreeShow(index) {
      this.three_show = []
      this.three_show.push({ text: '待入园：' + this.three_series[index].data_1 + '人' })
      if (this.three_series[index].data_2 > 0 && index === 0) {
        this.three_show.push({ text: '已入园：' + this.three_series[index].data_2 + '人' })
      } else if (index === 0) {
        this.three_show.push({ text: '已入园：0人' })
      }
      var pie_show = []
      for (let key in this.three_series[index].list) {
        if (key !== '景区窗口简易端') {
          pie_show.push({ value: this.three_series[index].list[key], name: key })
        }
        var three_pie = this.echarts.init(document.getElementById('three_pie'));
        var option = {
          color: ['#01f1e3', '#bb63ff', '#ffa63f', '#f03fff', '#07a198', '#1387f4', '#1b9b35', '#e33e31'],
          padding: [0, 0, 0, 0],
          series: [
            {
              type: 'pie',
              // radius: '50%',
              data: pie_show,
              label: {
                show: false
              },
            }
          ],
          tooltip: {
            position: 'left',
            formatter: function (params) {
              return params.data.name + "：" + params.data.value
            },
          },
          legend: {
            show: false,
          }
        }
        three_pie.setOption(option)
      }

    },
    pushTrafficLine(list) {
      var list_arr = []
      list_arr.push(list[0])
      for (let i = 1; i < list.length; i++) {
        list_arr.push(list[i] - list[i - 1])
      }
      return list_arr
    },
    getDeliciousFoodData() {
      var params = {}
      if (this.isToday) {
        params = { scenic_id: this.scenic_id, dates: this.last_day, store_id: '' }
      } else {
        params = { scenic_id: this.scenic_id, dates: this.last_day, store_id: '' }
      }
      xcxGetDeliciousFoodDataApi(params).then(res => {
        this.deliciousFoodData = res.data.data
        for (var i = 0; i < this.deliciousFoodData.business_indicators.length; i++) {
          var obj = this.deliciousFoodData.business_indicators[i]
          if (obj.key === '翻台率') {
            this.tableTurnoverRate = obj.label
            break
          }
        }
        this.showTypePie()
      })
    },
    // 市别
    showTypePie() {
      var series = [];
      var sum = 0;
      var legend_data = {}
      for (let i = 0; i < this.deliciousFoodData.time_period_type.length; i++) {
        var data = this.deliciousFoodData.time_period_type[i]
        if (i != this.deliciousFoodData.time_period_type.length - 1) {
          series.push({ value: data.label2, name: data.key })
          this.$set(legend_data, data.key, data.label2)
        } else {
          sum = data.label2
        }
      }
      var type_pie = this.echarts.init(document.getElementById('type_pie'));
      var option = {
        color: this.pieColor,

        series: [
          {
            center: ['50%', '36%'],
            type: 'pie',
            // radius: '50%',
            data: series,
            label: {
              show: false
            }
          }
        ],
        tooltip: {
          position: 'rigth',
          formatter: function (params) {
            return params.data.name + ":" + params.data.value
          },
        },
        legend: {
          show: true,
          bottom: 0,
          textStyle: {
            color: '#fff'
          },
          formatter: function (params) {
            return params + '：' + (legend_data[params] / sum * 100).toFixed(2) + '%'
          },
        }
      }
      console.log(sum, '合计')
      type_pie.setOption(option)
    },
    // 切换总收和商细
    changeAllShop(index) {
      this.allShopIndex = index
    },
    //舆情动态
    // 滚动到底部回调
    tendenciesScroll() {
      get_dynamic_subscribe_info_list({
        page: 1,
        limit: 50
      }).then(res => {
        if (res.data.data && res.data.data.length > 0) {
          if (this.tendenciesList.length === 0 || this.listQuery.page === 1) {
            this.tendenciesList = res.data.data
          } else {
            this.tendenciesList = this.tendenciesList.concat(res.data.data)
          }
          this.listQuery.page++
        } else {
        }
      })
    },
    handleDetail(data) {
      this.isDetail = true
      this.isDetailLoading = true
      get_dynamic_subscribe_info_detail({ 'antdu_id': data.antduId }).then(res => {
        this.tendenciesItem = res.data.data
      }).finally(r => {
        this.isDetailLoading = false
      })
    },
    // 跳转到原文
    toUrl(url) {
      if (url) {
        window.open(url)
      }
    },

    //舆情列表
    handleGetList() {
      const threeDaysAgo = new Date()
      threeDaysAgo.setDate(threeDaysAgo.getDate() - 3)
      const nextDay = new Date()
      nextDay.setDate(nextDay.getDate() + 1)
      get_subscribe_info_list({
        page: 1,
        limit: 200,
        start_date: parseTime(threeDaysAgo, '{y}-{m}-{d}'),
        end_date: parseTime(nextDay, '{y}-{m}-{d}'),
      }).then(res => {
        this.total = res.data.recordsTotal
        if (res.data.data.length > 0) {
          let list = res.data.data.map(item => {
            const [datePart, timePart] = item.createAt.split(' ')
            const [hour, minute] = timePart.split(':')
            item.date = datePart
            item.time = `${hour}:${minute}`
            return item
          })
          // 按照日期排序
          list = list.sort((a, b) => {
            // 直接比较整个时间字符串
            return new Date(b.createAt) - new Date(a.createAt)
          })
          // 相同日期放一起
          this.timelineList = list.reduce((groups, item) => {
            const date = String(item.date)
            if (!groups[date]) {
              groups[date] = []
            }
            groups[date].push(item)
            return groups
          }, {})
        } else {
          this.timelineList = null
        }
      })
    },
    strictClean(richText) {
      if (!richText) return ''
      // 只保留中文、英文、数字
      return richText.replace(/[^\u4e00-\u9fa5]/g, '')
    },
    // 文本高亮
    highlightText(text, rules) {
      if (!text || !rules || rules.length === 0) return text
      // 创建匹配规则的正则表达式
      const regex = this.createHighlightRegex(rules)
      // 使用正则表达式替换匹配的文本
      return text.replace(regex, '<span class="highlight">$&</span>')
    },
    createHighlightRegex(rules) {
      // 提取所有关键词
      const keywords = new Set()

      rules.forEach(rule => {
        if (!rule) return

        // 提取规则中的关键词（简化处理，实际项目需要更复杂的解析）
        const words = rule.match(/[^&|()\s]+/g) || []
        words.forEach(word => {
          if (word && word.length > 1) { // 过滤掉单个字符
            keywords.add(word.trim())
          }
        })
      })

      // 创建正则表达式，匹配任意关键词
      if (keywords.size === 0) return /(?!)/ // 不匹配任何内容

      const pattern = Array.from(keywords).map(word =>
        word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // 转义正则特殊字符
      ).join('|')

      return new RegExp(`(${pattern})`, 'gi')
    },
    // 修改图片访问来源
    imgText(text) {
      if (!text) return ''
      // 去重并过滤空值
      const words = [...new Set(['<img'].filter(word => word && word.trim()))]
      if (words.length === 0) {
        return text
      }
      // 创建正则表达式，忽略大小写，全局匹配
      const regex = new RegExp(`(${words.map(word =>
        word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      ).join('|')})`, 'gi')
      // 替换匹配的文本
      return text.replace(regex, '$1 referrerPolicy="no-referrer"')
    },

    //舆情分析开始
    // 初始化图表数据
    initEchart() {
      this.initEmotion()
      this.initHotWeb()
    },
    // 图表重置
    resizeEchart() {
      return debounce(() => {
        if (this.emotion) {
          this.emotion.resize()
        }
        if (this.hotWeb) {
          this.hotWeb.resize()
        }
      }, 200)
    },
    // 生成时间趋势折线图
    initTimeTrend() {
      this.timeTrend = echarts.init(this.$refs.timeTrend)
      this.timeTrend.setOption({
        title: {
          text: '时间趋势',
          left: 'center',
          textStyle: {
            color: '#fff'
          },
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            return `${params[0].name}<br/>数量: ${params[0].value}`
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.timeTrendData.x,
          axisTick: {
            show: false // 隐藏x轴刻度
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
            }
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
            }
          },
        },
        grid: {
          left: '1%',
          right: '4%',
          containLabel: true
        },
        series: [
          {
            data: this.timeTrendData.y,
            type: 'line',
            smooth: true,
            areaStyle: {},
            itemStyle: {
              normal: {
                label: { show: true, color: '#fff' }, color: '#6459cd', lineStyle: {
                  color: '#6459cd' // 改变折线颜色
                }
              }
            }
          }
        ]
      })
    },
    // 生成情绪分析饼图
    initEmotion() {
      this.emotion = echarts.init(this.$refs.emotion)
      // 计算总数
      const total = this.emotionData.reduce((sum, item) => sum + item.value, 0)
      this.emotion.setOption({
        title: {
          text: `情绪分析: ${total}`,
          left: 'center',
          textStyle: {
            color: '#fff'
          },
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          type: 'scroll',
          itemGap: 5,
          textStyle: {
            fontSize: 10,
            color: '#fff'
          },
          formatter: (name) => {
            const item = this.emotionData.find(d => d.name === name)
            if (item && total > 0) {
              const percent = ((item.value / total) * 100).toFixed(1)
              return `${name}: ${item.value} (${percent}%)`
            }
            return name
          }
        },
        grid: {
          left: '1%',
          right: '30%', // 为右侧图例留出空间
          bottom: '3%',
          containLabel: true
        },
        series: [
          {
            type: 'pie',
            avoidLabelOverlap: false,
            radius: ['20%', '40%'], // 调整为环形图
            center: ['35%', '50%'], // 饼图靠左，为图例留空间
            itemStyle: {
              normal: {
                color: (params) => {
                  return this.emotionType[params.name]
                }
              }
            },
            data: this.emotionData
          }
        ]
      })
    },
    // 生成媒体类型饼图
    initMediaType() {
      this.mediaType = echarts.init(this.$refs.mediaType)
      // 计算总数
      const total = this.mediaTypeData.reduce((sum, item) => sum + item.value, 0)
      this.mediaType.setOption({
        title: {
          text: `媒体类型: ${total}`,
          left: 'center',
          textStyle: {
            color: '#fff'
          },
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          type: 'scroll',
          itemGap: 5,
          textStyle: {
            fontSize: 10,
            color: '#fff'
          },
          formatter: (name) => {
            const item = this.mediaTypeData.find(d => d.name === name)
            if (item && total > 0) {
              const percent = ((item.value / total) * 100).toFixed(1)
              return `${name}: ${item.value} (${percent}%)`
            }
            return name
          }
        },
        grid: {
          left: '3%',
          right: '15%', // 为右侧图例留出空间
          bottom: '3%',
          containLabel: true
        },
        series: [
          {
            type: 'pie',
            radius: ['20%', '30%'], // 调整为环形图
            center: ['35%', '50%'], // 饼图靠左，为图例留空间
            data: this.mediaTypeData
          }
        ]
      })
    },
    // 生成热门网站柱状图
    initHotWeb() {
      this.hotWeb = echarts.init(this.$refs.hotWeb)
      this.hotWeb.setOption({
        title: {
          text: '渠道分析',
          left: 'center',
          textStyle: {
            color: '#fff'
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },

        },
        legend: {
          show: false
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
            }
          },
        },
        yAxis: {
          type: 'category',
          data: this.hotWebData.y,
          inverse: true,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
            }
          },
        },
        grid: {
          left: '1%',
          right: '2.5%',
          containLabel: true
        },
        dataZoom: [
          {
            type: 'slider',
            show: true,
            yAxisIndex: [0], // 控制 Y 轴
            width: 4, // 滚动条宽度
            right: 3, // 距离右侧的距离
            minValueSpan: 7, // 最小显示数量
            maxValueSpan: 7 // 最大显示数量
          },
          {
            type: 'inside',
            yAxisIndex: [0],
            moveOnMouseWheel: true // 鼠标滚轮触发平移
          }
        ],
        series: [
          {
            type: 'bar',
            smooth: true,
            show: false,
            areaStyle: {},
            data: this.hotWebData.x,
            itemStyle: { normal: { label: { show: true, position: 'right', color: '#fff' }, color: '#6459cd' } }
          }
        ]
      })
    },
    // 获取舆情分析数据
    getTimeTrend() {
      const sevenDaysAgo = new Date()
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)
      const nextDay = new Date()
      nextDay.setDate(nextDay.getDate() + 1)
      get_subscribe_time_trend({
        start_date: parseTime(sevenDaysAgo, '{y}-{m}-{d}'),
        end_date: parseTime(nextDay, '{y}-{m}-{d}'),
        time_type: 3,
      }).then(res => {
        const { data, emotion, mediaType, websiteName } = res.data
        if (data.length > 0) {
          this.timeTrendData.y = data.map(item => item.count)
          this.timeTrendData.x = data.map(item => parseTime(item.time_group, '{y}-{m}-{d}'))
        } else {
          this.timeTrendData = { x: [], y: [] }
        }

        if (emotion.length > 0) {
          this.emotionData = emotion.map(item => {
            if (item.emotion === '负面') {
              item.emotion = '疑似负面'
            }
            if (item.emotion === '差评') {
              item.emotion = '负面'
            }
            return {
              value: item.total,
              name: item.emotion
            }
          })
        } else {
          this.emotionData = []
        }

        if (mediaType.length > 0) {
          this.mediaTypeData = mediaType.map(item => {
            return {
              value: item.total,
              name: this.platform_type[item.mediaType]
            }
          })
        } else {
          this.mediaTypeData = []
        }
        if (websiteName.length > 0) {
          this.hotWebData.y = websiteName.map(item => item.websiteName)
          this.hotWebData.x = websiteName.map(item => item.total)
        } else {
          this.hotWebData = { x: [], y: [] }
        }
        this.initEchart()
      })
    },
    // 价格监管页面初始化
    type_price_supervision() {
      this.initPriceSupervisionSelection()
      this.getWeatherData()
      this.$nextTick(() => {
        this.renderPriceFenceLayer()
        this.refreshPriceFluctuationChart()
      })
    },
    initPriceFluctuationChart() {
      var chartDom = document.getElementById('priceFluctuationChart')
      if (!chartDom) {
        return
      }
      if (this.priceFluctuationChart) {
        this.priceFluctuationChart.dispose()
      }
      this.priceFluctuationChart = this.echarts.init(chartDom)
      var hotels = this.getPriceTrendTargetHotels()
      var dayCount = this.priceTrendChartDayCount
      var trend = this.buildPriceTrendSeries(hotels, dayCount)
      var recentLabel = '近' + dayCount + '天价格'
      var option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: [recentLabel, '上月同期价格'],
          textStyle: {
            color: '#a8c5e8',
            fontSize: 10
          },
          top: 0,
          right: 0
        },
        grid: {
          top: '22%',
          left: '10%',
          right: '6%',
          bottom: '12%'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: trend.dates,
          axisLabel: {
            textStyle: {
              color: '#a8c5e8',
              fontSize: 10
            }
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(0, 170, 255, 0.35)'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            textStyle: {
              color: '#a8c5e8',
              fontSize: 10
            },
            formatter: '¥{value}'
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(0, 170, 255, 0.12)',
              type: 'dashed'
            }
          }
        },
        series: [
          {
            name: recentLabel,
            type: 'line',
            smooth: true,
            data: trend.recentSeries,
            itemStyle: { color: '#ff4d4f' },
            lineStyle: { width: 2 }
          },
          {
            name: '上月同期价格',
            type: 'line',
            smooth: true,
            data: trend.lastMonthSeries,
            itemStyle: { color: '#00aaff' },
            lineStyle: { width: 2 }
          }
        ]
      }
      this.priceFluctuationChart.setOption(option, true)
    },
    changeTextType(value) {
      this.text_type_value = value
    },
    changeComparisonType(value) {
      this.comparison_type_index = value
      if (this.comparison_1 && this.comparison_2) {
        this.comparisonChange_1()
        this.comparisonChange_2()
      }
    },
    comparisonChange_1() {
      if (this.comparison_1) {
        var total = 1042852
        if (this.comparison_type_index == 1) {
          var series = [
            { name: '江苏', value: 13.39 },
            { name: '江西', value: 11.70 },
            { name: '安徽', value: 11.09 },
            { name: '浙江', value: 10.26 },
            { name: '广东', value: 9.78 },
            { name: '北京 ', value: 8.48 },
            { name: '辽宁', value: 7.85 },
            { name: '河南', value: 7.03 },
            { name: '山东', value: 6.80 },
            { name: '其他', value: 13.64 },
          ]
          
        } else if (this.comparison_type_index == 2) {
          var series = [
            { name: '60+', value: 19.35 },
            { name: '50-60', value: 16.49 },
            { name: '40-50', value: 17.26 },
            { name: '30-40', value: 20.59 },
            { name: '18-30', value: 18.10 },
            { name: '0-18', value: 8.22 },
          ]
        } else if (this.comparison_type_index == 3) {
          var series = [
            { name: '男', value: 40.38 },
            { name: '女', value: 59.62 }
          ]
        }
        var comparison_pie_1 = this.echarts.init(document.getElementById('comparison_pie_1'));
        var option = {
          color: this.pieColor,
          padding: [0, 0, 0, 0],
          series: [
            {
              type: 'pie',
              // radius: '50%',
              data: series,
              label: {
                show: false
              },
              center: ['50%', '40%'],
            }
          ],
          toolbox: {
            show: true
          },
          tooltip: {
            position: 'rigth',
            formatter: function (params) {
              return params.data.name + ":<br/>" + (params.data.value).toFixed(2) + "%<br/>" + (total * params.data.value / 100).toFixed(0) + "人"
            },
          },
          legend: {
            orient: 'horizontal',
            bottom: 2,
            itemWidth: 7,   // 默认25，缩小为8
            itemHeight: 7,  // 默认14，缩小为8
            itemGap: 7,    // 默认10，可适当缩小
            textStyle: {
              color: '#fff',
              fontSize: 7 // 缩小字体
            },
          },
        }
        comparison_pie_1.setOption(option)
      }
    },
    comparisonChange_2() {
      if (this.comparison_2) {
        var total = 1386717
        if (this.comparison_type_index == 1) {
          var series = [
            { name: '江西', value: 15.13 },
            { name: '江苏', value: 12.18 },
            { name: '浙江', value: 10.29 },
            { name: '安徽', value: 9.45 },
            { name: '广东', value: 9.45 },
            { name: '辽宁', value: 7.92 },
            { name: '河南', value: 6.70 },
            { name: '北京', value: 6.56},
            { name: '湖北', value: 6.48 },
            { name: '其他', value: 15.85 },
          ]
        } else if (this.comparison_type_index == 2) {
          var series = [
            { name: '60+', value: 17.85 },
            { name: '50-60', value: 16.58 },
            { name: '40-50', value: 16.00 },
            { name: '30-40', value: 20.12 },
            { name: '18-30', value: 22.44 },
            { name: '0-18', value: 7.01 },
          ]
        } else if (this.comparison_type_index == 3) {
          var series = [
            { name: '男', value: 36.38 },
            { name: '女', value: 63.62 },
          ]
        }
        var comparison_pie_2 = this.echarts.init(document.getElementById('comparison_pie_2'));
        var option = {
          color: this.pieColor,
          padding: [0, 0, 0, 0],
          series: [
            {
              type: 'pie',
              // radius: '50%',
              data: series,
              label: {
                show: false
              },
              center: ['50%', '40%'],
            }
          ],
          toolbox: {
            show: true
          },
          tooltip: {
            position: 'rigth',
            formatter: function (params) {
              return params.data.name + ":<br/>" + (params.data.value).toFixed(2) + "%<br/>" + (total * params.data.value / 100).toFixed(0) + "人"
            },
          },
          legend: {
            orient: 'horizontal',
            bottom: 2,
            itemWidth: 7,   // 默认25，缩小为8
            itemHeight: 7,  // 默认14，缩小为8
            itemGap: 7,    // 默认10，可适当缩小
            textStyle: {
              color: '#fff',
              fontSize: 7 // 缩小字体
            },
          },
        }
        comparison_pie_2.setOption(option)
      }
    },
    getLevel(data) {
      if(data) {
        this.level_value = 1
      }
      if (this.level_value == 1) {
        var series = [
          { name: '江苏', value: 13.57 },
          { name: '江西', value: 11.20 },
          { name: '浙江', value: 10.88 },
          { name: '安徽', value: 10.72 },
          { name: '广东', value: 8.98 },
          { name: '辽宁', value: 7.61 },
          { name: '河南', value: 6.98 },
          { name: '山东', value: 6.75 },
          { name: '湖北 ', value: 5.72 },
          { name: '其他', value: 17.59 },
        ]
        var total = 10357337
      } else if (this.level_value == 2) {
        var series = [
          { name: '上饶', value: 22.66 },
          { name: '南昌', value: 14.98 },
          { name: '景德镇', value: 13.78 },
          { name: '九江', value: 9.56 },
          { name: '抚州', value: 6.89 },
          { name: '赣州', value: 6.58 },
          { name: '鹰潭', value: 5.89 },
          { name: '吉安', value: 5.64 },
          { name: '宜春 ', value: 4.40 },
          { name: '其他', value: 4.63 },
        ]
        var total = 1159696
      } else if (this.level_value == 3) {
        var series = [
          { name: '婺源', value: 17.76 },
          { name: '广丰', value: 11.66 },
          { name: '上饶县', value: 10.51 },
          { name: '玉山县', value: 10.28 },
          { name: '信州区', value: 10.02 },
          { name: '广信区', value: 9.66 },
          { name: '德兴市', value: 8.69 },
          { name: '鄱阳县', value: 8.05 },
          { name: '弋阳县 ', value: 5.98 },
          { name: '其他', value: 7.39 },
        ]
        var total = 320717
      }
      var level_pie = this.echarts.init(document.getElementById('level_pie'));
      var option = {
        color: this.pieColor,
        padding: [0, 0, 0, 0],
        series: [
          {
            type: 'pie',
            // radius: '50%',
            data: series,
            label: {
              show: false
            },
            center: ['40%', '50%'],
          }
        ],
        toolbox: {
          show: true
        },
        tooltip: {
          position: 'rigth',
          formatter: function (params) {
            return params.data.name + ":<br/>" + (params.data.value).toFixed(2) + "%<br/>" + (total * params.data.value / 100).toFixed(0) + "人"
          },
        },
        legend: {
          orient: 'vertical',
          show: true,
          right: 0,
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
        },
      }
      level_pie.setOption(option)
      var _this = this
      level_pie.on('click', function(params){
        console.log('点击了系列:', params, _this.level_value);
        if (_this.level_value < 3) {
          _this.level_value += 1
          _this.getLevel()
        }
      })
    },
    lastLevel() {
      this.level_value -= 1
      this.getLevel()
    }
  }
};
</script>
<style scoped>
.sentiment-box {
  height: calc(100vh - 100px);
  display: flex;
}

.sentiment-left {
  width: 400px;
  flex-shrink: 0;
  margin: 0 10px;
}

.sentiment-stream-card {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
  max-width: 100%;
}

.sentiment-stream-body {
  flex: 1;
  padding: 0 10px 10px;
  box-sizing: border-box;
  min-height: 0;
  overflow: hidden;
  width: 100%;
}

.sentiment-stream-video {
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  box-sizing: border-box;
  object-fit: contain;
  background-color: #000;
}

.sentiment-body {
  flex: 1;
  display: flex;

}

.body-left {
  height: 100%;
  flex: 1;
  padding: 10px;
}

.body-right {
  height: 100%;
  flex: 1;
  padding: 10px;
}

.body-title {
  text-align: center;
  font-size: 28px;
}

.sentiment-right {
  width: 400px;
  flex-shrink: 0;
  margin: 0 10px;
}


.list-box {
  height: calc(100vh - 160px);
  overflow: auto;
  padding-right: 0;
}

.list-box::-webkit-scrollbar {
  width: 4px;
}

.list-box::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 4px;
}

.list-box::-webkit-scrollbar-thumb:hover {
  background: #fff;
}

.list-item {
  padding: 20px 0;
  cursor: pointer;
}

.item-header {
  display: flex;
  align-items: center;
}

.avatar {
  margin-right: 14px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
}

.avatar img {
  width: 40px;
  height: 40px;
}

.header-content {
  flex: auto;
  display: flex;
  align-items: center;
}

.header-content-left {
  flex: auto;
  display: flex;
  flex-direction: column;


}

.header-content-left .title {
  font-weight: bold;
  margin-bottom: 6px;
}

.header-content-left .content {
  font-size: 14px;
  color: #fff;
}

.header-content-right {
  flex-shrink: 0;
  margin-left: 20px;
  font-size: 14px;
  color: #6d5fe0;
}

.item-key {
  margin-top: 8px;
  font-size: 13px;
  color: #fff;
  display: flex;
}

.key-list {
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;


}

.key {
  margin-left: 10px;
  margin-bottom: 3px;
  color: #fff;
}

.item-tap {
  margin-top: 12px;
  margin-bottom: 4px;
  font-size: 13px;
  color: #fff;
  display: flex;
}

.tap-list {
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.tap {
  margin-left: 10px;
  margin-bottom: 3px;
  padding: 2px 5px;
  background-color: #6d5fe0;
  color: #fff;
  border-radius: 2px;
}

.item-body {
  padding: 0 15px;
}

.body-text {
  font-size: 15px;
  color: #c2c0c0;
  letter-spacing: 1px;
  line-height: 22px;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  /* 限制显示行数 */
  overflow: hidden;
  text-overflow: ellipsis;
}

.body-images {
  margin-top: 10px;
  overflow: hidden;
  width: 342px;
  position: relative;


}

.body-images img {
  object-fit: cover;
  flex-shrink: 0;
  height: 80px;
  width: 110px;
  margin: 0 2px;
}

.images-list {
  display: flex;
  flex-wrap: nowrap;
}

.prev {
  color: #fff;
  position: absolute;
  left: 2px;
  background-color: rgba(52, 64, 82, .7);
  padding: 3px;
  font-size: 14px;
  top: 30px;
}

.prev:hover {
  background-color: rgba(52, 64, 82, .5);
}

.next {
  color: #fff;
  position: absolute;
  right: 2px;
  background-color: rgba(52, 64, 82, .7);
  padding: 3px;
  font-size: 14px;
  top: 30px;
}

.next:hover {
  background-color: rgba(52, 64, 82, .5);
}

.img-total {
  position: absolute;
  left: 5px;
  bottom: 5px;
  font-size: 12px;
  color: #fff;
  padding: 2px 3px;
  line-height: 12px;
  background-color: rgba(86, 105, 133, 1);
}

.box-right {
  height: calc(100vh - 160px);
  display: flex;
  flex-direction: column;
}

.right-header {
  flex-shrink: 0;
}

.right-body {
  flex: 1;
  overflow-y: scroll;
}

.right-body-text {
  white-space: pre-line;
  font-size: 15px;
  color: #fff;
  letter-spacing: 1px;
  line-height: 22px;
}

/deep/ .right-body-text p {
  margin: 5px 0;
}

/deep/ .right-body-text img {
  display: inline-block;
  width: 100%;
  margin: 3px;
}

.right-body-images img {
  display: inline-block;
  max-width: 100%;
  margin: 3px;
}

.right-body::-webkit-scrollbar {
  width: 4px;
  position: fixed;
  right: 0;
}

.right-body::-webkit-scrollbar-thumb {
  background: #a8a8a8;
  border-radius: 4px;
}


.timeline {
  width: 28vw;
  height: calc(100vh - 160px);
  overflow-y: scroll;
}

.timeline-date {
  position: relative;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding: 10px 0;
  color: #fff;
  font-weight: bold;
}

.timeline-date:before {
  content: '';
  position: absolute;
  left: 8px;
  background-color: #6459cd;
  width: 1px;
  height: 100%;
}

.date-span {
  margin-right: 10px;
  /* background-color: #fff; */
  width: 17px;
  height: 17px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;


}

.date-item1 {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: #6459cd;
}

.timeline-item {
  position: relative;
}

.timeline-item:before {
  content: '';
  position: absolute;
  left: 8px;
  background-color: #6459cd;
  width: 1px;
  height: 100%;
}

.timeline-span {
  margin-right: 10px;
  /* background-color: #fff; */
  width: 17px;
  height: 17px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;


}

.span-item1 {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #6459cd;
}

.timeline-content {
  display: flex;
  align-items: center;
  padding: 14px 0;
}

.timeline-time {
  flex-shrink: 0;
  font-size: 14px;
  margin-right: 10px;
}

.timeline-text {
  cursor: pointer;
  flex: 1;
  font-size: 16px;
  color: #dad8d8;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  letter-spacing: 1px;
}

.timeline-website {
  width: 100px;
  flex-shrink: 0;
  font-size: 14px;
  margin-left: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.btn-box {
  width: 100px;
  flex-shrink: 0;
  font-size: 14px;
  margin-left: 10px;
}

.timeline::-webkit-scrollbar {
  width: 4px;
}

.timeline::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 4px;
}

.timeline::-webkit-scrollbar-thumb:hover {
  background: #fff;
}

.migrateMap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  /* max-height:calc(100% + 180px) ; */
  background-color: #555;
  z-index: 0;
  min-height: 100vh;
}

.centenr-echart {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 0;
}

.centenrBox {
  width: 1330px;
  height: 900px;
}

.centenrBox-chart {
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 1230px;
  height: 800px;
}

.shop-charts-btn {
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 1230px;
  height: 800px;
  display: flex;
  justify-content: space-around;
}

.shop-charts-01 {
  width: 1200px;
  height: 800px;
}

.shop-charts-02 {
  width: 500px;
  height: 800px;
}

.all_or_shop {
  display: flex;
  justify-content: center;
}

.all_or_shop_btn {
  width: 120px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 6px;
}

.all_or_shop_on {
  background-color: #060c41;
  border: 1px solid #04dccf;
  color: #04dccf;
}

.all_or_shop_btn:hover {
  cursor: pointer;
}

/* .migrateMap1{
  position: relative;
  top:0;
  left: 0;
  width: 100%;
  height: 571px;
  background-color: rgba(0,0,0,0);
} */
/* 头部开始 */
.head {
  position: relative;
  display: flex;
  padding: 0 20px;
  width: 100%;
  height: 54px;
  line-height: 54px;
  background-color: #141439;
  justify-content: space-between;
  z-index: 1;
}

.head-title {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  vertical-align: middle;
  cursor: pointer;
}

.head-title-listening {
  color: #ffffff;
}

.head-title-text {
  white-space: nowrap;
}

.head-title-voice-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 42px;
  height: 22px;
  padding: 0 8px;
  line-height: 22px;
  border: 1px solid rgba(112, 203, 255, 0.28);
  border-radius: 11px;
  color: #8cefff;
  font-size: 11px;
  box-sizing: border-box;
}

.head-title-voice-tag-active {
  border-color: rgba(112, 255, 159, 0.72);
  color: #70ff9f;
  box-shadow: 0 0 12px rgba(112, 255, 159, 0.12);
}

.head-logo {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  transform: translate(0, -2px);
}

.voice-status-box {
  position: absolute;
  top: 46px;
  left: 0;
  z-index: 4;
  display: inline-flex;
  align-items: center;
  max-width: 320px;
  min-height: 34px;
  padding: 0 12px;
  box-sizing: border-box;
  border: 1px solid rgba(112, 203, 255, 0.28);
  background: rgba(4, 9, 50, 0.96);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.22);
  white-space: nowrap;
}

.voice-status-dot {
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background: #8cefff;
  flex-shrink: 0;
}

.voice-status-text {
  overflow: hidden;
  text-overflow: ellipsis;
  color: rgba(255, 255, 255, 0.92);
  font-size: 12px;
}

.voice-status-info {
  border-color: rgba(112, 203, 255, 0.28);
}

.voice-status-info .voice-status-dot {
  background: #8cefff;
}

.voice-status-listening {
  border-color: rgba(112, 255, 159, 0.42);
}

.voice-status-listening .voice-status-dot {
  background: #70ff9f;
  box-shadow: 0 0 10px rgba(112, 255, 159, 0.45);
}

.voice-status-success {
  border-color: rgba(112, 255, 159, 0.42);
}

.voice-status-success .voice-status-dot {
  background: #70ff9f;
}

.voice-status-warning {
  border-color: rgba(255, 214, 106, 0.42);
}

.voice-status-warning .voice-status-dot {
  background: #ffd76a;
}

.voice-status-error {
  border-color: rgba(255, 138, 138, 0.42);
}

.voice-status-error .voice-status-dot {
  background: #ff8a8a;
}

.voice-status-fade-enter-active,
.voice-status-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.voice-status-fade-enter,
.voice-status-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

.date-weather {
  display: inline-block;
  padding: 0 15px;
  height: 36px;
  line-height: 36px;
  background-color: #040932;
  font-size: 13px;
  border-radius: 17px;
  vertical-align: middle;
}

.head-type {
  /* width: 417px; */
  max-width: 100%;
  height: 54px;
  display: flex;
  justify-content: space-around;
  vertical-align: middle;
}

.type-item {
  position: relative;
  height: 100%;
  display: inline-block;
  color: #575785;
  cursor: pointer;
  margin-right: 10px;
}

.type-on {
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #023AFF;
  border-radius: 1px;
}

.type-item2 {
  color: #fff;
}

/* 头部结束 */
/* 主体开始 */
.main {
  position: relative;
  width: 100%;
  /* padding-top: 28px; */
  /* box-sizing: border-box; */
  /* display: flex; */
  /* justify-content: space-between; */
  /* min-height: calc(100vh - 54px); */
  /* align-items:flex-end */
}

.warning-push-board {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  display: flex;
  align-items: center;
  min-width: 420px;
  max-width: 720px;
  height: 40px;
  padding: 0 16px;
  box-sizing: border-box;
  background: linear-gradient(90deg, rgba(8, 34, 70, 0.92) 0%, rgba(9, 46, 78, 0.72) 100%);
  border: 1px solid rgba(1, 241, 227, 0.28);
  box-shadow: 0 0 12px rgba(1, 241, 227, 0.12);
}

.warning-push-icon {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  margin-right: 10px;
  border-radius: 4px;
  background: rgba(255, 74, 74, 0.18);
  color: #ff4a4a;
  font-size: 15px;
  font-weight: 700;
  flex-shrink: 0;
}

.warning-push-text {
  flex: 1;
  min-width: 0;
  color: rgba(255, 255, 255, 0.95);
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.warning-push-button {
  margin-left: 14px;
  min-width: 84px;
  height: 28px;
  padding: 0 12px;
  border: 1px solid rgba(1, 241, 227, 0.45);
  background: rgba(1, 241, 227, 0.12);
  color: #8cefff;
  font-size: 12px;
  line-height: 26px;
  cursor: pointer;
  flex-shrink: 0;
}

.scenic-warning-board {
  position: absolute;
  top: 0;
  right: 360px;
  display: flex;
  align-items: center;
  width: 560px;
  height: 54px;
  padding: 0 18px;
  box-sizing: border-box;
  background: linear-gradient(90deg, rgba(8, 34, 70, 0.92) 0%, rgba(9, 46, 78, 0.72) 100%);
  border: 1px solid rgba(1, 241, 227, 0.45);
  box-shadow: 0 0 14px rgba(1, 241, 227, 0.2), inset 0 0 16px rgba(17, 155, 155, 0.12);
  border-radius: 6px;
  z-index: 2;
  overflow: hidden;
}

.scenic-warning-board::before {
  content: '';
  position: absolute;
  inset: 4px;
  border: 1px solid rgba(117, 250, 120, 0.65);
  border-radius: 4px;
  pointer-events: none;
}

.scenic-warning-icon {
  position: relative;
  z-index: 1;
  width: 22px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  margin-right: 14px;
  border-radius: 4px;
  background: rgba(255, 74, 74, 0.18);
  color: #ff4a4a;
  font-size: 16px;
  font-weight: 700;
}

.scenic-warning-content {
  position: relative;
  z-index: 1;
  flex: 1;
  height: 28px;
  overflow: hidden;
}

.scenic-warning-item {
  display: flex;
  align-items: center;
  height: 28px;
  line-height: 28px;
  white-space: nowrap;
}

.scenic-warning-title {
  margin-right: 12px;
  color: #ff4a4a;
  font-size: 16px;
  font-weight: 600;
  flex-shrink: 0;
}

.scenic-warning-text {
  overflow: hidden;
  text-overflow: ellipsis;
  color: rgba(255, 255, 255, 0.92);
  font-size: 16px;
}

.warning-slide-enter-active,
.warning-slide-leave-active {
  transition: all 0.45s ease;
}

.warning-slide-enter {
  opacity: 0;
  transform: translateY(100%);
}

.warning-slide-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}

.main_type {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  /* min-height: calc(100vh - 54px); */
  align-items: flex-end;
  padding-top: 20px;
}

.main_type.map-pass-through {
  pointer-events: none;
}

.main_type.map-pass-through>* {
  pointer-events: auto;
}

.click-box {
  position: absolute;
  right: 400px;
  top: 40px;
}

.data-box {
  background-color: #030A45;
  opacity: 0.9;
  box-shadow: -1px -1px 10px 2px rgba(78, 240, 228, 0.1);
  background-image: url(../../static/img/border-top.png),
    url(../../static/img/border-bottom.png);
  background-repeat: no-repeat, no-repeat;
  background-position: left top, right bottom;
  background-position: -0.3% -0.3%, 100.3% 100.3%;
}

/* 左边开始 */
.main-left {
  position: relative;
  /* flex-grow: 1; */
  margin: 0 20px 15px 20px;
  width: 320px;
  box-sizing: border-box;
  z-index: 1;
}

/* 左边顶部开始 */
.left-top {
  padding: 15px;
  /* padding-top: 35px; */
  width: 100%;
  height: 300px;
  box-sizing: border-box;

  z-index: 1;
}

.left-top-main {
  width: 100%;
}

.left-top-title {
  color: #fff;
  text-align: left;
  align-items: center;
}

.year-sum-box {
  margin-top: 6px;
  width: 291px;
  height: 57px;
  background: url(../../static/img/big-num-box.png) no-repeat;
  background-size: 100% 57px;
}

.year-sum {
  margin: 0 -2px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  width: calc(100% + 4px);
  line-height: 57px;
  text-align: center;
}

.center-big-title {
  margin-block: 6px;
  /* line-height: 81px;
  height: 81px; */
  vertical-align: top;
  color: #98bfbd;
  font-weight: 600;
  font-size: 20px;
  text-align: center;
}

.today-sum-one {
  width: 420px;
  height: 96px;
  background: url(../../static/img/num-box.png) no-repeat;
  background-size: auto 96px;
  background-position: left
}

.year-sum-big {
  position: relative;
  margin: 0 -3px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  width: calc(100% + 4px);
  line-height: 57px;
  text-align: center;
}

.sum-one-big {
  display: inline-block;
  /* margin-left:22px; */
  font-weight: 600;
  font-size: 80px;
}

.center-icon {
  position: absolute;
  bottom: 18px;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 60px;
}

.sum-one {
  display: inline-block;
  /* margin-left:22px; */
  font-weight: 600;
  font-size: 33px
}

/* .sum-one:first-child{
   margin-left:0px;
} */
.today-sum {
  display: flex;
  justify-content: space-between;
}

.today-one {
  flex-basis: 50%;
  text-align: center;
}

.today-one-title {
  margin: 8px 0 9px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
}

.today-one-sum {
  display: inline-block;
  width: 137px;
  height: 37px;
  background: url(../../static/img/small-num-box.png) no-repeat;
}

.today-one-sum-box {
  margin: 0 -1px;
  line-height: 37px;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  display: flex;
  justify-content: space-around;
  width: calc(100% + 2px);
}

.today-one-num {
  display: inline-block;
  /* margin-left: 13px; */

}

/* .today-one-num:first-child{
   margin-left: 0;
} */
.last-num {
  width: 100%;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
}

/* 左边顶部结束 */
/* 左边中间开始 */
.left-center {
  margin-top: 11px;
  padding: 0 10px 10px;
  width: 100%;
  height: 360px;
  box-sizing: border-box;
}

.inPercentage {
  margin-top: 15px;
  display: flex;
  justify-content: space-around;
}

.saturation {
  text-align: center;
}

.saturation-per {
  display: inline-block;
  width: 119px;
  height: 119px;
  background-image: url(../../static/img/Chart_bg.png);
  background-size: 102px 102px;
  background-position: center center;
  background-repeat: no-repeat;
}

.inPercentageRemark {
  margin-top: 13px;
  display: inline-block;
  height: 14px;
  line-height: 14px;
}

.little-bar {
  display: inline-block;
  width: 16px;
  height: 2px;
  vertical-align: middle;
}

/* 左边中间结束 */
/* 左边下部开始 */
.left-bottom {
  margin-top: 10px;
  width: 100%;
  height: 266px;
  box-sizing: border-box;
}
.left-bottom-title {
  position: relative;
  padding: 10px;
  font-size: 16px;
  color: #fff;
}
.last-level {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #01F1E3;
  font-size: 14px;
}
.gender {
  position: relative;
  padding-left: 5px;
  height: 80px;
}

.a-gender {
  margin-left: 10px;
  display: inline-block;
  text-align: center;
  vertical-align: top;
  transform: translate(0, 15px);
}

.a-gender>img {
  display: inline-block;
  width: 26px;
  height: 26px;
}

.gender-content {
  height: 14px;
  font-size: 10px;
  line-height: 14px
}

.matinee {
  display: inline-block;
  width: 110px;
  height: 105px;
  text-align: right;
}

.ota_pie {
  display: inline-block;
  width: 300px;
  height: 200px;
  text-align: right;
}

.scenic_ranking {
  display: inline-block;
  width: 150px;
  height: 260px;
  text-align: center;
}

.pie-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 6px;
  vertical-align: middle;
}

.pie-text-item {
  display: inline-block;
  margin: 3px 6px 0 0;
  font-size: 10px;
}

.gender-column {
  margin-left: 7px;
  display: inline-block;
  width: 190px;
  height: 105px;
}

.travel-person {
  margin-left: 7px;
  display: inline-block;
  width: 190px;
  height: 200px;
}

/* 左边下部结束 */
/* 左边结束 */
/* 中间开始 */
.main-center {
  flex-grow: 1;
  min-width: 720px;
  position: relative;
  height: 300px;
}

.heat-address {
  position: absolute;
  padding-left: 10px;
  top: 0;
  right: -119px;
  width: 102px;
  height: 36px;
  background-image: url(../../static/img/year-top.png),
    url(../../static/img/year-bottom.png),
    url(../../static/img/year-bgc.png);
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-size: auto auto, auto auto, 145px 65px;
  background-position: right top, left bottom, center center;
  font-size: 16px;
  color: #01F1E3;
  line-height: 36px;
  font-weight: 600;
}

.heat-address>img {
  display: inline-block;
  vertical-align: middle;
  transform: translate(0, -2px);
}

.charts {
  left: 0;
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.inOrOut {
  position: relative;
  width: 457px;
  height: 268px;
}

.inOrOut-chart {
  position: absolute;
  top: 11px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 425px;
  height: 256px;
}

.inTime {
  position: relative;
  width: 400px;
  height: 212px;
}

.inTime-chart {
  position: absolute;
  top: 11px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 360px;
  height: 200px;
}

/* 中间结束 */
/* 右边开始 */
.main-right {
  position: relative;
  margin: 0 20px 15px 20px;
  width: 320px;
  box-sizing: border-box;
  z-index: 1;
}

.changeDates {
  position: absolute;
  top: 0;
  left: -280px;
}

.changeDateOne {
  margin-right: 10px;
  display: inline-block;
  width: 66px;
  height: 32px;
  font-size: 15px;
  text-align: center;
  color: #01F1E3;
  line-height: 32px;
  font-weight: 600;
  background-image: url(../../static/img/year-top.png),
    url(../../static/img/year-bottom.png),
    url(../../static/img/year-bgc.png);
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-size: auto auto, auto auto, 110px 65px;
  background-position: right top, left bottom, center center;
  cursor: pointer;
}

/* 右边顶部开始 */
.right-top {
  width: 100%;
  height: 301px;
  box-sizing: border-box;
}

.right-title {
  position: relative;
  padding: 15px 10px;
  color: #fff;
  font-size: 16px;
  text-align: left;
}

.right-title-1 {
  font-size: 15px;
  color: #ccc;
}

.right-datetiem {
  position: absolute;
  padding-left: 8px;
  top: 15px;
  right: 10px;
  width: 55px;
  height: 22px;
  background-image: url(../../static/img/year-top.png),
    url(../../static/img/year-bottom.png),
    url(../../static/img/year-bgc.png);
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-position: right top, left bottom, center center;
  font-size: 10px;
  color: #01F1E3;
  line-height: 22px;
  font-weight: 600;
}

.right-datetiem>img {
  display: inline-block;
  vertical-align: middle;
  transform: translate(0, -1px);
}

.originTypeBox {
  position: relative;
  width: 100%;
}

.originTypeBox>img {
  display: inline-block;
  vertical-align: middle;
  transform: translate(0, -1px);
}

.originType {
  position: absolute;
  bottom: -75px;
  left: -8px;
  width: 66px;
  background-color: #08153b;
  border: 1px solid #01f1e3;
  z-index: 999;
}

.originTypeOne {
  padding: 0 4px;
  height: 24px;
  line-height: 24px;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #01f1e3;
}

.originTypeOne:last-child {
  border-bottom: 0px solid #01f1e3;
}

.touristType {
  margin: 0 auto;
  width: 100%;
  height: 240px;
}

/* 右边顶部结束 */
/* 右边中间开始 */
.right-center {
  margin-top: 20px;
  width: 100%;
  height: 261px;
  box-sizing: border-box;
}

.address {
  width: 160px;
  height: 150px;
}

.address_2 {
  width: 200px;
  height: 180px;
}

.addressList {
  display: inline-block;
  position: absolute;
  width: 100px;
  top: 50%;
  right: 8px;
  transform: translate(0, 22px);
}

.addressList_2 {
  display: inline-block;
  position: absolute;
  width: 130px;
  top: 50%;
  right: 8px;
  transform: translate(0, 22px);
}

.addressListOne {
  width: 60px;
  height: 15px;
  line-height: 15px;
  color: #aaabb0;
  font-size: 9px;
}

.addressListOne_2 {
  width: 60px;
  height: 18px;
  line-height: 18px;
  color: #aaabb0;
  font-size: 9px;
}

.addressBar {
  position: absolute;
  display: inline-block;
  width: 70px;
  height: 150px;
  top: 0;
  right: 0;
}

.addressBar_2 {
  position: absolute;
  display: inline-block;
  width: 100px;
  height: 180px;
  top: 0;
  right: 0;
}

/* 右边中间结束 */
/* 右边底部开始 */
.right-bottom {
  margin-top: 16px;
  width: 100%;
  height: 300px;
  box-sizing: border-box;
}

.touristLine {
  margin: 0 auto;
  width: 285px;
  height: 192px;

}

/* 右边底部结束 */
/* 右边结束 */
/* 第二部分左边开始 */
.cityCome {
  position: relative;
  width: 360px;
  height: 268px;
}

.cityCome-chart {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 350px;
  height: 180px;
}

.cityInput {
  padding: 0 6px;
  box-sizing: border-box;
  display: inline-block;
  width: 88px;
  height: 30px;
  line-height: 30px;
  z-index: 999;
}

.city-btn {
  margin-left: 6px;
  display: inline-block;
  width: 50px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  color: #fff;
  background-color: #1e5c79;
  border-radius: 6px;
}

.city-btn:hover {
  cursor: pointer;
}

.onOldCome {
  background-color: #0081c3;
}

.number-big {
  margin-top: 10px;
  color: #fff;
  font-size: 36px;
  font-weight: 600;
}

.number-small {
  margin-left: 14px;
  color: #01F1E3;
  font-size: 16px;
}

.title-small {
  display: inline-block;
  transform: translate(0, -2px);
}

.title-small-third {
  display: inline-block;
  width: 60px;
  text-align-last: justify;
  text-align: left;
}

.charts-percent {
  font-size: 12px;
  color: #fff;
  line-height: 12px;
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}

.ticket-dot {
  margin-left: 10px;
  margin-right: 6px;
  display: inline-block;
  vertical-align: middle;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.three-day {
  margin-left: 6px;
  margin-top: 18px;
  display: inline-block;
  width: 108px;
  vertical-align: top;
  font-size: 12px;
  /* text-align-last: justify; */
}

.rank-box {
  position: relative;
  display: inline-block;
  width: 178px;
  height: 278px;
}

.rank-charts {
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translate(-50%, 0);
}

.center-top-num {
  position: fixed;
  top: 50px;
  left: 50%;
  transform: translate(-50%, 0);
  padding: 18px;
}

.title-price {
  position: relative;
  color: #fff;
  margin: 10px 0 5px;
}

.title-price-tong {
  position: absolute;
  top: 6px;
  right: 6px;
}

.num-price {
  font-weight: 600;
  color: #01F1E3;
  margin-left: 10px;
  font-size: 20px;
}

.ota_pie_box {
  position: relative;
  width: 300px;
  display: inline-block;
  vertical-align: top;
}

.ota_pie_list {
  position: absolute;
  top: 20px;
  right: 15px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  width: 800px;
  border-radius: 8px;
  overflow: hidden;
}

.modal-header {
  padding: 15px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  border: none;
  background: none;
  font-size: 24px;
  cursor: pointer;
}

.modal-body {
  padding: 0;
  background: #000;
}

.click-box {
  padding: 5px;
  height: 30px;
  background: #133041;
  color: white;
  display: inline-block;
  cursor: pointer;
}

.scroll-text-box {
  flex: 1;
  height: 100%;
  overflow: hidden;
  position: relative;
  padding: 0 16px;
  display: flex;
  align-items: center;
}

.scroll-text-content {
  display: flex;
  flex-direction: column;
  animation: scrollUp 5s linear infinite;
  white-space: nowrap;
}

.scroll-text-content span {
  height: 18px;
  line-height: 18px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 400;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
}

@keyframes scrollUp {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-50%);
  }
}

/* 表格样式 */
.table-container {
  width: 100%;
}

.table-header {
  display: flex;
  background: linear-gradient(90deg, #1e3a8a 0%, #2563eb 100%);
  border-radius: 4px;
  margin-bottom: 8px;
  padding: 10px 0;
}

.th {
  flex: 1;
  text-align: center;
  color: #ffffff;
  font-size: 13px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.th:first-child {
  flex: 1.2;
}

.table-body {
  max-height: 400px;
  overflow-y: auto;
}

.table-body::-webkit-scrollbar {
  width: 4px;
}

.table-body::-webkit-scrollbar-track {
  background: #0a1f44;
}

.table-body::-webkit-scrollbar-thumb {
  background: #2563eb;
  border-radius: 2px;
}

.table-row {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px solid rgba(64, 158, 255, 0.1);
  transition: all 0.3s;
}

.table-row:hover {
  background: rgba(64, 158, 255, 0.15);
  transform: scale(1.01);
  box-shadow: 0 0 15px rgba(64, 158, 255, 0.2);
}

.table-row.even {
  background: rgba(64, 158, 255, 0.05);
}

.td {
  flex: 1;
  text-align: center;
  color: #a8c5e8;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.td:first-child {
  flex: 1.2;
}

.road-name {
  color: #ffffff;
  font-weight: 500;
}

/* 拥堵率颜色 */
.rate-text {
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 13px;
}

.rate-text.normal {
  color: #67c23a;
  background: rgba(103, 194, 58, 0.15);
  text-shadow: 0 0 8px rgba(103, 194, 58, 0.4);
}

.rate-text.warning {
  color: #e6a23c;
  background: rgba(230, 162, 60, 0.15);
  text-shadow: 0 0 8px rgba(230, 162, 60, 0.4);
}

.rate-text.danger {
  color: #f56c6c;
  background: rgba(245, 108, 108, 0.15);
  text-shadow: 0 0 8px rgba(245, 108, 108, 0.4);
}

.resource-panel {
  position: absolute;
  top: 50px;
  left: 400px;
  width: 150px;
  background-color: #0f4c81;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.resource-panel-title {
  padding: 10px 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 1px;
  background: linear-gradient(180deg, rgba(68, 164, 231, 0.55) 0%, rgba(15, 76, 129, 0.96) 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.14);
}

.resource-item {
  display: flex;
  align-items: center;
  padding: 8px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.resource-item:last-child {
  border-bottom: none;
}

.resource-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.resource-item.active {
  background-color: #2196F3;
  position: relative;
}

.resource-item.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #fff;
}

.resource-icon {
  width: 20px;
  text-align: center;
  margin-right: 10px;
  font-size: 14px;
  opacity: 0.9;
}

.resource-label {
  flex: 1;
  font-size: 14px;
  letter-spacing: 0.5px;
}

.resource-count {
  font-size: 13px;
  opacity: 0.9;
  font-weight: 500;
}

/* 备选方案：使用 CSS 绘制简单图标，不依赖 Font Awesome */
.icon-fallback {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 10px;
  position: relative;
}

.business-resource-page {
  position: relative;
  min-height: calc(100vh - 82px);
  z-index: 1;
}

.business-resource-page.map-pass-through {
  pointer-events: none;
}

.business-resource-page.map-pass-through>* {
  pointer-events: auto;
}

.business-alert {
  position: absolute;
  top: 20px;
  right: 372px;
  z-index: 3;
  display: flex;
  align-items: center;
  height: 42px;
  padding: 0 18px;
  background: rgba(9, 39, 58, 0.88);
  color: rgba(255, 255, 255, 0.96);
  font-size: 15px;
  box-shadow: 0 0 18px rgba(1, 241, 227, 0.1);
}

.business-alert em {
  color: #ff3d35;
  font-style: normal;
  font-weight: 700;
}

.business-alert-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  line-height: 20px;
  text-align: center;
  color: #ff3d35;
  border: 1px solid rgba(255, 61, 53, 0.8);
  border-radius: 3px;
  font-weight: 700;
}

.business-left-panel {
  position: absolute;
  top: 20px;
  left: 18px;
  z-index: 2;
  width: 324px;
  height: calc(100vh - 76px);
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
}

.business-saturation-card {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 12px 14px 10px;
  margin-bottom: 0;
  border: 1px solid rgba(88, 145, 255, 0.55);
  background-color: rgba(16, 30, 99, 0.94);
  background-image: url(../../static/img/border-top.png),
    url(../../static/img/border-bottom.png);
}

.business-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.business-card-title {
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
}

.business-saturation-card .business-card-title {
  color: #9bdfff;
}

.business-period-filter {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 24px;
  border: 1px solid rgba(73, 218, 222, 0.45);
  background: rgba(5, 31, 70, 0.72);
  color: #8cefff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: inset 0 0 10px rgba(73, 218, 222, 0.12), 0 0 10px rgba(73, 218, 222, 0.1);
}

.business-period-filter span {
  width: 7px;
  height: 7px;
  margin-left: 8px;
  border-right: 2px solid #8cefff;
  border-bottom: 2px solid #8cefff;
  transform: translateY(-2px) rotate(45deg);
}

.business-bar-chart {
  margin-top: 10px;
}

.business-chart-row {
  display: grid;
  grid-template-columns: 54px 1fr 38px;
  align-items: center;
  column-gap: 8px;
  height: 20px;
  margin-bottom: 4px;
}

.business-chart-label {
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  text-align: right;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.business-chart-track {
  height: 10px;
  border: 1px solid rgba(232, 63, 151, 0.78);
  background: rgba(24, 38, 108, 0.58);
  overflow: hidden;
}

.business-chart-track i {
  display: block;
  height: 100%;
  border-radius: 0 6px 6px 0;
  background: linear-gradient(90deg, #5ba7ff 0%, #a56bd2 50%, #e84395 100%);
}

.business-chart-track i.is-warning {
  background: linear-gradient(90deg, #5ba7ff 0%, #e4a844 100%);
}

.business-chart-track i.is-danger {
  background: linear-gradient(90deg, #5ba7ff 0%, #e84395 100%);
}

.business-chart-row strong {
  color: #ffe13d;
  font-size: 13px;
  font-style: italic;
  font-weight: 800;
}

.business-chart-row strong.is-danger {
  color: #ff5148;
}

.business-chart-row strong.is-warning {
  color: #ffd744;
}

.business-chart-axis {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin: 0 40px 0 62px;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  text-align: right;
}

.business-advice-box {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  margin-top: 8px;
  padding: 7px 8px;
  border: 1px solid rgba(88, 145, 255, 0.32);
  background: rgba(5, 18, 70, 0.42);
  color: rgba(255, 255, 255, 0.88);
}

.business-advice-title {
  margin-bottom: 3px;
  color: #8cefff;
  font-size: 12px;
  font-weight: 700;
}

.business-advice-box p {
  margin: 0 0 2px;
  font-size: 11px;
  line-height: 1.35;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.business-advice-box p:last-child {
  margin-bottom: 0;
}

.business-resource-menu {
  position: absolute;
  top: 365px;
  left: 50%;
  z-index: 2;
  width: 150px;
  transform: translateX(-150%);
  overflow: hidden;
  background-color: #0f4c81;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.business-resource-menu-title {
  padding: 10px 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 1px;
  background: linear-gradient(180deg, rgba(68, 164, 231, 0.55) 0%, rgba(15, 76, 129, 0.96) 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.14);
}

.business-resource-item {
  display: flex;
  align-items: center;
  padding: 8px;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  line-height: 20px;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.business-resource-item:last-child {
  border-bottom: none;
}

.business-resource-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.business-resource-item.active {
  position: relative;
  background-color: #2196F3;
}

.business-resource-item.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 3px;
  height: 100%;
  background-color: #fff;
}

.business-resource-icon {
  position: relative;
  width: 16px;
  height: 15px;
  margin-right: 8px;
  flex-shrink: 0;
  border: 1px solid #ffffff;
  border-top-width: 3px;
}

.business-resource-icon::before,
.business-resource-icon::after {
  content: '';
  position: absolute;
  bottom: 0;
  width: 1px;
  height: 7px;
  background: #ffffff;
}

.business-resource-icon::before {
  left: 4px;
}

.business-resource-icon::after {
  right: 4px;
}

.business-resource-icon-img {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  flex-shrink: 0;
  object-fit: contain;
}

.business-resource-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.business-resource-count {
  margin-left: 4px;
  flex-shrink: 0;
  color: #ffe13d;
  font-weight: 700;
}

.business-right-panel {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;
  width: 322px;
  height: calc(100vh - 76px);
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;
}

.business-tool-card {
  flex: 0 0 178px;
  padding: 22px 14px 12px;
  border: 1px solid rgba(90, 168, 255, 0.72);
  box-sizing: border-box;
}

.business-tool-body {
  display: flex;
  margin-top: 8px;
}

.business-drawing-status {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 182px;
  height: 112px;
  margin-right: 12px;
  padding: 10px 12px;
  border: 1px solid rgba(128, 196, 255, 0.42);
  background: rgba(6, 22, 74, 0.72);
  color: rgba(255, 255, 255, 0.82);
  box-sizing: border-box;
}

.business-drawing-status.active {
  border-color: rgba(127, 255, 255, 0.86);
  box-shadow: inset 0 0 16px rgba(65, 234, 232, 0.12), 0 0 14px rgba(65, 234, 232, 0.12);
}

.business-drawing-status div {
  margin-bottom: 12px;
  color: #8fffff;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
}

.business-drawing-status span {
  margin-top: 5px;
  font-size: 12px;
  line-height: 1.35;
}

.business-tool-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.business-tool-actions button,
.business-fence-list button {
  height: 24px;
  border: 1px solid rgba(128, 196, 255, 0.7);
  border-radius: 2px;
  background: rgba(221, 231, 249, 0.92);
  color: #20233d;
  font-size: 12px;
  cursor: pointer;
}

.business-tool-actions button {
  width: 86px;
}

.business-tool-actions button.active {
  background: #8fffff;
  color: #06294a;
}

.business-tool-actions button:disabled {
  opacity: 0.46;
  cursor: not-allowed;
}

.business-stat-card {
  flex: 1 1 auto;
  min-height: 0;
  padding: 22px 14px 12px;
  border: 1px solid rgba(90, 168, 255, 0.72);
  box-sizing: border-box;
  overflow: hidden;
}

.business-stat-table {
  width: 252px;
  margin: 12px auto 0;
}

.business-stat-head,
.business-stat-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1.2fr;
  align-items: center;
  min-height: 24px;
  text-align: center;
  font-size: 12px;
}

.business-stat-head {
  color: #77d7ff;
  background: rgba(29, 114, 157, 0.58);
  border: 1px solid rgba(116, 220, 255, 0.5);
}

.business-stat-row {
  color: #ffffff;
}

.business-load-danger {
  color: #ff513b;
}

.business-load-warning {
  color: #ffb22e;
}

.business-load-normal {
  color: #93e142;
}

.business-passenger-box {
  width: 252px;
  margin: 14px auto 0;
  padding-top: 12px;
  border-top: 2px solid rgba(122, 200, 255, 0.55);
}

.business-passenger-title {
  margin-bottom: 10px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
}

.business-passenger-meta {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  color: #ffffff;
  font-size: 12px;
}

.business-rank-row {
  position: relative;
  display: flex;
  align-items: center;
  height: 20px;
  margin-bottom: 3px;
  overflow: hidden;
}

.business-rank-row span {
  position: relative;
  z-index: 1;
  width: 18px;
  height: 16px;
  margin-right: 6px;
  border-radius: 8px;
  background: linear-gradient(180deg, #ffffff 0%, #f3c232 100%);
  color: #28436e;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
}

.business-rank-row strong {
  position: relative;
  z-index: 1;
  width: 96px;
  color: #ffffff;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

.business-rank-row i {
  display: block;
  height: 5px;
  border-radius: 3px;
  background: linear-gradient(90deg, #ffd84f 0%, #ffb11d 100%);
  box-shadow: 0 0 8px rgba(255, 190, 32, 0.58);
}

.business-suggestion {
  width: 100%;
  max-height: 82px;
  margin-top: 12px;
  padding: 7px 10px;
  border: 1px solid rgba(88, 145, 255, 0.32);
  background: rgba(5, 18, 70, 0.42);
  color: rgba(255, 255, 255, 0.88);
  box-sizing: border-box;
  overflow: hidden;
}

.business-suggestion p {
  margin: 0 0 2px;
  font-size: 11px;
  line-height: 1.35;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.business-suggestion p:last-child {
  margin-bottom: 0;
}

.business-fence-card {
  flex: 0 0 176px;
  padding: 22px 14px 12px;
  border: 1px solid rgba(90, 168, 255, 0.72);
  box-sizing: border-box;
}

.business-fence-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 16px;
  margin-top: 16px;
}

.business-fence-list button {
  position: relative;
  width: 130px;
  background: rgba(14, 30, 94, 0.78);
  color: #ffffff;
}

.business-fence-list button.active {
  background: #9ed8ff;
  color: #0d2744;
}

.business-delete-icon {
  position: absolute;
  top: 5px;
  right: 7px;
  width: 8px;
  height: 11px;
  border: 1px solid #ff352b;
  border-top: 0;
}

.business-delete-icon::before {
  content: '';
  position: absolute;
  top: -3px;
  left: -2px;
  width: 10px;
  height: 1px;
  background: #ff352b;
}

.text-box {
  width: 310px;
  min-height: 100px;
  border: 2px solid #ff4a4a;
  border-radius: 6px;
  padding: 5px;
  box-sizing: border-box;
  /* display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis; */
}

.text-item-6 {
  padding-left: 15px;
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
  width: 320px;
  box-sizing: border-box;
}

.button-6 {
  margin: 15px auto;
  background-color: #169bd5;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  width: 200px;
  border-radius: 6px;
}

/* 价格监管页面 */
.price-supervision-left,
.price-supervision-right {
  width: 360px;
}

.price-supervision-right {
  position: absolute;
  right: 0;
  top: 30px;
}

.price-panel {
  padding: 0 12px 10px;
  box-sizing: border-box;
}

.price-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 4px;
}

.price-panel-header .right-title {
  margin-bottom: 0;
}

.price-search-box {
  flex-shrink: 0;
}

.price-search-input {
  width: 100px;
  height: 22px;
  padding: 0 8px;
  border: 1px solid rgba(0, 170, 255, 0.55);
  border-radius: 2px;
  background: rgba(6, 12, 32, 0.85);
  color: #fff;
  font-size: 12px;
  outline: none;
}

.price-search-input::placeholder {
  color: rgba(168, 197, 232, 0.65);
}

.price-table-container {
  margin-top: 8px;
}

.price-table-header {
  display: flex;
  background: #1a3350;
  border: 1px solid rgba(0, 170, 255, 0.35);
  border-radius: 2px;
  padding: 7px 0;
}

.price-th {
  flex: 1;
  text-align: center;
  color: #00ccff;
  font-size: 14px;
  font-weight: 500;
}

.price-table-body {
  max-height: 120px;
  overflow-y: auto;
}

.work-order-body {
  max-height: 692px;
}

.price-table-body::-webkit-scrollbar {
  width: 4px;
}

.price-table-body::-webkit-scrollbar-track {
  background: rgba(6, 12, 32, 0.6);
}

.price-table-body::-webkit-scrollbar-thumb {
  background: rgba(0, 170, 255, 0.55);
  border-radius: 2px;
}

.price-table-row {
  display: flex;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 170, 255, 0.12);
}

.price-table-row.even {
  background: rgba(0, 170, 255, 0.05);
}

.accommodation-hotel-row {
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
}

.accommodation-hotel-row:hover {
  background: rgba(0, 170, 255, 0.12);
}

.accommodation-hotel-row.active {
  background: rgba(0, 170, 255, 0.22);
  box-shadow: inset 0 0 0 1px rgba(0, 242, 255, 0.55);
}

.accommodation-header .hotel-col,
.price-td.hotel-name {
  flex: 1.35;
  text-align: left;
  padding-left: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.accommodation-list-body {
  max-height: 127px;
}

.price-table-empty {
  padding: 12px 0;
  text-align: center;
  color: rgba(168, 197, 232, 0.75);
  font-size: 12px;
}

.price-selected-hotel-tag {
  margin-left: 8px;
  font-size: 12px;
  font-weight: 400;
  color: #00aaff;
}

.price-td {
  flex: 1;
  text-align: center;
  color: #fff;
  font-size: 11px;
  line-height: 1.4;
}

.price-td.room-type,
.price-td.hotel-name {
  color: #ffffff;
}

.premium-rate {
  font-weight: 600;
}

.premium-rate.up {
  color: #ff4d4f;
}

.premium-rate.down {
  color: #52c41a;
}

.premium-rate.flat {
  color: #ffffff;
}

.complaint-linkage-box {
  padding: 4px 2px 0;
}

.complaint-summary {
  color: #fff;
  font-size: 14px;
  margin-bottom: 8px;
}

.complaint-item {
  color: #fff;
  font-size: 12px;
  line-height: 1.8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 27px;
}

.complaint-dot {
  display: inline-block;
  width: 4px;
  height: 4px;
  margin-right: 6px;
  border-radius: 50%;
  background: #00aaff;
  vertical-align: middle;
}

.price-warning-list {
  padding: 2px 0;
  max-height: 110px;
  /* 控制展示高度，超出滚动 */
  overflow-y: auto;
}

.price-warning-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 0;
  border-bottom: 1px solid rgba(0, 170, 255, 0.1);
}

.price-warning-item:last-child {
  border-bottom: none;
}

.price-warning-text {
  flex: 1;
  color: #fff;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 8px;
}

.price-warning-link {
  flex-shrink: 0;
  color: #00aaff;
  font-size: 12px;
  cursor: pointer;
}

.price-warning-link:hover {
  color: #01f1e3;
  text-decoration: underline;
}

.price-warning-modal-overlay {
  z-index: 10000;
}

.price-warning-modal-content {
  width: 720px;
  max-width: 92vw;
  background: #0a1633;
  border: 1px solid rgba(0, 170, 255, 0.55);
  box-shadow: 0 0 24px rgba(0, 170, 255, 0.25);
}

.price-warning-modal-header {
  padding: 14px 18px;
  border-bottom: 1px solid rgba(0, 170, 255, 0.25);
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(90deg, rgba(0, 85, 170, 0.35) 0%, rgba(6, 12, 32, 0.2) 100%);
}

.price-warning-close-btn {
  color: #a8c5e8;
}

.price-warning-modal-body {
  padding: 16px 18px 20px;
  background: #060c20;
}

.price-warning-modal-subtitle {
  color: #d8e8ff;
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 8px;
}

.price-warning-modal-tip {
  color: rgba(168, 197, 232, 0.75);
  font-size: 12px;
  margin-bottom: 12px;
}

.price-warning-modal-chart {
  width: 100%;
  height: 360px;
}

.price-trend-panel {
  height: 392px;
  margin-top: 14px;
  padding-bottom: 12px;
}

.price-trend-filters {
  gap: 8px;
  margin-bottom: 8px;
  width: 100%;
}

.price-filter-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 48%;
  padding: 4px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-sizing: border-box;
  transition: border-color 0.2s, background 0.2s;
}

.price-filter-item-active {
  border-color: rgba(0, 242, 255, 0.65);
  background: rgba(0, 170, 255, 0.1);
}

.price-filter-label {
  color: rgba(168, 197, 232, 0.85);
  font-size: 11px;
}

.price-filter-select {
  width: 100%;
  height: 28px;
  padding: 0 8px;
  border: 1px solid rgba(0, 170, 255, 0.55);
  border-radius: 2px;
  background: rgba(6, 12, 32, 0.85);
  color: #ffffff;
  font-size: 12px;
  outline: none;
  cursor: pointer;
}

.price-filter-select option {
  color: #060c20;
}

.price-trend-chart-tip {
  color: rgba(168, 197, 232, 0.75);
  font-size: 11px;
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.price-fluctuation-chart {
  width: 100%;
  height: 200px;
}

.price-work-order-panel {
  height: 800px;
}

.price-map-alert-board {
  position: absolute;
  top: 66px;
  right: 400px;
  z-index: 2;
  max-width: 380px;
  width: 380px;
  /* 固定宽度更稳定 */
}

.alert-scroll-container {
  height: 35px;
  overflow: hidden;
  background: #133041;
  border-radius: 4px;
  padding: 0 12px;
}

.alert-scroll-wrapper {
  animation: scrollUp 7s linear infinite;
  white-space: normal;
}

/* 滚动动画：从 0 滚到 -100% */
@keyframes scrollUp {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-50%);
    /* 因为复制了一份，所以滚 50% 刚好循环 */
  }
}

/* 警告项样式 */
.price-map-alert-item {
  display: flex;
  align-items: center;
  height: 32px;
  color: #fff;
  font-size: 14px;
}

.price-map-alert-icon {
  margin-right: 6px;
  color: #d9001b;
}

.price-map-alert-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-type-box {
  display: flex;
  margin: 10px auto;
  width: 300px;
}
.text-type-item {
  flex-grow: 1;
  border:1px solid #00ccff;
  color: #fff;
  box-sizing: border-box;
  text-align: center;
}
.text-type-item-on {
  background-color: #00ccff;
}
.filter-select-box {
  position: relative;
  display: inline-block;
  margin-left: 10px;
  width: 140px;
}

.filter-select {
  width: 100%;
  padding: 8px 32px 8px 12px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  cursor: pointer;
  outline: none;
  appearance: none;
}

.filter-select:hover {
  border-color: rgba(76, 165, 255, 0.5);
}

.select-arrow {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.5);
  font-size: 10px;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/ScenicData.vue